import { ɵɵdefinePipe, ɵsetClassMetadata, Pipe, ɵɵdefineInjectable, Injectable, ɵɵinject, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, ɵɵgetCurrentView, ɵɵelementStart, ɵɵlistener, ɵɵrestoreView, ɵɵnextContext, ɵɵtext, ɵɵelementEnd, ɵɵtemplate, ɵɵprojection, ɵɵproperty, ɵɵpureFunction5, ɵɵadvance, ɵɵdefineComponent, ɵɵprojectionDef, Component, Input, EventEmitter, ɵɵdirectiveInject, ElementRef, ɵɵdefineDirective, ɵɵelement, ɵɵclassMapInterpolate1, ɵɵInheritDefinitionFeature, Optional, Output, ɵɵtextInterpolate1, ɵɵtextInterpolate, ɵɵclassProp, ɵɵviewQuery, ɵɵqueryRefresh, ɵɵloadQuery, ViewChild, ɵɵsanitizeUrl, ɵɵpureFunction1, Directive, HostListener, ɵɵProvidersFeature, ɵɵsanitizeHtml, ɵɵpureFunction2, ɵɵpureFunction0, ɵɵpureFunction4, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonModule, NgIf, NgClass, NgForOf } from '@angular/common';
import { ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, NgSelectOption, ɵangular_packages_forms_forms_x, DefaultValueAccessor, PatternValidator, NgControlStatus, NgModel, NumberValueAccessor, SelectControlValueAccessor, FormsModule } from '@angular/forms';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { ImageCropperComponent, ImageCropperModule } from 'ngx-image-cropper';

/**
 * DataBaseManager classe de auxilio para uso do Indexed DB
 */
class DataBaseManager {
    constructor(dbName, version, tInfos) {
        this.dbName = dbName;
        this.version = version;
        this.tInfos = tInfos;
        this.indxDb = window.indexedDB;
        this.openInitDB();
    }
    openInitDB() {
        console.log('Initialize IDB ... ');
        this.promissedb = new Promise((resolve, reject) => {
            let req;
            req = this.indxDb.open(this.dbName, this.version);
            req.onupgradeneeded = (event) => {
                for (const it in this.tInfos) {
                    if (this.tInfos.hasOwnProperty(it)) {
                        const tInfo = this.tInfos[it];
                        const parms = { keyPath: tInfo.primaryFieldName };
                        const tblLocal = event.target.result.createObjectStore(tInfo.tableName, parms);
                        tblLocal.createIndex(tInfo.primaryIndexName, tInfo.primaryFieldName);
                    }
                }
                this.useDatabase();
                resolve(event.target.result);
            };
            req.onsuccess = (event) => {
                console.log('Initialize IDB = OK');
                this.useDatabase();
                resolve(event.target.result);
            };
            req.onerror = (event) => {
                reject(event);
            };
        });
    }
    /**
     * Esteja certo de que adicionou um evento para notificar se a página muda a versão
     * Nós devemos fechar o banco. Isso permite à outra página ser atualizada
     * Se você não fizer isso a atualização não acontecerá até fechar as abas.
     */
    useDatabase() {
        this.promissedb.then((idb) => {
            idb.onversionchange = (event) => {
                /* this.db.close(); */
                alert('Uma nova versão desta web app está pronta. Atualiza, por favor!');
            };
        });
    }
    startTransaction(tableName, write) {
        return this.promissedb.then((idb) => {
            return idb.transaction([tableName], (write ? 'readwrite' : 'readonly'));
        });
    }
}
class TableManager {
    constructor(dbMgr, tableInfo) {
        this.dbMgr = dbMgr;
        this.tableInfo = tableInfo;
    }
    add(vo) {
        this.dbMgr.startTransaction(this.tableInfo.tableName, true)
            .then((trans) => {
            const tbl = trans.objectStore(this.tableInfo.tableName);
            tbl.add(vo).onerror = (e) => {
                console.error('IDB Error: ', e.target.result);
                throw e;
            };
        });
    }
    del(pk) {
        this.dbMgr.startTransaction(this.tableInfo.tableName, true)
            .then((trans) => {
            const tbl = trans.objectStore(this.tableInfo.tableName);
            tbl.delete(pk).onerror = (e) => {
                console.error('IDB Error: ', e.target.result);
                throw e;
            };
        });
    }
    edit(vo) {
        this.dbMgr.startTransaction(this.tableInfo.tableName, true)
            .then((trans) => {
            const tbl = trans.objectStore(this.tableInfo.tableName);
            tbl.put(vo).onerror = (e) => {
                console.error('IDB Error: ', e.target.result);
                throw e;
            };
        });
    }
    exists(pk) {
        return this.dbMgr.startTransaction(this.tableInfo.tableName)
            .then((trans) => {
            const tbl = trans.objectStore(this.tableInfo.tableName);
            const req = tbl.index(this.tableInfo.primaryIndexName).get(pk);
            req.onsuccess = (e) => {
                return e.target.result != null;
            };
            req.onerror = (e) => {
                console.error('IDB Error: ', e.target.result);
                throw e;
            };
            return false;
        });
    }
    getData(pk) {
        return new Promise((resolve, reject) => {
            this.dbMgr.startTransaction(this.tableInfo.tableName)
                .then((trans) => {
                const tbl = trans.objectStore(this.tableInfo.tableName);
                const req = tbl.index(this.tableInfo.primaryIndexName).get(pk);
                req.onsuccess = (e) => {
                    resolve(e.target.result);
                };
                req.onerror = (e) => {
                    reject(e.target.result);
                };
            });
        });
    }
    getList(maxRows) {
        return new Promise((resolve, reject) => {
            const result = [];
            let currRow = 0;
            this.dbMgr.startTransaction(this.tableInfo.tableName)
                .then((trans) => {
                const tbl = trans.objectStore(this.tableInfo.tableName);
                const req = tbl.openCursor();
                req.onsuccess = (e) => {
                    const cursor = e.target.result;
                    if (cursor) {
                        result.push(cursor.value);
                        currRow++;
                        if (currRow < (maxRows ? maxRows : 1000)) {
                            cursor.continue();
                        }
                    }
                };
                trans.oncomplete = () => {
                    resolve(result);
                };
                req.onerror = (e) => {
                    reject(e.target.result);
                };
            });
        });
    }
    /**
     * Salva lista de objetos persistindo no dataBase
     * @param list Lista a ser atualizada no idb local
     * @returns Promise
     */
    atualizeCache(list) {
        console.log('atualizacache');
        return new Promise((resolve, reject) => {
            if (list) {
                this.dbMgr.startTransaction(this.tableInfo.tableName, true)
                    .then((trans) => {
                    const tbl = trans.objectStore(this.tableInfo.tableName);
                    const req = tbl.clear();
                    req.onsuccess = (e) => {
                        list.forEach((i) => {
                            this.add(i);
                        });
                        console.log('resolve cache');
                        resolve();
                    };
                    req.onerror = (e) => {
                        reject(e);
                    };
                });
            }
        });
    }
}
/**
 * Classe com informações da table do IDB
 * O IDB não dá suporte aos meta dados das tables
 */
class TableInfo {
    constructor(tableName, primaryFieldName) {
        this.tableName = tableName;
        this.primaryFieldName = primaryFieldName;
        this.primaryIndexName = 'pk' + tableName;
    }
}

// tslint:disable: variable-name
// tslint:disable: unified-signatures
// tslint:disable: member-ordering
/**
 * Classe para modificação do Array
 */
class ArrayList {
    constructor(className, ...initialItems) {
        this._className = className;
        const arrayList = Object.create(Array.prototype);
        ArrayList.init(className, arrayList, initialItems, ArrayList.prototype);
        return arrayList;
    }
    get className() {
        return this._className;
    }
    static init(className, arrayList, initialItems, prototype) {
        Object.getOwnPropertyNames(prototype)
            .forEach((prop) => {
            if (prop === 'constructor') {
                return;
            }
            Object.defineProperty(arrayList, prop, { value: prototype[prop], configurable: true });
        });
        Object.defineProperty(arrayList, 'length', {
            value: arrayList.length,
            writable: true,
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(arrayList, 'className', {
            value: className,
            writable: true,
            enumerable: false,
            configurable: true
        });
        let itemsToPush = initialItems;
        if (Array.isArray(initialItems[0]) && initialItems.length === 1) {
            itemsToPush = initialItems[0];
        }
        Array.prototype.push.apply(arrayList, itemsToPush);
        return arrayList;
    }
    toJSON() {
        return Array.prototype.slice.apply(this);
    }
    get(index) {
        return this[index];
    }
    add(value) {
        if (value instanceof Array) {
            Array.prototype.push.apply(this, value);
        }
        else {
            Array.prototype.push.call(this, value);
        }
        return this;
    }
    remove(x) {
        return !!this._remove(x);
    }
    _remove(x) {
        const arr = this;
        let index = -1;
        if (typeof x === 'function') {
            for (let i = 0, len = arr.length; i < len; i++) {
                if (x(this[i])) {
                    index = i;
                    break;
                }
            }
        }
        else {
            index = arr.indexOf(x);
        }
        if (index === -1) {
            return undefined;
        }
        else {
            const res = arr.splice(index, 1);
            return res.length ? res[0] : undefined;
        }
    }
    clear() {
        this.length = 0;
    }
    size() {
        return this.length;
    }
    isEmpty() {
        return this.length === 0;
    }
    map(...args) {
        let result = [];
        if (args && args.length > 0) {
            for (const x of args) {
                if (typeof x === 'function') {
                    result = [].map.call(this, x);
                    break;
                }
            }
        }
        return result;
    }
    filter(callbackfn, thisArg) {
        return new ArrayList(this.className, [].filter.call(this, callbackfn));
    }
    reduce(callbackfn, initialValue) {
        return new ArrayList(this.className, [].reduce.call(this, callbackfn));
    }
    reduceRight(callbackfn, initialValue) {
        return new ArrayList(this.className, [].reduceRight.call(this, callbackfn));
    }
    slice(start, end) {
        return new ArrayList(this.className, [].slice.call(this, start, end));
    }
    splice(start, deleteCount, ...items) {
        return new ArrayList(this.className, [].splice.call(this, start, deleteCount, ...items));
    }
}

class ListEmpresas {
    constructor() {
        this.jclass = 'com.sollus.vo.ListEmpresas';
        this.empresas = new ArrayList('number');
    }
    equals(arg) {
        return arg && this.empresas.toString() === arg.empresas.toString();
    }
    toString() {
        return this.empresas.join(',');
    }
    indexOf(empresa) {
        return this.empresas.indexOf(empresa);
    }
    exists(empresa) {
        return this.indexOf(empresa) >= 0;
    }
    /**
     * Adiciona nova empresa
     * @param codEmpresa Codigo da empresa
     */
    add(codEmpresa) {
        this.empresas.add(codEmpresa);
    }
    clear() {
        this.empresas.clear();
    }
    /**
     * @return retorna quantas empresas foram selecionadas
     */
    size() {
        return this.empresas.size();
    }
    /**
     * Retorna TRUE se não tiver nenhuma empresa normalmente significa TODAS
     * @return boolean
     */
    isEmpty() {
        return this.empresas == null || this.empresas.isEmpty();
    }
}

class EStatusControl {
    constructor(value) {
        this.value = '';
        this.value = value;
    }
    get NONE() {
        return EStatusControl.NONE;
    }
    get LOADING() {
        return EStatusControl.LOADING;
    }
    get SUCCESS() {
        return EStatusControl.SUCCESS;
    }
    get ERROR() {
        return EStatusControl.ERROR;
    }
}
EStatusControl.NONE = '';
EStatusControl.LOADING = 'L';
EStatusControl.SUCCESS = 'S';
EStatusControl.ERROR = 'E';

/* tslint:disable:unified-signatures */
/**
 * Classe utilitaria para alteração, conversao, ...
 */
class Parser {
    // apenas para evitar a chamada DateUtil.getDefaultDate()   -> linguagem fraca gera referencia circular ------ notasse que TypeScript é feito pelo mesmo cara que escrevia o Delphi
    static getDefaultDate() {
        return new Date(1900, 0, 1, 0, 0, 0, 0);
    }
    /**
     * Retorna string com tamanho relativo formatado humano em GB, MB, KB ...
     * @param bytes Valor em bytes para conversão
     * @returns Retorna string com valor em byte, KB, MB, GB ou TB
     */
    static bytesToSize(bytes) {
        let result = '';
        if (bytes === null || isNaN(bytes) || bytes === 0) {
            return '0 byte';
        }
        if (bytes >= 1000000000000) {
            result = ((((bytes / 1000) / 1000) / 1000) / 1000).toFixed(1) + ' TB';
        }
        else if (bytes >= 1000000000) {
            result = (((bytes / 1000) / 1000) / 1000).toFixed(1) + ' GB';
        }
        else if (bytes >= 1000000) {
            result = ((bytes / 1000) / 1000).toFixed(1) + ' MB';
        }
        else if (bytes >= 1000) {
            result = (bytes / 1000).toFixed(1) + ' KB';
        }
        else if (bytes > 1) {
            result = bytes + ' bytes';
        }
        else if (bytes === 1) {
            result = bytes + ' byte';
        }
        return result.replace('.0', '').replace('.', ',');
    }
    static lfill(str, newLen, fillChar, trunc) {
        let result = str ? str : '';
        if (!fillChar) {
            fillChar = '0';
        }
        if (!str || str.length <= newLen) {
            while (result.length < newLen) {
                result = fillChar + result;
            }
        }
        else {
            if (trunc) {
                return result.substring(0, newLen);
            }
        }
        return result;
    }
    /**
     * Insere char/zeros a direita
     * @param str String para modificar
     * @param newLen Tamanho da nova string com zeros a direita
     * @param fillChar Caracter que sera usado para porencher o tamanho
     * @param trunc Se a string original for maior que NnewLen ela trunca
     * @returnsString com zeros a direita
     */
    static rfill(str, newLen, fillChar, trunc) {
        let result = str ? str : '';
        if (!fillChar) {
            fillChar = '0';
        }
        if (!str || str.length <= newLen) {
            while (result.length < newLen) {
                result = result + fillChar;
            }
        }
        else {
            if (trunc) {
                return result.substring(0, newLen);
            }
        }
        return result;
    }
    /**
     * Converte Date para string formatada 'dd/mm/aaaa'
     * @param data Objeto de data
     * @returns String data formatada
     */
    static dateToStr(data) {
        if (!data) {
            return '';
        }
        if (typeof data === 'string') {
            return data;
        }
        return Parser.lfill(data.getDate() + '', 2) + '/' + Parser.lfill((data.getMonth() + 1) + '', 2) + '/' + data.getFullYear();
    }
    /**
     * Converte Date para string formatada 'hh:mm:ss'
     * @param hora Objeto de data
     * @returns String hora formatada
     */
    static timeToStr(hora) {
        if (!hora) {
            return '';
        }
        if (typeof hora === 'string') {
            return hora;
        }
        return Parser.lfill(hora.getHours() + '', 2) + ':' + Parser.lfill(hora.getMinutes() + '', 2) + ':' + Parser.lfill(hora.getSeconds() + '', 2);
    }
    /**
     * Converte DateTime para string formatada 'dd/MM/aaaa hh:mm:ss'
     * @param data Objeto de data
     * @returns String data hora formatada
     */
    static dateTimeToStr(data) {
        if (!data) {
            return '';
        }
        if (typeof data === 'string') {
            return data;
        }
        return this.dateToStr(data) + ' ' + this.timeToStr(data);
    }
    /**
     * Remove todos os caracteres excetos 0-9
     * @param arg String com (.) (,) (/) (-)
     * @returns String somente com digitos de 0 a 9
     */
    static trimToDigits(arg) {
        let result = '';
        if (arg) {
            result = (arg + '').replace(/\D/g, '');
        }
        return result;
    }
    /**
     * Remove todos os caracteres excetos (0-9) (.) (-)
     * @param arg String com os numeros
     * @returns String com digitos
     */
    static trimToNumber(arg) {
        let result = '';
        if (arg) {
            result = (arg + '').replace(/(?!-)[^0-9.]/g, '');
        }
        return result;
    }
    /**
     * Converte o valor String para um Int
     * @param arg0 String para converter
     * @returns Valor em number (1, 2, 3, 4, ...)
     */
    static strToInt(arg0) {
        let result = 0;
        if (arg0 && this.trimToNumber(arg0) !== '') {
            result = parseInt(this.trimToNumber(arg0), 10);
        }
        return (!isNaN(result) ? result : 0);
    }
    /**
     * Converte o valor String para um Float
     * @param arg0 String para converter
     * @returns Valor em number (1.0, 1.2, 2.3, ...)
     */
    static strToFloat(arg0) {
        let result = 0;
        if (arg0 && this.trimToNumber(arg0) !== '') {
            result = parseFloat(this.trimToNumber(arg0));
        }
        return (!isNaN(result) ? result : 0.0);
    }
    /**
     * Converte string para Date
     * @param strData String formatada 'dd/mm/aaaa'
     * @returnsDate com hora zerada
     */
    static strToDate(strData) {
        if (strData) {
            if (strData instanceof Date) {
                return strData;
            }
            if (typeof strData === 'string' && strData.indexOf('/') > -1) {
                const partes = strData.split('/');
                if (partes.length === 3) {
                    return new Date(Parser.strToInt(partes[2]), (Parser.strToInt(partes[1]) - 1), Parser.strToInt(partes[0]));
                }
            }
        }
        return this.getDefaultDate();
    }
    /**
     * Converte string para Date (data e hora)
     * @param strData (dd/MM/aaaa HH:mm:ss) ou (dd/MM/aaaa HH:mm)
     * @returns Data e hora
     */
    static strToDateTime(strData) {
        if (strData) {
            if (strData instanceof Date) {
                return strData;
            }
            if (typeof strData === 'string' && strData.indexOf('/') > -1 && strData.indexOf(' ') > -1 && strData.indexOf(':') > -1) {
                const partes = strData.split(' ');
                if (partes.length === 2) {
                    const partesData = partes[0].split('/');
                    const partesHora = partes[1].split(':');
                    if (partesData.length === 3 && partesHora.length === 3) {
                        return new Date(Parser.strToInt(partesData[2]), (Parser.strToInt(partesData[1]) - 1), Parser.strToInt(partesData[0]), Parser.strToInt(partesHora[0]), Parser.strToInt(partesHora[1]), Parser.strToInt(partesHora[2]), 0);
                    }
                    else if (partesData.length === 3 && partesHora.length === 2) {
                        return new Date(Parser.strToInt(partesData[2]), (Parser.strToInt(partesData[1]) - 1), Parser.strToInt(partesData[0]), Parser.strToInt(partesHora[0]), Parser.strToInt(partesHora[1]), 0, 0);
                    }
                }
            }
        }
        return this.getDefaultDate();
    }
    /**
     * Formata o CPF
     * @param value Com os digitos do CPF
     * @returns String com CPF formatado
     */
    static formataCPF(value) {
        if (value == null || value.length === 0) {
            return '';
        }
        const digitsValue = Parser.trimToDigits(value);
        let newValue = '';
        if (digitsValue.length > 9) {
            newValue = digitsValue.substring(0, 3) + '.' + digitsValue.substring(3, 6) + '.' + digitsValue.substring(6, 9) + '-' + digitsValue.substring(9, 11);
        }
        else if (digitsValue.length > 6 && digitsValue.length <= 9) {
            newValue = digitsValue.substring(0, 3) + '.' + digitsValue.substring(3, 6) + '.' + digitsValue.substring(6);
        }
        else if (digitsValue.length > 3 && digitsValue.length <= 6) {
            newValue = digitsValue.substring(0, 3) + '.' + digitsValue.substring(3);
        }
        else if (digitsValue.length > 0 && digitsValue.length <= 3) {
            newValue = digitsValue;
        }
        return newValue;
    }
    /**
     * Formata o numeros da data com as barras
     * @param value Somente os numeros da data em string
     * @returns String com data formatada
     */
    static formataData(value) {
        if (value == null || value.length === 0) {
            return '';
        }
        const digitsValue = Parser.trimToDigits(value);
        let newValue = '';
        if (digitsValue.length > 4) {
            newValue = digitsValue.substring(0, 2) + '/' + digitsValue.substring(2, 4) + '/' + digitsValue.substring(4, 8);
        }
        else if (digitsValue.length > 2 && digitsValue.length <= 4) {
            newValue = digitsValue.substring(0, 2) + '/' + digitsValue.substring(2);
        }
        else if (digitsValue.length > 0 && digitsValue.length <= 2) {
            newValue = digitsValue;
        }
        return newValue;
    }
    /**
     * Formata o CNPJ EX 12.123.123/0001-12
     * @param value String com o CNPJ
     * @returns String formatada
     */
    static formataCNPJ(value) {
        if (value == null || value.length === 0) {
            return '';
        }
        let newValue = Parser.trimToDigits(value);
        if (newValue.length === 14) {
            newValue = newValue.substring(0, 2)
                + '.'
                + newValue.substring(2, 5)
                + '.'
                + newValue.substring(5, 8)
                + '/'
                + newValue.substring(8, 12)
                + '-'
                + newValue.substring(12);
        }
        return newValue;
    }
    /**
     * Formata o telefone
     *
     * Telefone com 8 digitos
     * (051) 3030-2020, (51) 2020-1010, 3010-2020
     *
     * Telefone com 9 digitos
     * (051) 93030-2020, (51) 92020-1010, 93010-2020
     *
     * @param value String para ser formatada
     * @returns String formatada
     */
    static formataFone(value) {
        if (value == null || value.length === 0) {
            return '';
        }
        const newValue = Parser.trimToDigits(value);
        if (newValue.length === 7) {
            return newValue.substring(0, 3) + '-' + newValue.substring(3);
        }
        if (newValue.length === 8) {
            return newValue.substring(0, 4) + '-' + newValue.substring(4);
        }
        if (newValue.length === 9) {
            return newValue.substring(0, 5) + '-' + newValue.substring(5);
        }
        if (newValue.length === 10) {
            return '('
                + newValue.substring(0, 2)
                + ') '
                + newValue.substring(2, 6)
                + '-'
                + newValue.substring(6);
        }
        if (newValue.length === 11) {
            if (newValue.startsWith('0')) {
                return '('
                    + newValue.substring(0, 3)
                    + ') '
                    + newValue.substring(3, 7)
                    + '-'
                    + newValue.substring(7);
            }
            else {
                return '('
                    + newValue.substring(0, 2)
                    + ') '
                    + newValue.substring(2, 7)
                    + '-'
                    + newValue.substring(7);
            }
        }
        if (newValue.length === 12) {
            if (newValue.startsWith('0')) {
                return '('
                    + newValue.substring(0, 3)
                    + ') '
                    + newValue.substring(3, 8)
                    + '-'
                    + newValue.substring(8);
            }
            else {
                return '('
                    + newValue.substring(0, 2)
                    + ') '
                    + newValue.substring(2, 8)
                    + '-'
                    + newValue.substring(8);
            }
        }
        return newValue;
    }
    /**
     * Formata o CEP ex 93300-000
     * @param value String para ser formatada
     * @returns String formatada
     */
    static formataCEP(value) {
        if (value == null || value.length === 0) {
            return '00000-000';
        }
        let newValue = Parser.lfill(Parser.trimToDigits(value), 8, '0', true);
        if (newValue.length === 8) {
            newValue = newValue.substring(0, 5) + '-' + newValue.substring(5);
        }
        return newValue;
    }
    /**
     * Formata código da etiqueta com pontos
     * Ex: 0010123451232009 => 001.012345.123.200.9
     * @param codEtiq String para ser formatada
     * @returns String formatada com pontos
     */
    static formateNumberEtiq(codEtiq) {
        if (codEtiq == null || codEtiq.length === 0) {
            return '';
        }
        const newCodEtiq = Parser.trimToDigits(codEtiq);
        if (newCodEtiq.length === 16) {
            return newCodEtiq.substring(0, 3) /* cod empresa */
                + '.'
                + newCodEtiq.substring(3, 9) /* cod item */
                + '.'
                + newCodEtiq.substring(9, 12) /* cod tamanho */
                + '.'
                + newCodEtiq.substring(12, 15) /* cod data */
                + '.'
                + newCodEtiq.substring(15); /* digito verificador */
        }
        return newCodEtiq;
    }
    /**
     * Converte Json para Classe
     * @param json Json (string ou objeto) para ser convertido
     * @param classReference Classe pai do objeto
     * @returns Objeto em instanciado com a classe
     */
    static jsonToClass(json, classReference) {
        if (json && classReference) {
            let jsonParse = json;
            // caso seja uma string, converte em uma objeto
            if (typeof json === 'string') {
                jsonParse = JSON.parse(json);
            }
            if (jsonParse && (jsonParse instanceof Array)) {
                return this.deserializeArrayObject(jsonParse, classReference);
            }
            if (jsonParse && (jsonParse instanceof Object) && !(jsonParse instanceof Array)) {
                return this.deserializeObject(jsonParse, classReference);
            }
        }
        else {
            throw new Error('JsonToClass: json ou classe não foram informados');
        }
    }
    /* Método auxiliar de JsonToClass */
    static deserializeObject(jsonObject, classReference) {
        let instance;
        if (jsonObject != null) {
            instance = new classReference();
            for (const propertyKey of Object.keys(instance)) {
                const type = typeof instance[propertyKey];
                if (type === 'string') {
                    instance[propertyKey] = (typeof jsonObject[propertyKey] === 'string') ? jsonObject[propertyKey] : '';
                }
                else if (type === 'number') {
                    instance[propertyKey] = (typeof jsonObject[propertyKey] === 'number') ? jsonObject[propertyKey] : 0;
                }
                else if (type === 'boolean') {
                    instance[propertyKey] = (typeof jsonObject[propertyKey] === 'boolean') ? jsonObject[propertyKey] : false;
                }
                else if (type === 'object' && !(instance[propertyKey] instanceof Array)) {
                    instance[propertyKey] = this.deserializeObject(jsonObject[propertyKey], instance[propertyKey].constructor);
                }
                else if (type === 'object' && (instance[propertyKey] instanceof Array) && instance[propertyKey].className) {
                    instance[propertyKey] = this.deserializeArrayObject(jsonObject[propertyKey], instance[propertyKey].className);
                }
                else if (type === 'object' && (instance[propertyKey] instanceof Array)) {
                    instance[propertyKey] = jsonObject[propertyKey];
                }
            }
        }
        return instance;
    }
    /** Método auxiliar de JsonToClass */
    static deserializeArrayObject(jsonArray, classReference) {
        const array = [];
        if (jsonArray != null) {
            for (const jsonObject of jsonArray) {
                array.push(this.deserializeObject(jsonObject, classReference));
            }
        }
        return new ArrayList(classReference, ...array);
    }
    static numberToString(valor, casas = 2) {
        let resultado = '0,00';
        if (casas != null && !isNaN(casas)) {
            resultado = '0' + (casas > 0 ? ',' : '') + Parser.lfill('', casas);
            if (valor != null && !isNaN(valor)) {
                const partes = valor.toString().split('.');
                partes[0] = partes[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.');
                if (casas === 0) {
                    resultado = partes[0];
                }
                else if (casas > 0) {
                    partes[1] = Parser.rfill(partes[1], casas, '0', true);
                    resultado = partes.join(',');
                }
            }
        }
        return resultado;
    }
    static numberRound(valor, decimal = 2) {
        if (valor == null || isNaN(valor)) {
            return 0;
        }
        if (decimal > 0) {
            const result = (valor * Math.pow(10, decimal));
            return Math.round(result) / Math.pow(10, decimal);
        }
        else {
            return Math.round(valor);
        }
    }
    static formatarMoeda(valor, codigo = 'BRL') {
        const result = Parser.numberToString(valor, 2);
        return 'R$ ' + result;
    }
    /**
     * Formata number em string como moeda sem fração (Ex: 489, 123 mil, 22 Mi, 8 Bi)
     * @param valor Número para converter
     * @returns String valor em moeda formatada sem o R$
     */
    static abreviaValorMoeda(valor) {
        if (valor == null || isNaN(valor)) {
            return '0';
        }
        const negativo = valor < 0;
        let resultado = '';
        if (negativo) {
            valor = valor * -1;
        }
        if (valor < 1000) {
            resultado = Parser.numberToString(valor, 0) + '';
        }
        else if (valor < (1000 * 1000)) { /* menor que 1,000,000 */
            resultado = Parser.numberToString(Math.round(valor / 1000), 0) + ' mil';
        }
        else if (valor < (1000 * 1000 * 1000)) { /* menor que 1,000,000,000 */
            resultado = Parser.numberToString(Math.round(valor / (1000 * 1000)), 0) + ' Mi';
        }
        else if (valor < (1000 * 1000 * 1000 * 1000)) { /* menor que 1,000,000,000,000 */
            resultado = Parser.numberToString(Math.round(valor / (1000 * 1000 * 1000)), 0) + ' Bi';
        }
        return negativo ? ('-' + resultado) : resultado;
    }
    static removerAcentos(s) {
        if (s == null) {
            return '';
        }
        const map = {
            'â': 'a', 'Â': 'A', 'à': 'a', 'À': 'A', 'á': 'a', 'Á': 'A', 'ã': 'a', 'Ã': 'A',
            'ê': 'e', 'Ê': 'E', 'è': 'e', 'È': 'E', 'é': 'e', 'É': 'E',
            'î': 'i', 'Î': 'I', 'ì': 'i', 'Ì': 'I', 'í': 'i', 'Í': 'I',
            'õ': 'o', 'Õ': 'O', 'ô': 'o', 'Ô': 'O', 'ò': 'o', 'Ò': 'O', 'ó': 'o', 'Ó': 'O',
            'ü': 'u', 'Ü': 'U', 'û': 'u', 'Û': 'U', 'ú': 'u', 'Ú': 'U', 'ù': 'u', 'Ù': 'U',
            'ç': 'c', 'Ç': 'C'
        };
        return s.replace(/[\W\[\] ]/g, (a) => map[a] || a);
    }
    static floatToStrF(valor, mask = '0.', milhar = false) {
        let minFraction = 0;
        let maxFraction = 0;
        if (mask && mask.length > 0 && mask.indexOf('.') > -1) {
            const a = mask.split('.');
            if (a.length > 1 && a[1].length > 0) {
                const minF = a[1].split('0');
                const maxF = a[1].split('#');
                minFraction = minF.length - 1;
                maxFraction = minFraction + (maxF.length - 1);
            }
        }
        const formatter = new Intl.NumberFormat('pt-BR', {
            style: 'decimal',
            minimumFractionDigits: minFraction,
            maximumFractionDigits: maxFraction,
            useGrouping: milhar
        });
        return formatter.format(valor);
    }
}

/* tslint:disable:unified-signatures */
/**
 * Classe utilitaria para trabalhar com datas
 */
class DateUtil {
    /**
     * Retorna a data atual com hora zerada
     * @returnsData com hora zerada
     */
    static getDate() {
        return DateUtil.getDateOnly(new Date());
    }
    /**
     * Retorna data com hora zerada. Caso data seja invalida, retorna defaultDate
     * @param date Data com ou sem hora
     * @returns Retorna somente aaaa-MM-dd
     */
    static getDateOnly(date) {
        const dataOnly = DateUtil.getDefaultDate(date);
        return new Date(DateUtil.extractYear(dataOnly), DateUtil.extractMonth(dataOnly) - 1, DateUtil.extractDay(dataOnly), 0, 0, 0, 0);
    }
    /**
     * Converte string para Date
     * @param strData String formatada 'dd/mm/aaaa'
     * @returnsDate com hora zerada
     */
    static strToDate(strData) {
        return Parser.strToDate(strData);
    }
    /**
     * Converte string para Date (data e hora)
     * @param strData (dd/MM/aaaa HH:mm:ss) ou (dd/MM/aaaa HH:mm)
     * @returns Data e hora
     */
    static strToDateTime(strData) {
        return Parser.strToDateTime(strData);
    }
    /**
     * Retorna se duas datas sao iguais
     * @param data1 Primeira data
     * @param data2 Segunda data
     * @returnsTRUE se forem iguais
     */
    static isEquals(data1, data2) {
        if (!data1 || !data2) {
            return (!data1 && !data2);
        }
        const aux = data1.getTime() - data2.getTime();
        return (Math.trunc((aux / 1000 / 60 / 60 / 24) + 0.05) === 0);
    }
    /**
     * Rertorna se a data é valida
     * @param data data em string com oum sem barras
     */
    static isValid(data) {
        if (data == null && data.length === 0) {
            return false;
        }
        const digitos = Parser.trimToDigits(data);
        if (digitos.length !== 8) {
            return false;
        }
        const dia = Parser.strToInt(digitos.substring(0, 2));
        const mes = Parser.strToInt(digitos.substring(2, 4));
        const ano = Parser.strToInt(digitos.substring(4));
        const date = new Date(ano, (mes - 1), dia);
        return date != null && date.getFullYear() === ano && (date.getMonth() + 1) === mes && date.getDate() === dia;
    }
    /**
     * Retorna se é uma data nula ou igual a defaultDate (01/01/1900)
     * @param data Data a ser verificada
     * @returnsTRUE se for nula ou default
     */
    static isDefaultDate(data) {
        if (!data) {
            return true;
        }
        if (typeof data === 'string') {
            data = this.strToDateTime(data);
        }
        return DateUtil.isEquals(data, DateUtil.getDefaultDate());
    }
    /**
     * Retorna um numero de minutos entre as datas
     * @param date1 Primeira data
     * @param date2 Segunda data
     * @returns Numero de minutos
     */
    static numMinutesByInterval(date1, date2) {
        if (!date1 || !date2) {
            return 0;
        }
        return Math.trunc((date2.getTime() - date1.getTime()) / (60 * 1000));
    }
    /**
     * Retorna um numero de horas entre as datas
     * @param date1 Primeira data
     * @param date2 Segunda data
     * @returns Numero de horas
     */
    static numHoursByInterval(date1, date2) {
        if (!date1 || !date2) {
            return 0;
        }
        return Math.trunc((date2.getTime() - date1.getTime()) / (60 * 60 * 1000));
    }
    /**
     * Retorna um numero de dias entre as datas
     * @param date1 Primeira data
     * @param date2 Segunda data
     * @returns Numero de dias
     */
    static numDaysByInterval(date1, date2) {
        if (!date1 || !date2) {
            return 0;
        }
        return Math.trunc((DateUtil.getDateOnly(date2).getTime() - DateUtil.getDateOnly(date1).getTime()) / (24 * 60 * 60 * 1000));
    }
    static getDefaultDate(data) {
        if (data) {
            return data;
        }
        else {
            return new Date(1900, 0, 1, 0, 0, 0, 0);
        }
    }
    /**
     * Retorna o dia da semana:
     *   0 = domingo
     *   1 = segunda
     *   2 = terça
     *   3 = quarta
     *   4 = quinta
     *   5 = sexta
     *   6 = sábado
     * @param data Buscar o dia da semana
     * @returnsRetorna 0-6
     */
    static getDayOfWeek(data) {
        if (data) {
            return data.getDay();
        }
        return 0;
    }
    static getDayOfWeekStr(data, removeFeira = false, length = 0) {
        let semana = this.dayOfWeek[this.getDayOfWeek(data)];
        if (removeFeira) {
            semana = semana.toLowerCase().replace('-feira', '');
        }
        if (length === 0) {
            return semana;
        }
        return semana.length >= length ? semana.substring(0, length) : semana;
    }
    /**
     * Retorna a semana do ano (ISO-8601)
     * @param data Buscar a semana do ano
     * @returns Retorna com a semana do ano
     */
    static getWeekOfYear(data) {
        if (!data) {
            return 0;
        }
        if (typeof data === 'string') {
            data = this.strToDateTime(data);
        }
        const aux = new Date(data.getFullYear(), data.getMonth(), data.getDate(), 0, 0, 0, 0);
        aux.setDate(aux.getDate() + (aux.getDay() === 0 ? -3 : 4 - aux.getDay()));
        return Math.round(((aux.getTime() - new Date(aux.getFullYear(), 0, 4).getTime()) / 86400000) / 7) + 1;
    }
    /**
     * Extrai o dia da data
     * @param data Data para extrair
     * @returnsRetorna com o dia do mes
     */
    static extractDay(data) {
        if (!data) {
            return 1;
        }
        if (typeof data === 'string') {
            data = this.strToDateTime(data);
        }
        return data.getDate();
    }
    /**
     * Extrai o mês da data
     *   1 = janeiro, 2 = fevereiro, ..., 12 = dezembro
     * @param data Data para extrair
     * @returnsRetorna numero do mes onde 1 = janeiro
     */
    static extractMonth(data) {
        if (!data) {
            return 1;
        }
        if (typeof data === 'string') {
            data = this.strToDateTime(data);
        }
        return data.getMonth() + 1;
    }
    static extractMonthStr(data, length = 0) {
        const mes = this.months[this.extractMonth(data) - 1];
        if (length === 0) {
            return mes;
        }
        return mes.length >= length ? mes.substring(0, length) : mes;
    }
    /**
     * Extrai o ano da data
     * @param data Data para extrair
     * @returnsRetorna com o ano
     */
    static extractYear(data) {
        if (!data) {
            return 1900;
        }
        if (typeof data === 'string') {
            data = this.strToDateTime(data);
        }
        return data.getFullYear();
    }
    /**
     * Retorna a data relativa a minutos, horas, ontem, dias da semana
     * ou a data no formato padrão dd MMMM aaaa
     * @param dataAtual Data com hora
     * @param dataComparar Data com hora
     * @returnsTexto com a data relativa
     */
    static getDataRelativa(dataAtual, dataComparar) {
        let result = '';
        if (typeof dataAtual === 'string') {
            dataAtual = this.strToDateTime(dataAtual);
        }
        if (typeof dataComparar === 'string') {
            dataComparar = this.strToDateTime(dataComparar);
        }
        const dtA = DateUtil.getDefaultDate(dataAtual);
        const dtC = DateUtil.getDefaultDate(dataComparar);
        const numMinutos = DateUtil.numMinutesByInterval(dtC, dtA);
        const numHoras = DateUtil.numHoursByInterval(dtC, dtA);
        const numDias = DateUtil.numDaysByInterval(dtC, dtA);
        if (numMinutos === 0 || numMinutos === 1) {
            result = 'agora';
        }
        else if (numMinutos > 1 && numMinutos < 60) {
            result = 'há ' + numMinutos + ' minutos atrás';
        }
        else if (numHoras === 1) {
            result = 'há 1 hora atrás';
        }
        else if (numHoras > 1 && numHoras < 24 && numDias === 0) {
            result = 'há ' + numHoras + ' horas atrás';
        }
        else if (numDias === 1) {
            result = 'ontem as ' + dtC.getHours() + ' horas';
        }
        else if (numDias < 0) {
            result = 'amanhã as ' + dtC.getHours() + ' horas';
        }
        else if (numDias > 0 && numDias < 7) {
            result = DateUtil.dayOfWeek[DateUtil.getDayOfWeek(dtC)] + ' as ' + dtC.getHours() + ' horas';
        }
        else if (numDias === 7) {
            result = 'há 1 semana atrás as ' + dtC.getHours() + ' horas';
        }
        else if (numDias > 7 && (dtA.getFullYear() === dtC.getFullYear())) {
            result = 'em ' + dtC.getDate() + ' ' + DateUtil.months[dtC.getMonth()] + ' as ' + dtC.getHours() + ' horas';
        }
        else {
            result = 'em ' + dtC.getDate() + ' ' + DateUtil.months[dtC.getMonth()] + ' ' + dtC.getFullYear() + ' as ' + dtC.getHours() + ' horas';
        }
        return result;
    }
    /**
     * Retorna a dias para o aniversário
     * @param dataAniv Data de nascimento
     * @returnsNumero de dias até o aniversário
     */
    static diasParaAniversario(dataAniv) {
        const diaAniv = this.extractDay(dataAniv);
        const mesAniv = this.extractMonth(dataAniv);
        const dataAnivCalc = new Date(this.extractYear(new Date()), (mesAniv - 1), diaAniv, 0, 0, 0);
        return this.numDaysByInterval(new Date(), dataAnivCalc);
    }
    /**
     * Valida a data de nascimento
     * @param data Data de nascimento
     * @param idadeMaxima Anos maximo de idade
     * @returns retorna true se o nascimento é valido
     */
    static isDataNascimentoValida(data, idadeMaxima = 0) {
        if (idadeMaxima === 0) {
            idadeMaxima = 130;
        }
        const dataAgora = new Date();
        const dataAntiga = new Date((DateUtil.extractYear(dataAgora) - idadeMaxima), (DateUtil.extractMonth(dataAgora) - 1), DateUtil.extractDay(dataAgora));
        const dataNascimento = DateUtil.strToDate(data);
        return DateUtil.numDaysByInterval(dataAgora, dataNascimento) < 0 && DateUtil.numDaysByInterval(dataAntiga, dataNascimento) > 0;
    }
    /**
     * Retorna a data incrementada com dias
     * @param dataAtual Data para ser incrementada
     * @param dias Numero de dias para incrementar
     * @returnsData incrementada
     */
    static incDay(dataAtual, dias) {
        const result = new Date();
        result.setDate(dataAtual.getDate() + dias);
        return result;
    }
    /**
     * Retorna uma data convertida a partir do numero PeriodoMes usado no controle
     * @param meses Informe o numero do PeriodoMes
     * @returnsRetorna a data com o dia 1 (Ex: 01/01/2000)
     */
    static periodoMesParaData(meses) {
        const valorAno = Math.floor((((meses - 1) / 12) + 2000) + 0.001);
        const shortAno = Math.floor(((meses - 1) / 12) + 0.001);
        const valorMes = meses - (shortAno * 12);
        return new Date(valorAno, (valorMes - 1), 1, 0, 0, 0, 0);
    }
    /**
     * Retorna numero de meses do PeriodoMes usado no controle
     * @param data Informe a data para converter em PeriodoMes
     * @returnsnumero de meses
     */
    static dataParaPeriodoMes(data) {
        let result = 0;
        if (!DateUtil.isDefaultDate(data)) {
            const ano = DateUtil.extractYear(data) - 2000;
            const mes = DateUtil.extractMonth(data);
            result = (ano * 12) + mes;
        }
        return result;
    }
    /**
     * Retorna uma data dentro da semana, pasando o numero do dia da semana entre 0 a 6 (0 = domindo, 1 = segunda, ..., 6 = sábado).
     * Usado para descobrir a primeira e última data de uma semana (domingo a sábado).
     * @param dataAtual Data atual
     * @param numeroDiaSemana 0 = domindo, 1 = segunda, ..., 6 = sábado
     * @returnsRetorna data a partir do numero da semana.
     */
    static getDataDentroDaSemana(dataAtual, numeroDiaSemana) {
        dataAtual = this.getDefaultDate(dataAtual);
        if (numeroDiaSemana >= 0 || numeroDiaSemana <= 6) {
            const numeroSemanaDataAtual = DateUtil.getDayOfWeek(dataAtual);
            if (numeroSemanaDataAtual > numeroDiaSemana) {
                return DateUtil.incDay(dataAtual, (0 - numeroSemanaDataAtual));
            }
            if (numeroSemanaDataAtual < numeroDiaSemana) {
                return DateUtil.incDay(dataAtual, (numeroSemanaDataAtual - 6) * (-1));
            }
        }
        return dataAtual;
    }
    /**
     * Retorna o numero de dias máximo de um determinado mês.
     * @param ano Informe o numero do ano. Ex: 2019
     * @param mes Informe o numero do mês. Ex: 0 = janeiro
     * @returnsRetorna o numero de dias
     */
    static maxDiasDoMes(ano, mes) {
        if (ano < 1900 || mes < 0 || mes > 11) {
            return 0;
        }
        return new Date(ano, (mes + 1), 0).getDate();
    }
    static contagemRegressiva(data, mascara = '%D| dia: dias| %H| hora: horas| %M| minuto: minutos| %S| segundo: segundos|') {
        if (!data) {
            return '';
        }
        const dataAgora = new Date();
        const diferenca = data.getTime() - dataAgora.getTime();
        let dia = 0;
        let hora = 0;
        let minuto = 0;
        let segundo = 0;
        if (diferenca > 0) {
            dia = Math.floor(diferenca / (1000 * 60 * 60 * 24));
            hora = Math.floor((diferenca % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            minuto = Math.floor((diferenca % (1000 * 60 * 60)) / (1000 * 60));
            segundo = Math.floor((diferenca % (1000 * 60)) / 1000);
        }
        const resultMascara = [];
        const regExMascara = /(\%[\w])\|(\s*\w*)\:(\s*\w*)\|(.+?(?=\%)|$)/g;
        try {
            let arrayMascara = regExMascara.exec(mascara);
            while (arrayMascara !== null) {
                let valor = 0;
                switch (this.strValid(arrayMascara[1])) {
                    case '%D':
                        valor = dia;
                        break;
                    case '%H':
                        valor = hora;
                        break;
                    case '%M':
                        valor = minuto;
                        break;
                    case '%S':
                        valor = segundo;
                        break;
                }
                if (valor > 0) {
                    resultMascara.push(valor + (valor === 1 ? this.strValid(arrayMascara[2]) : this.strValid(arrayMascara[3])) + this.strValid(arrayMascara[4]));
                }
                arrayMascara = regExMascara.exec(mascara);
            }
        }
        catch (erro) {
            console.error(erro);
        }
        return resultMascara.join('');
    }
    static strValid(str) {
        return str ? str : '';
    }
}
DateUtil.dayOfWeek = ['domingo', 'segunda-feira', 'terca-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sabado'];
DateUtil.months = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

class DataRelativaPipe {
    transform(value) {
        if (typeof value === 'string') {
            value = DateUtil.strToDateTime(value);
        }
        return DateUtil.getDataRelativa(new Date(), value);
    }
}
DataRelativaPipe.ɵfac = function DataRelativaPipe_Factory(t) { return new (t || DataRelativaPipe)(); };
DataRelativaPipe.ɵpipe = ɵɵdefinePipe({ name: "dataRelativa", type: DataRelativaPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DataRelativaPipe, [{
        type: Pipe,
        args: [{
                name: 'dataRelativa'
            }]
    }], null, null); })();

class DateToStrPipe {
    transform(value) {
        if (value instanceof Date) {
            if (value.getHours() > 0 || value.getMinutes() > 0 || value.getSeconds() > 0) {
                return Parser.dateTimeToStr(value);
            }
            else {
                return Parser.dateToStr(value);
            }
        }
        return value;
    }
}
DateToStrPipe.ɵfac = function DateToStrPipe_Factory(t) { return new (t || DateToStrPipe)(); };
DateToStrPipe.ɵpipe = ɵɵdefinePipe({ name: "dateToStr", type: DateToStrPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DateToStrPipe, [{
        type: Pipe,
        args: [{
                name: 'dateToStr'
            }]
    }], null, null); })();

class FormatNumberEtiqPipe {
    transform(value) {
        if (typeof value === 'string') {
            return Parser.formateNumberEtiq(value);
        }
        return value;
    }
}
FormatNumberEtiqPipe.ɵfac = function FormatNumberEtiqPipe_Factory(t) { return new (t || FormatNumberEtiqPipe)(); };
FormatNumberEtiqPipe.ɵpipe = ɵɵdefinePipe({ name: "formatNumberEtiq", type: FormatNumberEtiqPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FormatNumberEtiqPipe, [{
        type: Pipe,
        args: [{
                name: 'formatNumberEtiq'
            }]
    }], null, null); })();

class StrToDatePipe {
    transform(value) {
        if (typeof value === 'string') {
            return DateUtil.strToDate(value);
        }
        return value;
    }
}
StrToDatePipe.ɵfac = function StrToDatePipe_Factory(t) { return new (t || StrToDatePipe)(); };
StrToDatePipe.ɵpipe = ɵɵdefinePipe({ name: "strToDate", type: StrToDatePipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(StrToDatePipe, [{
        type: Pipe,
        args: [{
                name: 'strToDate'
            }]
    }], null, null); })();

class AjaxService {
    constructor() {
        this.token = '';
    }
    execute(method, url, data) {
        /* Return a new promise */
        return new Promise((resolve, reject) => {
            /* coloca um parametro de timestamp na url para evitar cache */
            if (method === 'GET' && url) {
                const time = '_=' + (new Date()).getTime();
                if (url.indexOf('?') > -1) {
                    url += '&' + time;
                }
                else {
                    url += '?' + time;
                }
            }
            const req = new XMLHttpRequest();
            req.open(method, url);
            /* adiciona token de autenticacao */
            if (this.token && this.token.length > 0) {
                req.setRequestHeader('x-auth-token', this.token);
            }
            req.onload = () => {
                /**
                 * This is called even on 404 etc
                 * so check the status
                 */
                if (req.status === 200) {
                    /* Resolve the promise with the response text */
                    resolve(JSON.parse(req.response));
                }
                else if (req.status === 403) {
                    /* sessao expirou */
                    reject(JSON.parse(req.response));
                }
                else if (req.status === 404) {
                    /* recurso nao localizado */
                    const der = { codigo: 404, mensagem: '404 - Recurso não localizado' };
                    reject(der);
                }
                else {
                    /**
                     * Otherwise reject with the status text
                     * which will hopefully be a meaningful error
                     */
                    try {
                        reject(JSON.parse(req.response));
                    }
                    catch (e) {
                        const der = { codigo: req.status, mensagem: req.statusText };
                        reject(der);
                    }
                }
            };
            /* Handle network errors */
            req.onerror = () => {
                const der = { codigo: -1, mensagem: 'Erro de rede, verifique sua conexão e tente novamente.' };
                reject(der);
            };
            /* Make the request */
            if (method === 'POST' && data) {
                req.send(data);
            }
            else {
                req.send(null);
            }
        });
    }
    /**
     * Ao fazer login o servidor pode fornecer um token de autenticacao
     * @param token Retornado pelo servidor ao efetuar o login
     */
    setToken(token) {
        this.token = token;
    }
    /**
     * Faz chamada GET via HTTP AJAX para url
     * @param url Para chamada ao servidor normalmente parcial estilo 'empresa?action=list'
     * @returns Retorna Promise com resultado
     */
    get(url) {
        return this.execute('GET', url, '');
    }
    /**
     * Faz chamada POST via HTTP AJAX para url
     * @param url Para chamada ao servidor normalmente parcial estilo 'empresa?action=list'
     * @param data Para envio de dados em formato JSON
     * @returns Retorne Promise com resultado
     */
    post(url, data) {
        return this.execute('POST', url, JSON.stringify(data));
    }
}
AjaxService.ɵfac = function AjaxService_Factory(t) { return new (t || AjaxService)(); };
AjaxService.ɵprov = ɵɵdefineInjectable({ token: AjaxService, factory: AjaxService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AjaxService, [{
        type: Injectable
    }], null, null); })();

class BaseService {
    constructor(router, ajax, toastr) {
        this.router = router;
        this.ajax = ajax;
        this.toastrSrv = toastr;
    }
    handleError(error) {
        /* faz tratamento de erro e dispara tostr com mensagem de erro */
        console.error(error);
        /* verifica se eh 403 para redirecionar para a tela de login */
        if (error.codigo === 403) {
            this.router.navigate(['/login']);
        }
        /* Lanca aviso TOASTR ao usuario */
        if (error.errorClass === 'com.sollus.exception.EDataValidate') {
            const errorConfig = { timeOut: 0, extendedTimeOut: 0, closeButton: true };
            this.toastrSrv.warning(error.mensagem, 'Atenção!', errorConfig);
        }
        else {
            const errorConfig = { timeOut: 0, extendedTimeOut: 0, tapToDismiss: false, closeButton: true };
            this.toastrSrv.error(error.mensagem, 'Erro!', errorConfig);
        }
        /* re-lanca a excecao para a GUI tratar o erro se quiser */
        return Promise.reject(new Error(error.mensagem));
    }
}
BaseService.ɵfac = function BaseService_Factory(t) { return new (t || BaseService)(ɵɵinject(Router), ɵɵinject(AjaxService), ɵɵinject(ToastrService)); };
BaseService.ɵprov = ɵɵdefineInjectable({ token: BaseService, factory: BaseService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(BaseService, [{
        type: Injectable
    }], function () { return [{ type: Router }, { type: AjaxService }, { type: ToastrService }]; }, null); })();

/* tslint:disable:unified-signatures */
class BrowserUtil {
    static getFirstMatch(ua, regex) {
        const match = ua.match(regex);
        return (match && match.length > 1 && match[1]) || '';
    }
    /**
     * Retorna um BrowserInfo com dados do navegador
     * Importar também {BrowserInfo} para usar a classe
     * fonte https://github.com/ded/bowser
     * @returns Retorna dados do navegador
     */
    static browserInfo() {
        const result = new BrowserInfo();
        const ua = navigator.userAgent.toLowerCase();
        if (/mozilla/.test(ua) && /firefox/.test(ua)) {
            result.browser = BrowserType.FIREFOX;
            result.version = BrowserUtil.getFirstMatch(ua, /(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i);
        }
        else if (/chrome|crios|crmo/i.test(ua)) {
            result.browser = BrowserType.CHROME;
            result.version = BrowserUtil.getFirstMatch(ua, /(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i);
        }
        else if (/chrome.+? edge/i.test(ua)) {
            result.browser = BrowserType.EDGE;
            result.version = BrowserUtil.getFirstMatch(ua, /edge\/(\d+(\.\d+)?)/i);
        }
        else if (/msie|trident/i.test(ua)) {
            result.browser = BrowserType.IE;
            result.version = BrowserUtil.getFirstMatch(ua, /(?:msie |rv:)(\d+(\.\d+)?)/i);
        }
        else {
            result.browser = BrowserType.NONE;
        }
        return result;
    }
    static createCookie(name, value, days) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        else {
            expires = '';
        }
        document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '';
    }
    /**
     * Faz a leitura dos Cookies e retorna o valor
     * @param name Nome da chave do Cookie a ser lido
     * @returns Valor do Cookie ou **NULL** caso nao encontre
     */
    static readCookie(name) {
        const nameEQ = decodeURIComponent(name) + '=';
        const ca = document.cookie.split(';');
        for (let c of ca) {
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return '';
    }
    /**
     * Retorna se o Browser esta conectado a internet
     * @returns Retorna TRUE se tem conexao ativa com a internet
     */
    static isOnLine() {
        return navigator.onLine;
    }
    static verificaURL(url) {
        if (url.indexOf('://')) {
            url = url.replace('://', ':@@').replace('//', '/').replace(':@@', '://');
        }
        else {
            url = url.replace('//', '/');
        }
        return url;
    }
    /**
     * Abre uma janela pop-up centralizada
     * @param url url para abrir o pop-up
     * @param nome nome da janela
     * @param width largura da janela
     * @param height altura da janela
     */
    static windowCenter(url, nome, width, height) {
        let atribs = 'resizable=1,toolbar=0,status=0,menubar=0,scrollbars=1';
        if (width && height) {
            const top = (screen.height - Parser.strToInt(height) - 30) / 2;
            const left = (screen.width - Parser.strToInt(width)) / 2;
            atribs += `,width=${width},height=${height},top=${top},left=${left}`;
        }
        const win = window.open(this.verificaURL(url), nome, atribs);
        win.focus();
    }
}
BrowserUtil.ɵfac = function BrowserUtil_Factory(t) { return new (t || BrowserUtil)(); };
BrowserUtil.ɵprov = ɵɵdefineInjectable({ token: BrowserUtil, factory: BrowserUtil.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(BrowserUtil, [{
        type: Injectable
    }], null, null); })();
/* tipos de Browser */
var BrowserType;
(function (BrowserType) {
    BrowserType[BrowserType["NONE"] = 0] = "NONE";
    BrowserType[BrowserType["CHROME"] = 1] = "CHROME";
    BrowserType[BrowserType["EDGE"] = 2] = "EDGE";
    BrowserType[BrowserType["FIREFOX"] = 3] = "FIREFOX";
    BrowserType[BrowserType["IE"] = 4] = "IE";
    BrowserType[BrowserType["SAFARI"] = 5] = "SAFARI";
})(BrowserType || (BrowserType = {}));
class BrowserInfo {
}

/**
 * Classe utilitária para calculo do CPF e CNPJ
 */
class Cnp {
    /**
     * Calcula o digito
     * @param str Valor
     * @param peso Peso
     * @returns Retorna o digito
     */
    static calcularDigito(str, peso) {
        let soma = 0;
        for (let indice = (str.length - 1); indice >= 0; indice--) {
            const digito = Parser.strToInt(str.substring(indice, indice + 1));
            soma += digito * peso[peso.length - str.length + indice];
        }
        soma = 11 - soma % 11;
        return soma > 9 ? 0 : soma;
    }
    /**
     * Verifica se todos os caracteries sao repetidos
     * @param valor valor a ser testado
     * @returns Retorna TRUE se todos os caracteries sao repetidos
     */
    static isDigitosRepetidos(valor) {
        const lista = valor.split(valor.substring(0, 1));
        return lista.length > valor.length;
    }
    /**
     * Verifica se o CPF é válido
     * @param cpf String soment numérica sem separadores
     * @returns Retorna TRUE se é válido
     */
    static isValidCPF(cpf) {
        if (!cpf || Parser.trimToDigits(cpf).length !== 11) {
            return false;
        }
        cpf = Parser.trimToDigits(cpf);
        const digito1 = this.calcularDigito(cpf.substring(0, 9), this.pesoCPF);
        const digito2 = this.calcularDigito(cpf.substring(0, 9) + digito1, this.pesoCPF);
        return cpf === (cpf.substring(0, 9) + digito1.toString() + digito2.toString()) && !this.isDigitosRepetidos(cpf.substring(0, 9)) && !this.isDigitosRepetidos(cpf);
    }
    /**
     * Verifica se o CNPJ é válido
     * @param cnpj String soment numérica sem separadores
     * @returns Retorna TRUE se for válido
     */
    static isValidCNPJ(cnpj) {
        if (!cnpj || Parser.trimToDigits(cnpj).length !== 14) {
            return false;
        }
        cnpj = Parser.trimToDigits(cnpj);
        const digito1 = this.calcularDigito(cnpj.substring(0, 12), this.pesoCNPJ);
        const digito2 = this.calcularDigito(cnpj.substring(0, 12) + digito1, this.pesoCNPJ);
        return cnpj === (cnpj.substring(0, 12) + digito1.toString() + digito2.toString()) && !this.isDigitosRepetidos(cnpj);
    }
}
Cnp.pesoCPF = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
Cnp.pesoCNPJ = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

// tslint:disable:max-line-length
class CreditCard {
    static getFlagByNumber(numberCard) {
        let flagName = '';
        if (numberCard) {
            numberCard = Parser.trimToDigits(numberCard);
        }
        if (numberCard == null || numberCard.length < 6) {
            return '';
        }
        for (const flag of this.flags) {
            const result = flag.startNumber.filter(n => numberCard.startsWith(n));
            if (result && result.length > 0) {
                flagName = flag.name;
                break;
            }
        }
        return flagName;
    }
    static maxLenghtNumberCard(creditCardFlag) {
        if (creditCardFlag === 'diners') {
            return 14;
        }
        if (creditCardFlag === 'amex' || creditCardFlag === 'discover') {
            return 15;
        }
        return 16;
    }
    static dateMask(dateStr) {
        if (dateStr == null) {
            return '';
        }
        dateStr = Parser.trimToDigits(dateStr);
        if (dateStr.length <= 2) {
            return dateStr.substring(0, 2);
        }
        if (dateStr.length > 2) {
            return dateStr.substring(0, 2) + ' / ' + dateStr.substring(2, 4);
        }
    }
    static numberMask(numberCard, creditCardFlag) {
        if (numberCard == null) {
            return '';
        }
        if (creditCardFlag == null) {
            creditCardFlag = this.getFlagByNumber(numberCard);
        }
        numberCard = Parser.trimToDigits(numberCard);
        if (creditCardFlag === 'diners') {
            return this.maskDiners(numberCard);
        }
        if (creditCardFlag === 'amex') {
            return this.maskAmex(numberCard);
        }
        return this.maskDefault(numberCard);
    }
    static maskDiners(numberCard) {
        /* 3024 304375 1734 */
        if (numberCard.length <= 4) {
            return numberCard.substring(0, 4);
        }
        if (numberCard.length <= 10) {
            return numberCard.substring(0, 4) + ' ' + numberCard.substring(4, 10);
        }
        if (numberCard.length > 10) {
            return numberCard.substring(0, 4) + ' ' + numberCard.substring(4, 10) + ' ' + numberCard.substring(10, 14);
        }
    }
    static maskAmex(numberCard) {
        /* 3443 813813 39984 */
        if (numberCard.length <= 4) {
            return numberCard.substring(0, 4);
        }
        if (numberCard.length <= 10) {
            return numberCard.substring(0, 4) + ' ' + numberCard.substring(4, 10);
        }
        if (numberCard.length > 10) {
            return numberCard.substring(0, 4) + ' ' + numberCard.substring(4, 10) + ' ' + numberCard.substring(10, 15);
        }
    }
    static maskDefault(numberCard) {
        /* 5108 9953 9477 8089 */
        if (numberCard.length <= 4) {
            return numberCard.substring(0, 4);
        }
        if (numberCard.length <= 8) {
            return numberCard.substring(0, 4) + ' ' + numberCard.substring(4, 8);
        }
        if (numberCard.length <= 12) {
            return numberCard.substring(0, 4) + ' ' + numberCard.substring(4, 8) + ' ' + numberCard.substring(8, 12);
        }
        if (numberCard.length > 12) {
            return numberCard.substring(0, 4) + ' ' + numberCard.substring(4, 8) + ' ' + numberCard.substring(8, 12) + ' ' + numberCard.substring(12, 16);
        }
    }
    static lenghtCvv(creditCardFlag) {
        return creditCardFlag && creditCardFlag === 'amex' ? 4 : 3;
    }
    static isDateValidate(month, year) {
        const dateNow = new Date();
        if (month == null || month === 0 || month > 12 || year == null || year === 0) {
            return false;
        }
        if (year < 100) {
            year = Parser.strToInt((dateNow.getFullYear() + '').substring(0, 2) + (year > 10 ? year + '' : '0' + year));
        }
        if (year < dateNow.getFullYear() || year > (dateNow.getFullYear() + 10)) {
            return false;
        }
        if (year > dateNow.getFullYear() && year <= (dateNow.getFullYear() + 10)) {
            return true;
        }
        if (year === dateNow.getFullYear()) {
            return month >= (dateNow.getMonth() + 1);
        }
    }
}
CreditCard.flags = [
    { name: 'elo', startNumber: ['401178', '401179', '431274', '438935', '451416', '457393', '457631', '457632', '498405', '498410', '498411', '498412', '498418', '498419', '498420', '498421', '498422', '498427', '498428', '498429', '498432', '498433', '498472', '498473', '498487', '498493', '498494', '498497', '498498', '504175', '506699', '506700', '506701', '506702', '506703', '506704', '506705', '506706', '506707', '506708', '506709', '506710', '506711', '506712', '506713', '506714', '506715', '506716', '506717', '506718', '506719', '506720', '506721', '506722', '506723', '506724', '506725', '506726', '506727', '506728', '506729', '506730', '506731', '506732', '506733', '506734', '506735', '506736', '506737', '506738', '506739', '506740', '506741', '506742', '506743', '506744', '506745', '506746', '506747', '506748', '506749', '506750', '506751', '506752', '506753', '506754', '506755', '506756', '506757', '506758', '506759', '506760', '506761', '506762', '506763', '506764', '506765', '506766', '506767', '506768', '506769', '506770', '506771', '506772', '506773', '506774', '506775', '506776', '506777', '506778', '509000', '509001', '509002', '509003', '509004', '509005', '509006', '509007', '509008', '509009', '509010', '509011', '509012', '509013', '509014', '509015', '509016', '509017', '509018', '509019', '509020', '509021', '509022', '509023', '509024', '509025', '509026', '509027', '509028', '509029', '509030', '509031', '509032', '509033', '509034', '509035', '509036', '509037', '509038', '509039', '509040', '509041', '509042', '509043', '509044', '509045', '509046', '509047', '509048', '509049', '509050', '509051', '509052', '509053', '509054', '509055', '509056', '509057', '509058', '509059', '509060', '509061', '509062', '509063', '509064', '509065', '509066', '509067', '509068', '509069', '509070', '509071', '509072', '509073', '509074', '509075', '509076', '509077', '509078', '509079', '509080', '509081', '509082', '509083', '509084', '509085', '509086', '509087', '509088', '509089', '509090', '509091', '509092', '509093', '509094', '509095', '509096', '509097', '509098', '509099', '509100', '509101', '509102', '509103', '509104', '509105', '509106', '509107', '509108', '509109', '509110', '509111', '509112', '509113', '509114', '509115', '509116', '509117', '509118', '509119', '509120', '509121', '509122', '509123', '509124', '509125', '509126', '509127', '509128', '509129', '509130', '509131', '509132', '509133', '509134', '509135', '509136', '509137', '509138', '509139', '509140', '509141', '509142', '509143', '509144', '509145', '509146', '509147', '509148', '509149', '509150', '509151', '509152', '509153', '509154', '509155', '509156', '509157', '509158', '509159', '509160', '509161', '509162', '509163', '509164', '509165', '509166', '509167', '509168', '509169', '509170', '509171', '509172', '509173', '509174', '509175', '509176', '509177', '509178', '509179', '509180', '509181', '509182', '509183', '509184', '509185', '509186', '509187', '509188', '509189', '509190', '509191', '509192', '509193', '509194', '509195', '509196', '509197', '509198', '509199', '509200', '509201', '509202', '509203', '509204', '509205', '509206', '509207', '509208', '509209', '509210', '509211', '509212', '509213', '509214', '509215', '509216', '509217', '509218', '509219', '509220', '509221', '509222', '509223', '509224', '509225', '509226', '509227', '509228', '509229', '509230', '509231', '509232', '509233', '509234', '509235', '509236', '509237', '509238', '509239', '509240', '509241', '509242', '509243', '509244', '509245', '509246', '509247', '509248', '509249', '509250', '509251', '509252', '509253', '509254', '509255', '509256', '509257', '509258', '509259', '509260', '509261', '509262', '509263', '509264', '509265', '509266', '509267', '509268', '509269', '509270', '509271', '509272', '509273', '509274', '509275', '509276', '509277', '509278', '509279', '509280', '509281', '509282', '509283', '509284', '509285', '509286', '509287', '509288', '509289', '509290', '509291', '509292', '509293', '509294', '509295', '509296', '509297', '509298', '509299', '509300', '509301', '509302', '509303', '509304', '509305', '509306', '509307', '509308', '509309', '509310', '509311', '509312', '509313', '509314', '509315', '509316', '509317', '509318', '509319', '509320', '509321', '509322', '509323', '509324', '509325', '509326', '509327', '509328', '509329', '509330', '509331', '509332', '509333', '509334', '509335', '509336', '509337', '509338', '509339', '509340', '509341', '509342', '509343', '509344', '509345', '509346', '509347', '509348', '509349', '509350', '509351', '509352', '509353', '509354', '509355', '509356', '509357', '509358', '509359', '509360', '509361', '509362', '509363', '509364', '509365', '509366', '509367', '509368', '509369', '509370', '509371', '509372', '509373', '509374', '509375', '509376', '509377', '509378', '509379', '509380', '509381', '509382', '509383', '509384', '509385', '509386', '509387', '509388', '509389', '509390', '509391', '509392', '509393', '509394', '509395', '509396', '509397', '509398', '509399', '509400', '509401', '509402', '509403', '509404', '509405', '509406', '509407', '509408', '509409', '509410', '509411', '509412', '509413', '509414', '509415', '509416', '509417', '509418', '509419', '509420', '509421', '509422', '509423', '509424', '509425', '509426', '509427', '509428', '509429', '509430', '509431', '509432', '509433', '509434', '509435', '509436', '509437', '509438', '509439', '509440', '509441', '509442', '509443', '509444', '509445', '509446', '509447', '509448', '509449', '509450', '509451', '509452', '509453', '509454', '509455', '509456', '509457', '509458', '509459', '509460', '509461', '509462', '509463', '509464', '509465', '509466', '509467', '509468', '509469', '509470', '509471', '509472', '509473', '509474', '509475', '509476', '509477', '509478', '509479', '509480', '509481', '509482', '509483', '509484', '509485', '509486', '509487', '509488', '509489', '509490', '509491', '509492', '509493', '509494', '509495', '509496', '509497', '509498', '509499', '509500', '509501', '509502', '509503', '509504', '509505', '509506', '509507', '509508', '509509', '509510', '509511', '509512', '509513', '509514', '509515', '509516', '509517', '509518', '509519', '509520', '509521', '509522', '509523', '509524', '509525', '509526', '509527', '509528', '509529', '509530', '509531', '509532', '509533', '509534', '509535', '509536', '509537', '509538', '509539', '509540', '509541', '509542', '509543', '509544', '509545', '509546', '509547', '509548', '509549', '509550', '509551', '509552', '509553', '509554', '509555', '509556', '509557', '509558', '509559', '509560', '509561', '509562', '509563', '509564', '509565', '509566', '509567', '509568', '509569', '509570', '509571', '509572', '509573', '509574', '509575', '509576', '509577', '509578', '509579', '509580', '509581', '509582', '509583', '509584', '509585', '509586', '509587', '509588', '509589', '509590', '509591', '509592', '509593', '509594', '509595', '509596', '509597', '509598', '509599', '509600', '509601', '509602', '509603', '509604', '509605', '509606', '509607', '509608', '509609', '509610', '509611', '509612', '509613', '509614', '509615', '509616', '509617', '509618', '509619', '509620', '509621', '509622', '509623', '509624', '509625', '509626', '509627', '509628', '509629', '509630', '509631', '509632', '509633', '509634', '509635', '509636', '509637', '509638', '509639', '509640', '509641', '509642', '509643', '509644', '509645', '509646', '509647', '509648', '509649', '509650', '509651', '509652', '509653', '509654', '509655', '509656', '509657', '509658', '509659', '509660', '509661', '509662', '509663', '509664', '509665', '509666', '509667', '509668', '509669', '509670', '509671', '509672', '509673', '509674', '509675', '509676', '509677', '509678', '509679', '509680', '509681', '509682', '509683', '509684', '509685', '509686', '509687', '509688', '509689', '509690', '509691', '509692', '509693', '509694', '509695', '509696', '509697', '509698', '509699', '509700', '509701', '509702', '509703', '509704', '509705', '509706', '509707', '509708', '509709', '509710', '509711', '509712', '509713', '509714', '509715', '509716', '509717', '509718', '509719', '509720', '509721', '509722', '509723', '509724', '509725', '509726', '509727', '509728', '509729', '509730', '509731', '509732', '509733', '509734', '509735', '509736', '509737', '509738', '509739', '509740', '509741', '509742', '509743', '509744', '509745', '509746', '509747', '509748', '509749', '509750', '509751', '509752', '509753', '509754', '509755', '509756', '509757', '509758', '509759', '509760', '509761', '509762', '509763', '509764', '509765', '509766', '509767', '509768', '509769', '509770', '509771', '509772', '509773', '509774', '509775', '509776', '509777', '509778', '509779', '509780', '509781', '509782', '509783', '509784', '509785', '509786', '509787', '509788', '509789', '509790', '509791', '509792', '509793', '509794', '509795', '509796', '509797', '509798', '509799', '509800', '509801', '509802', '509803', '509804', '509805', '509806', '509807', '509808', '509809', '509810', '509811', '509812', '509813', '509814', '509815', '509816', '509817', '509818', '509819', '509820', '509821', '509822', '509823', '509824', '509825', '509826', '509827', '509828', '509829', '509830', '509831', '509832', '509833', '509834', '509835', '509836', '509837', '509838', '509839', '509840', '509841', '509842', '509843', '509844', '509845', '509846', '509847', '509848', '509849', '509850', '509851', '509852', '509853', '509854', '509855', '509856', '509857', '509858', '509859', '509860', '509861', '509862', '509863', '509864', '509865', '509866', '509867', '509868', '509869', '509870', '509871', '509872', '509873', '509874', '509875', '509876', '509877', '509878', '509879', '509880', '509881', '509882', '509883', '509884', '509885', '509886', '509887', '509888', '509889', '509890', '509891', '509892', '509893', '509894', '509895', '509896', '509897', '509898', '509899', '509900', '509901', '509902', '509903', '509904', '509905', '509906', '509907', '509908', '509909', '509910', '509911', '509912', '509913', '509914', '509915', '509916', '509917', '509918', '509919', '509920', '509921', '509922', '509923', '509924', '509925', '509926', '509927', '509928', '509929', '509930', '509931', '509932', '509933', '509934', '509935', '509936', '509937', '509938', '509939', '509940', '509941', '509942', '509943', '509944', '509945', '509946', '509947', '509948', '509949', '509950', '509951', '509952', '509953', '509954', '509955', '509956', '509957', '509958', '509959', '509960', '509961', '509962', '509963', '509964', '509965', '509966', '509967', '509968', '509969', '509970', '509971', '509972', '509973', '509974', '509975', '509976', '509977', '509978', '509979', '509980', '509981', '509982', '509983', '509984', '509985', '509986', '509987', '509988', '509989', '509990', '509991', '509992', '509993', '509994', '509995', '509996', '509997', '509998', '509999', '627780', '636297', '636368', '650031', '650032', '650033', '650035', '650036', '650037', '650038', '650039', '650040', '650041', '650042', '650043', '650044', '650045', '650046', '650047', '650048', '650049', '650050', '650051', '650405', '650406', '650407', '650408', '650409', '650410', '650411', '650412', '650413', '650414', '650415', '650416', '650417', '650418', '650419', '650420', '650421', '650422', '650423', '650424', '650425', '650426', '650427', '650428', '650429', '650430', '650431', '650432', '650433', '650434', '650435', '650436', '650437', '650438', '650439', '650485', '650486', '650487', '650488', '650489', '650490', '650491', '650492', '650493', '650494', '650495', '650496', '650497', '650498', '650499', '650500', '650501', '650502', '650503', '650504', '650505', '650506', '650507', '650508', '650509', '650510', '650511', '650512', '650513', '650514', '650515', '650516', '650517', '650518', '650519', '650520', '650521', '650522', '650523', '650524', '650525', '650526', '650527', '650528', '650529', '650530', '650531', '650532', '650533', '650534', '650535', '650536', '650537', '650538', '650541', '650542', '650543', '650544', '650545', '650546', '650547', '650548', '650549', '650550', '650551', '650552', '650553', '650554', '650555', '650556', '650557', '650558', '650559', '650560', '650561', '650562', '650563', '650564', '650565', '650566', '650567', '650568', '650569', '650570', '650571', '650572', '650573', '650574', '650575', '650576', '650577', '650578', '650579', '650580', '650581', '650582', '650583', '650584', '650585', '650586', '650587', '650588', '650589', '650590', '650591', '650592', '650593', '650594', '650595', '650596', '650597', '650598', '650700', '650701', '650702', '650703', '650704', '650705', '650706', '650707', '650708', '650709', '650710', '650711', '650712', '650713', '650714', '650715', '650716', '650717', '650718', '650720', '650721', '650722', '650723', '650724', '650725', '650726', '650727', '650901', '650902', '650903', '650904', '650905', '650906', '650907', '650908', '650909', '650910', '650911', '650912', '650913', '650914', '650915', '650916', '650917', '650918', '650919', '650920', '651652', '651653', '651654', '651655', '651656', '651657', '651658', '651659', '651660', '651661', '651662', '651663', '651664', '651665', '651666', '651667', '651668', '651669', '651670', '651671', '651672', '651673', '651674', '651675', '651676', '651677', '651678', '651679', '655000', '655001', '655002', '655003', '655004', '655005', '655006', '655007', '655008', '655009', '655010', '655011', '655012', '655013', '655014', '655015', '655016', '655017', '655018', '655019', '655021', '655022', '655023', '655024', '655025', '655026', '655027', '655028', '655029', '655030', '655031', '655032', '655033', '655034', '655035', '655036', '655037', '655038', '655039', '655040', '655041', '655042', '655043', '655044', '655045', '655046', '655047', '655048', '655049', '655050', '655051', '655052', '655053', '655054', '655055', '655056', '655057', '655058'] },
    { name: 'discover', startNumber: ['6011', '622', '64', '65'] },
    { name: 'hipercard', startNumber: ['384100', '384140', '384160', '60'] },
    { name: 'diners', startNumber: ['301', '305', '36', '38'] },
    { name: 'amex', startNumber: ['34', '37'] },
    { name: 'aura', startNumber: ['50'] },
    { name: 'jcb', startNumber: ['35'] },
    { name: 'visa', startNumber: ['4'] },
    { name: 'master', startNumber: ['5'] },
];

/**
 * Classe de calculo dos digitos verificadores
 */
class DigitoVerificadorUtil {
    /**
     * Rotina para calculo de digito verificador Modulo10. Se não for passado uma
     * string com representação numerica correta a rotina vai retornar 0 (zero)
     * @param numero String com codigo numerico
     * @returns Int com o digito verificador
     */
    static getDigitoModulo10(numero) {
        if (numero && numero === '') {
            return 0;
        }
        const modulo = 10;
        let calculo = 0;
        let resto = 0;
        let soma = 0;
        for (let i = 0; i < numero.length; i++) {
            const pos = numero.length - i;
            if (i % 2 === 0) {
                soma = 2 * Parser.strToInt(numero.substring(pos - 1, pos));
                while (soma >= 10) {
                    const strSoma = soma.toString();
                    soma = 0;
                    for (let x = 0; x < strSoma.length; x++) {
                        soma += Parser.strToInt(strSoma.substring(x, x + 1));
                    }
                }
                calculo += soma;
            }
            else {
                calculo += Parser.strToInt(numero.substring(pos - 1, pos));
            }
        }
        resto = calculo % modulo;
        let result = modulo - resto;
        if (result >= 10) {
            result = 0;
        }
        return result;
    }
    /**
     * Verifica se é um código de 16 digitos válido
     * @param codigo String para conferir
     * @returns TRUE caso seja válido
     */
    static isValidModulo10(codigo) {
        const cod = Parser.trimToDigits(codigo);
        return cod.length === 16 && this.getDigitoModulo10(cod.substring(0, 15)) === Parser.strToInt(cod.substring(15));
    }
    /**
     * Rotina para calculo de digito verificador para EAN13. Se nao for passado uma
     * string com representação numerica correta a rotina vai retornar 0 (zero)
     * @param numero String com codigo numerico
     * @returns Int o digito verificador
     */
    static getDigitoEAN13(numero) {
        if (numero && numero === '') {
            return 0;
        }
        let DV = 0;
        for (let A = 12; A > 0; A--) {
            DV += Parser.strToInt(numero.substring(A - 1, A)) * (!((A % 2) === 0) ? 1 : 3);
        }
        DV = (((Math.floor((DV / 10) + 0.001)) || 0) * 10) - DV;
        if (DV >= 10 || DV === 0) {
            return 0;
        }
        else {
            DV = 10 - (Math.abs(DV));
            return DV;
        }
    }
    /**
     * Verifica se é um código compativel com EAN13
     * @param ean String para conferir
     * @returns TRUE caso seja válido
     */
    static isValidEAN(ean) {
        const cod = Parser.trimToDigits(ean);
        return cod.length === 13 && this.getDigitoEAN13(cod.substring(0, 12)) === Parser.strToInt(cod.substring(12));
    }
    /**
     * Rotina para calculo de digito verificador Modulo11. Se não for passado uma
     * string com representação numerica correta a rotina vai retornar 0 (zero)
     * @param numero String com codigo numerico
     * @param maxMulti Valor maximo do multiplicador default 9
     * @returns Int com o digito verificador
     */
    static getDigitoModulo11(numero, maxMulti) {
        if (numero && numero === '') {
            return 0;
        }
        const modulo = 11;
        let calculo = 0;
        let resto = 0;
        let soma = 0;
        let multi = 2;
        for (let i = 0; i < numero.length; i++) {
            const pos = numero.length - i;
            /* Divisão inicial por 2 da Direita para Esquerda */
            soma = multi * Parser.strToInt(numero.substring(pos - 1, pos));
            calculo += soma;
            multi++;
            if (multi > maxMulti) {
                multi = 2;
            }
        }
        resto = calculo % modulo;
        let result = modulo - resto;
        if (result >= 10) {
            result = 0;
        }
        return result;
    }
}

class MacleMobileUtil {
    static getStrToVersaoMMT(versao) {
        let versaoLista = [];
        if (versao != null && versao.length > 0) {
            if (versao.indexOf('.') > -1) {
                versaoLista = versao.split('.');
            }
            else {
                versaoLista = [versao];
            }
        }
        if (versaoLista.length > 2) {
            try {
                return new VersaoMMT(Parser.strToInt(versaoLista[0]), Parser.strToInt(versaoLista[1]), Parser.strToInt(versaoLista[2]));
            }
            catch (error) {
                console.error(error);
            }
        }
        if (versaoLista.length === 2) {
            try {
                return new VersaoMMT(Parser.strToInt(versaoLista[0]), Parser.strToInt(versaoLista[1]), 0);
            }
            catch (error) {
                console.error(error);
            }
        }
        if (versaoLista.length === 1) {
            try {
                return new VersaoMMT(Parser.strToInt(versaoLista[0]), 0, 0);
            }
            catch (error) {
                console.error(error);
            }
        }
        return new VersaoMMT(0, 0, 0);
    }
}
class VersaoMMT {
    constructor(major, minor, patch) {
        this.major = 0;
        this.minor = 0;
        this.patch = 0;
        this.major = major || 0;
        this.minor = minor || 0;
        this.patch = patch || 0;
    }
    isEquals(versao) {
        return this.major === versao.major && this.minor === versao.minor && this.patch === versao.patch;
    }
    isMaiorIgual(versao) {
        if (this.major >= versao.major) {
            return true;
        }
        if (this.major >= versao.major && this.minor >= versao.minor) {
            return true;
        }
        if (this.major >= versao.major && this.minor >= versao.minor && this.patch >= versao.patch) {
            return true;
        }
        return false;
    }
}

/**
 * Classe utilitaria para trabalhar com String
 */
class StringUtil {
    /**
     * Verifica se a string do email é valido
     * @param value email
     * @returns boolean True para email valido
     */
    static isValidEmail(value) {
        if (!value) {
            return false;
        }
        if (value.indexOf(' ') > -1) {
            return false;
        }
        if (value.indexOf('@') < 1) {
            return false;
        }
        const emailSplit = value.split('@');
        if (emailSplit.length !== 2 || emailSplit[1].indexOf('.') === -1) {
            return false;
        }
        const dominioSplit = emailSplit[1].split('.').filter((v) => v && v.length > 0);
        if (dominioSplit.length < 2) {
            return false;
        }
        return true;
    }
}

class MafCommonsModule {
}
MafCommonsModule.ɵmod = ɵɵdefineNgModule({ type: MafCommonsModule });
MafCommonsModule.ɵinj = ɵɵdefineInjector({ factory: function MafCommonsModule_Factory(t) { return new (t || MafCommonsModule)(); }, providers: [
        AjaxService,
        BaseService
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(MafCommonsModule, { declarations: [DataRelativaPipe,
        DateToStrPipe,
        FormatNumberEtiqPipe,
        StrToDatePipe], imports: [CommonModule], exports: [DataRelativaPipe,
        DateToStrPipe,
        FormatNumberEtiqPipe,
        StrToDatePipe] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafCommonsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    DataRelativaPipe,
                    DateToStrPipe,
                    FormatNumberEtiqPipe,
                    StrToDatePipe
                ],
                exports: [
                    DataRelativaPipe,
                    DateToStrPipe,
                    FormatNumberEtiqPipe,
                    StrToDatePipe
                ],
                providers: [
                    AjaxService,
                    BaseService
                ]
            }]
    }], null, null); })();

/*
 * DB - Classes de auxilio para Indexed DB
 */

// tslint:disable: variable-name
function AlertComponent_div_0_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 3);
    ɵɵlistener("click", function AlertComponent_div_0_button_1_Template_button_click_0_listener() { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(2); return ctx_r2.dispensar(); });
    ɵɵtext(1, "\u00D7");
    ɵɵelementEnd();
} }
const _c0 = function (a0, a1, a2, a3, a4) { return { "alert-dismissable": a0, "alert-success": a1, "alert-info": a2, "alert-warning": a3, "alert-danger": a4 }; };
function AlertComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵtemplate(1, AlertComponent_div_0_button_1_Template, 2, 0, "button", 2);
    ɵɵprojection(2);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction5(2, _c0, ctx_r0.dispensavel, ctx_r0.type === "success", ctx_r0.type === "info", ctx_r0.type === "warning", ctx_r0.type === "danger"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.dispensavel);
} }
const _c1 = ["*"];
class AlertComponent {
    constructor() {
        this._type = 'success';
        this.isVisivel = true;
        /**
         * Exibe um X no lado direito do alerta. padrao 'false'.
         */
        this.dispensavel = false;
    }
    /**
     * Tipo do alerta (padrao success):
     *
     *   success = cor verde
     *   info    = cor azul
     *   warning = cor amarelo
     *   danger  = cor vermelho
     */
    get type() { return this._type; }
    set type(value) {
        if (value != null && typeof value === 'string') {
            value.toLowerCase().trim();
            if (value === 'success' || value === 'info' || value === 'warning' || value === 'danger') {
                this._type = value;
            }
        }
    }
    dispensar() {
        this.isVisivel = false;
    }
}
AlertComponent.ɵfac = function AlertComponent_Factory(t) { return new (t || AlertComponent)(); };
AlertComponent.ɵcmp = ɵɵdefineComponent({ type: AlertComponent, selectors: [["maf-alert"]], inputs: { type: "type", dispensavel: "dispensavel" }, ngContentSelectors: _c1, decls: 1, vars: 1, consts: [["class", "alert", 3, "ngClass", 4, "ngIf"], [1, "alert", 3, "ngClass"], ["type", "button", "aria-hidden", "true", 3, "click", 4, "ngIf"], ["type", "button", "aria-hidden", "true", 3, "click"]], template: function AlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵtemplate(0, AlertComponent_div_0_Template, 3, 8, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.isVisivel);
    } }, directives: [NgIf, NgClass], styles: [".alert[_ngcontent-%COMP%]{padding:15px;margin:0;border:1px solid transparent;border-radius:4px;word-break:break-word}.alert[_ngcontent-%COMP%], .alert[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{text-align:left}.alert[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-top:0;color:inherit}.alert[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{font-weight:700}.alert[_ngcontent-%COMP%] > p[_ngcontent-%COMP%], .alert[_ngcontent-%COMP%] > ul[_ngcontent-%COMP%]{margin-bottom:0}.alert[_ngcontent-%COMP%] > p[_ngcontent-%COMP%] + p[_ngcontent-%COMP%]{margin-top:5px}.alert-dismissable[_ngcontent-%COMP%]{padding-right:35px}.alert-dismissable[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{position:relative;float:right;top:-3px;right:-21px;padding:0;margin:0;border:0;line-height:1;background:0 0;font:inherit;font-size:21px;font-weight:700;color:inherit;text-shadow:0 1px 0 #fff;text-transform:none;-webkit-appearance:none;opacity:.2;overflow:visible;cursor:pointer}.alert-dismissable[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5}.alert-success[_ngcontent-%COMP%]{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#c9e2b3}.alert-success[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#2b542c}.alert-info[_ngcontent-%COMP%]{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#a6e1ec}.alert-info[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#245269}.alert-warning[_ngcontent-%COMP%]{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#f7e1b5}.alert-warning[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#66512c}.alert-danger[_ngcontent-%COMP%]{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border-top-color:#e4b9c0}.alert-danger[_ngcontent-%COMP%]   .alert-link[_ngcontent-%COMP%]{color:#843534}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AlertComponent, [{
        type: Component,
        args: [{
                selector: 'maf-alert',
                template: `
    <div *ngIf="isVisivel" class="alert" [ngClass]="{'alert-dismissable': dispensavel, 'alert-success': (type === 'success'), 'alert-info': (type === 'info'), 'alert-warning': (type === 'warning'), 'alert-danger': (type === 'danger')}">
			<button *ngIf="dispensavel" (click)="dispensar()" type="button" aria-hidden="true">×</button>
			<ng-content></ng-content>
    </div>
	`,
                styleUrls: ['./alert.component.css']
            }]
    }], function () { return []; }, { type: [{
            type: Input
        }], dispensavel: [{
            type: Input
        }] }); })();

class MafFormControlService {
    constructor() {
        this.controls = [];
        this.breakForm = false;
        this.validate = new EventEmitter();
    }
    addControl(control) {
        this.controls.push(control);
        control.validate.subscribe(() => {
            this.validate.emit({ valid: this.valid() });
        });
    }
    /**
     * Retorna TRUE se todos componentes do form estiverem válidos
     */
    valid() {
        const c = this.controls.find((vo) => !vo.valid.valid);
        if (c) {
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Força a checagem de todos componentes e retorna TRUE se
     * todos componentes do form estiverem válidos
     */
    confirmAllValid() {
        this.controls.forEach((c) => {
            c.checkValid();
        });
        return this.valid();
    }
    /* seta o foco no proximo controler do form */
    focusNext() {
        this.breakForm = false;
        /* componente com foco */
        let idx = this.controls.findIndex((fc) => fc.focused);
        if (this.controls !== null && this.controls.length > 0 && this.controls[idx] !== null && this.controls[idx].isButton) {
            /* não deve ir para proximo componente */
            return;
        }
        let c;
        do {
            idx = this.getIDX(idx);
            c = this.controls[idx];
        } while (c && c.disabled);
        /* se achou campo então seta o foco nele */
        if (c) {
            c.setFocus();
        }
    }
    getIDX(idx) {
        idx++;
        if (idx === this.controls.length) {
            if (this.breakForm) {
                throw new Error('Nenum campo para ir');
            }
            idx = 0; /* volta ao primeiro elemento */
            this.breakForm = true;
        }
        return idx;
    }
}
MafFormControlService.ɵfac = function MafFormControlService_Factory(t) { return new (t || MafFormControlService)(); };
MafFormControlService.ɵprov = ɵɵdefineInjectable({ token: MafFormControlService, factory: MafFormControlService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafFormControlService, [{
        type: Injectable
    }], null, null); })();

// tslint:disable: variable-name
class MafFormControlComponent {
    constructor(_elRef, formService) {
        this._elRef = _elRef;
        this.formService = formService;
        /* valor atual do controle */
        this._value = '';
        /* retorno do binding do campo value */
        this.valueChange = new EventEmitter();
        /* TRUE para desabilitar component */
        this.disabled = false;
        /* texto do label do componente */
        this.label = '';
        /* texto explicativo exibido ao usuario quando o campo está vazio */
        this.placeHolder = '';
        /* texto do hint do componente */
        this.title = '';
        /* dataSet é usado para passar um valor ou objeto de dados, a ser utilizado posteriormente */
        this.dataSet = undefined;
        /* TRUE para obrigatório informar */
        this.required = false;
        /* minLength é o tamanho minimo de caracteres para a validação */
        this.minLength = -1;
        this.maxLength = -1;
        /**
         * Sinalizacao do status do componente da tela ,loading, sucesso,
         * ou erro serve para sinalizar status de buscas por ajax
         */
        this.status = new EStatusControl(EStatusControl.NONE);
        /* quando terminou a validação dispara o evento para sinalizar alteração de estado */
        this.validate = new EventEmitter();
        this.focus = new EventEmitter();
        this.blur = new EventEmitter();
        /* TRUE se o componente está válido */
        this._valid = { valid: true };
        /* indica se o componente é um botão para facilitar ao form */
        this.isButton = false;
        /**
         * Variável de controle de mudança de estado da validação para emitir
         * evento validate sinalizando a mudança para o form e demais interessados
         */
        this._oldValid = true;
        this._oldValue = '';
        this._throwEvent = true;
        this._changed = false;
        /* TRUE se o componente estiver com o foco */
        this._focused = false;
        if (this.formService) {
            this.formService.addControl(this);
        }
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
        this.valueChange.emit(value);
    }
    get valid() {
        return this._valid;
    }
    set valid(valid) {
        this._valid = valid;
        this.validate.emit(valid);
    }
    get focused() { return this._focused; }
    ngAfterViewInit() {
        if (this._elRef) {
            if (this._elRef.nativeElement && this._elRef.nativeElement.nodeName && this._elRef.nativeElement.nodeName.toLowerCase().indexOf('select') > -1) {
                this._html_ref = this._elRef.nativeElement.querySelector('select');
            }
            else {
                this._html_ref = this._elRef.nativeElement.querySelector('input');
            }
        }
    }
    checkValid() {
        /* testa se é requirido */
        if (this.valid.valid) {
            if (this.required && !this.value) {
                this.valid.message = 'Por favor informe';
                this.valid.valid = false;
            }
            /* controle do minLength */
            if (this.minLength > -1 && !this.focused) {
                if (this.value && this.value.length < this.minLength) {
                    this.valid.message = 'Informe no mínimo ' + this.minLength + ' caracteres';
                    this.valid.valid = false;
                }
            }
            /* controle do maxLength */
            if (this.maxLength > -1) {
                if (this.value && this.value.length > this.maxLength) {
                    this.valid.message = 'Informe no máximo ' + this.maxLength + ' caracteres';
                    this.valid.valid = false;
                }
            }
        }
        /* dispara o evento de validação, caso tenha mudado o status */
        if (this.valid.valid !== this._oldValid || this._changed) {
            this._oldValid = this.valid.valid;
            this._changed = false;
            if (this._throwEvent) {
                this.validate.emit(this.valid);
            }
        }
        else {
            this._oldValid = this.valid.valid;
        }
    }
    onKeyUp(event) {
        if (event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) {
            this.status.value = EStatusControl.NONE;
            this._changed = true;
            this.checkValid();
        }
    }
    onFocus(event) {
        this._focused = true;
        this.focus.emit(event);
    }
    setFocus() {
        this._html_ref.focus();
        const href = this._html_ref;
        if (href.select) {
            href.select();
        }
    }
    onChange(event) {
        this.checkValid();
    }
    onBlur(event) {
        if (this._changed) {
            this.checkValid();
        }
        this._focused = false;
        /* controle do minLength */
        if (this.minLength > -1) {
            if (this.value && this.value.length < this.minLength) {
                this.valid.message = 'Informe no mínimo ' + this.minLength + ' caracteres';
                this.valid.valid = false;
            }
        }
        this.blur.emit(event);
    }
    /**
     * Verifica a tecla é um número
     * @param event KeyboardEvent
     * @returns boolean
     */
    isNumberKeys(event) {
        return event.keyCode && ((event.keyCode > 47 && event.keyCode < 58) || (event.keyCode > 95 && event.keyCode < 106));
    }
    /**
     * Verifica a tecla 'backspace' e 'delete'
     * @param event KeyboardEvent
     * @returns boolean
     */
    isDeleteKeys(event) {
        // 8 (backspace) - 46 (delete)
        return event.keyCode && (event.keyCode === 8 || event.keyCode === 46);
    }
    /**
     * Verifica a tecla 'end', 'home', 'arrowLeft', 'arrowUp', 'arrowRight', 'arrowDown'
     * @param event KeyboardEvent
     * @returns boolean
     */
    isNavigationKeys(event) {
        // 35 (end) - 36 (home) - 37 (arrowLeft) - 38 (arrowUp) - 39 (arrowRight) - 40 (arrowDown)
        return event.keyCode && (event.keyCode === 35 || event.keyCode === 36 || event.keyCode === 37 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40);
    }
    /**
     * Verifica as teclas 'ctrl' + 'x'
     * @param event KeyboardEvent
     * @returns boolean
     */
    isCutKeys(event) {
        return event.keyCode && event.keyCode === 88 && (event.ctrlKey || event.metaKey);
    }
    /**
     * Verifica as teclas 'ctrl' + 'c'
     * @param event KeyboardEvent
     * @returns boolean
     */
    isCopyKeys(event) {
        return event.keyCode && event.keyCode === 67 && (event.ctrlKey || event.metaKey);
    }
    /**
     * Verifica as teclas 'ctrl' + 'v'
     * @param event KeyboardEvent
     * @returns boolean
     */
    isPasteKeys(event) {
        return event.keyCode && event.keyCode === 86 && (event.ctrlKey || event.metaKey);
    }
}
MafFormControlComponent.ɵfac = function MafFormControlComponent_Factory(t) { return new (t || MafFormControlComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService)); };
MafFormControlComponent.ɵdir = ɵɵdefineDirective({ type: MafFormControlComponent, inputs: { value: "value", disabled: "disabled", label: "label", placeHolder: "placeHolder", title: "title", dataSet: "dataSet", required: "required", minLength: "minLength", maxLength: "maxLength", status: "status", valid: "valid" }, outputs: { valueChange: "valueChange", validate: "validate", focus: "focus", blur: "blur" } });
class MafInputConst {
}
MafInputConst.maf_input_anim_config = [
    trigger('InOut', [
        state('in', style({ transform: 'translateY(0)', opacity: 1 })),
        transition('void => *', [
            animate(200, keyframes([
                style({ opacity: 0, transform: 'translateY(-100%)', offset: 0 }),
                style({ opacity: 1, transform: 'translateY(2px)', offset: 0.3 }),
                style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 })
            ]))
        ]),
        transition('* => void', [
            animate(200, keyframes([
                style({ opacity: 1, transform: 'translateY(0)', offset: 0 }),
                style({ opacity: 1, transform: 'translateY(3px)', offset: 0.7 }),
                style({ opacity: 0, transform: 'translateY(-100%)', offset: 1.0 })
            ]))
        ])
    ])
];

function MafButtonComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 3);
} }
function MafButtonComponent_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 4);
} if (rf & 2) {
    const ctx_r66 = ɵɵnextContext();
    ɵɵclassMapInterpolate1("fa fa-", ctx_r66.icon, " fa-fw");
} }
const _c0$1 = function (a1, a2, a3, a4, a5) { return { "btn": true, "btn-default": a1, "btn-primary": a2, "btn-success": a3, "btn-danger": a4, "loading": a5 }; };
const _c1$1 = ["*"];
class MafButtonComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
        /* nome do icone a ser exibido conforme class do font-awesome */
        this.icon = '';
        /**
         * tipo do botao
         * default, primary, success, danger
         */
        this.type = 'default';
        /* Indicador se o botão esta executando ... */
        this.loading = false;
        // tslint:disable-next-line: no-output-native
        this.click = new EventEmitter();
        this.isButton = true; /* sinaliza ao form a condição do componente */
    }
    ngAfterViewInit() {
        if (this._elRef) {
            this._html_ref = this._elRef.nativeElement.querySelector('button');
        }
    }
    doClick(event) {
        event.stopPropagation();
        if (!this.loading) {
            this.click.emit(event);
        }
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
}
MafButtonComponent.ɵfac = function MafButtonComponent_Factory(t) { return new (t || MafButtonComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafButtonComponent.ɵcmp = ɵɵdefineComponent({ type: MafButtonComponent, selectors: [["maf-button"]], inputs: { icon: "icon", type: "type", loading: "loading" }, outputs: { click: "click" }, features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c1$1, decls: 4, vars: 10, consts: [["type", "button", 3, "disabled", "ngClass", "click", "focus", "blur"], ["class", "fa fa-spinner fa-pulse fa-fw", "aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], ["aria-hidden", "true", 1, "fa", "fa-spinner", "fa-pulse", "fa-fw"], ["aria-hidden", "true"]], template: function MafButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "button", 0);
        ɵɵlistener("click", function MafButtonComponent_Template_button_click_0_listener($event) { return ctx.doClick($event); })("focus", function MafButtonComponent_Template_button_focus_0_listener($event) { return ctx.onFocus($event); })("blur", function MafButtonComponent_Template_button_blur_0_listener($event) { return ctx.onBlur($event); });
        ɵɵtemplate(1, MafButtonComponent_i_1_Template, 1, 0, "i", 1);
        ɵɵtemplate(2, MafButtonComponent_i_2_Template, 1, 3, "i", 2);
        ɵɵprojection(3);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("disabled", ctx.disabled)("ngClass", ɵɵpureFunction5(4, _c0$1, ctx.type === "default", ctx.type === "primary", ctx.type === "success", ctx.type === "danger", ctx.loading));
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.loading);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.icon && !ctx.loading);
    } }, directives: [NgClass, NgIf], styles: [".btn[_ngcontent-%COMP%]{display:inline-block;margin:2px;padding:6px 9px;border-radius:4px;border:1px solid #ddd;outline:0;background-image:none;color:#555;transition:background .2s ease-in-out,color .15s ease-in-out,border-color .15s ease-in-out,opacity .15s ease-in-out;cursor:pointer;touch-action:manipulation;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:14px;font-weight:400;line-height:1.42857143;opacity:.9;text-align:center;vertical-align:middle}.btn[_ngcontent-%COMP%]:hover{text-shadow:0 -1px 0 rgba(0,0,0,.2);box-shadow:1px 1px 3px rgba(0,0,0,.15);opacity:1}.btn[_ngcontent-%COMP%]:active{box-shadow:0 2px 5px rgba(0,0,0,.3) inset;opacity:1}.btn[_ngcontent-%COMP%]:focus{border-color:#1ab394;outline:0!important;opacity:1}.btn-primary[_ngcontent-%COMP%]{background-color:#18aa90;border-color:#18a689;color:#fff}.btn-primary[_ngcontent-%COMP%]:hover{box-shadow:1px 1px 3px rgba(24,136,97,.4)}.btn-primary[_ngcontent-%COMP%]:focus{border-color:#0e5639}.btn-primary[_ngcontent-%COMP%]:active{box-shadow:0 2px 5px rgba(0,0,0,.2) inset;background-color:#307f60;border-color:#122b40}.btn-default[_ngcontent-%COMP%]{background-color:#fff;color:#666;border-color:#ccc}.btn-default[_ngcontent-%COMP%]:hover{box-shadow:1px 1px 3px rgba(18,43,64,.15);background-color:#efefef}.btn-default[_ngcontent-%COMP%]:focus{background-color:#efefef}.btn-default[_ngcontent-%COMP%]:active{box-shadow:0 2px 5px rgba(0,0,0,.15) inset;background-color:#dfdfdf!important}.btn-success[_ngcontent-%COMP%]{background-color:#1380ef;border-color:#1c84c6;color:#fff}.btn-success[_ngcontent-%COMP%]:focus{border-color:#122b40}.btn-success[_ngcontent-%COMP%]:active{box-shadow:0 2px 5px rgba(0,0,0,.3) inset;background-color:#204d74;border-color:#122b40}.btn-danger[_ngcontent-%COMP%]{background-color:#fff;border-color:#fe5575;color:#ed2545}.btn-danger[_ngcontent-%COMP%]:hover{box-shadow:1px 1px 3px rgba(138,28,25,.4);background-color:#ed2545;border-color:#ed2545;color:#fff}.btn-danger[_ngcontent-%COMP%]:focus{background-color:#ed2545;border-color:#761c19;color:#fff}.btn-danger[_ngcontent-%COMP%]:active{box-shadow:0 2px 5px rgba(0,0,0,.3) inset;background-color:#ac2925;border-color:#761c19;color:#fff}.btn[_ngcontent-%COMP%]:disabled{color:#aaa;background-color:#efefef!important;border-color:#ddd;box-shadow:none!important;opacity:.75!important;cursor:not-allowed;text-shadow:none!important}.loading[_ngcontent-%COMP%]{opacity:.6!important;cursor:not-allowed;box-shadow:none!important}.btn[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-left:-3px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafButtonComponent, [{
        type: Component,
        args: [{
                selector: 'maf-button',
                template: `
    <button type="button"
      [disabled]="disabled"
      [ngClass]="{'btn': true, 'btn-default': type === 'default', 'btn-primary': type === 'primary', 'btn-success': type === 'success', 'btn-danger': type === 'danger', 'loading': loading}"
      (click)="doClick($event)"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
      >
      <i *ngIf="loading" class="fa fa-spinner fa-pulse fa-fw" aria-hidden="true"></i>
      <i *ngIf="icon && ! loading" class="fa fa-{{icon}} fa-fw" aria-hidden="true"></i>
      <ng-content></ng-content>
    </button>
  `,
                styleUrls: ['./maf-button.component.css']
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, { icon: [{
            type: Input
        }], type: [{
            type: Input
        }], loading: [{
            type: Input
        }], click: [{
            type: Output
        }] }); })();

// tslint:disable: no-output-on-prefix
const _c0$2 = ["imageArquivo"];
function CapturaImagensComponent_div_2_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 14);
} }
function CapturaImagensComponent_div_2_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 15);
} }
function CapturaImagensComponent_div_2_img_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "img", 16);
} }
function CapturaImagensComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, CapturaImagensComponent_div_2_i_1_Template, 1, 0, "i", 11);
    ɵɵtemplate(2, CapturaImagensComponent_div_2_i_2_Template, 1, 0, "i", 12);
    ɵɵtemplate(3, CapturaImagensComponent_div_2_img_3_Template, 1, 0, "img", 13);
    ɵɵtext(4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.icone.toLowerCase() === "edit");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.icone.toLowerCase() === "add");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.icone.toLowerCase() === "camera");
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r4.label, " ");
} }
function CapturaImagensComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 17);
} }
function CapturaImagensComponent_div_4_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 19);
    ɵɵlistener("click", function CapturaImagensComponent_div_4_div_9_Template_div_click_0_listener() { ɵɵrestoreView(_r16); const ctx_r15 = ɵɵnextContext(2); return ctx_r15.buscarRedeComercial(); });
    ɵɵelementStart(1, "span");
    ɵɵelement(2, "i", 23);
    ɵɵtext(3, " Rede Comercial");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function CapturaImagensComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 18);
    ɵɵelementStart(1, "div", 19);
    ɵɵlistener("click", function CapturaImagensComponent_div_4_Template_div_click_1_listener() { ɵɵrestoreView(_r18); const ctx_r17 = ɵɵnextContext(); return ctx_r17.addImagemArquivo(); });
    ɵɵelementStart(2, "span");
    ɵɵelement(3, "i", 20);
    ɵɵtext(4, " Arquivo");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 19);
    ɵɵlistener("click", function CapturaImagensComponent_div_4_Template_div_click_5_listener() { ɵɵrestoreView(_r18); const ctx_r19 = ɵɵnextContext(); return ctx_r19.addImagemWebCam(); });
    ɵɵelementStart(6, "span");
    ɵɵelement(7, "i", 21);
    ɵɵtext(8, " WebCam");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(9, CapturaImagensComponent_div_4_div_9_Template, 4, 0, "div", 22);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext();
    ɵɵadvance(9);
    ɵɵproperty("ngIf", ctx_r6.isRedeComercial);
} }
function CapturaImagensComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 21);
} }
function CapturaImagensComponent_i_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 17);
} }
function CapturaImagensComponent_div_11_div_3_div_7_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "option", 41);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const wc_r25 = ctx.$implicit;
    ɵɵproperty("value", wc_r25.id);
    ɵɵadvance(1);
    ɵɵtextInterpolate(wc_r25.label);
} }
function CapturaImagensComponent_div_11_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 38);
    ɵɵelementStart(1, "select", 39);
    ɵɵlistener("change", function CapturaImagensComponent_div_11_div_3_div_7_Template_select_change_1_listener($event) { ɵɵrestoreView(_r27); const ctx_r26 = ɵɵnextContext(3); return ctx_r26.changeCamera($event); });
    ɵɵtemplate(2, CapturaImagensComponent_div_11_div_3_div_7_option_2_Template, 2, 2, "option", 40);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵɵnextContext(3);
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r23.cameras);
} }
function CapturaImagensComponent_div_11_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 30);
    ɵɵelement(1, "video", 31);
    ɵɵelementStart(2, "div", 32);
    ɵɵelement(3, "canvas", 33);
    ɵɵelement(4, "canvas", 34);
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 35);
    ɵɵlistener("click", function CapturaImagensComponent_div_11_div_3_Template_div_click_5_listener() { ɵɵrestoreView(_r29); const ctx_r28 = ɵɵnextContext(2); return ctx_r28.captureImagem(); });
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 36);
    ɵɵlistener("click", function CapturaImagensComponent_div_11_div_3_Template_div_click_6_listener() { ɵɵrestoreView(_r29); const ctx_r30 = ɵɵnextContext(2); return ctx_r30.stopAndCloseBlockWindow(); });
    ɵɵelementEnd();
    ɵɵtemplate(7, CapturaImagensComponent_div_11_div_3_div_7_Template, 3, 1, "div", 37);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵclassProp("active", ctx_r20.showCaptured);
    ɵɵadvance(5);
    ɵɵproperty("ngIf", (ctx_r20.cameras == null ? null : ctx_r20.cameras.length) > 0);
} }
function CapturaImagensComponent_div_11_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 42);
    ɵɵelement(1, "i", 43);
    ɵɵelementEnd();
} }
function CapturaImagensComponent_div_11_div_5_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 48);
    ɵɵelementStart(1, "maf-button", 49);
    ɵɵlistener("click", function CapturaImagensComponent_div_11_div_5_div_6_Template_maf_button_click_1_listener() { ɵɵrestoreView(_r33); const ctx_r32 = ɵɵnextContext(3); return ctx_r32.closeBlockWindow(); });
    ɵɵtext(2, "OK");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function CapturaImagensComponent_div_11_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 44);
    ɵɵelementStart(1, "div", 45);
    ɵɵelementStart(2, "span");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 46);
    ɵɵtext(5);
    ɵɵtemplate(6, CapturaImagensComponent_div_11_div_5_div_6_Template, 3, 0, "div", 47);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵɵnextContext(2);
    ɵɵadvance(3);
    ɵɵtextInterpolate(ctx_r22.dadosAlert.title);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r22.dadosAlert.message, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r22.dadosAlert.okButton);
} }
function CapturaImagensComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 24);
    ɵɵelement(1, "div", 25);
    ɵɵelementStart(2, "div", 26);
    ɵɵtemplate(3, CapturaImagensComponent_div_11_div_3_Template, 8, 3, "div", 27);
    ɵɵtemplate(4, CapturaImagensComponent_div_11_div_4_Template, 2, 0, "div", 28);
    ɵɵtemplate(5, CapturaImagensComponent_div_11_div_5_Template, 7, 3, "div", 29);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r10.showVideoContainer);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r10.carregando);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r10.dadosAlert.visible);
} }
class CapturaImagensComponent {
    constructor(ajax) {
        this.ajax = ajax;
        /**
         * Icone que deve ser exbido para a captura, pode ser 'edit', 'add' ou 'camera'
         */
        this.icone = 'edit';
        /**
         * Label exibe label como Fotos, Capturar ...
         */
        this.label = 'Editar Foto';
        /**
         * Habilita botao para procurar na Rede Comercial
         */
        this.redeComercialUrl = '';
        this.redeComercialParam = '';
        /**
         * O imgPath caminho relativo no servidor onde a imagem deve ser salva
         */
        this.imgPath = '';
        /**
         * O imgPrefix string com prefixo do nome da imagem a ser salva
         */
        this.imgPrefix = '';
        /**
         * O imgAvatar TRUE indica ao servidor que deve cortar a imagem em formato 1:1
         * Quadrado e FALSE o servidor mantem formato 4:3
         */
        this.imgAvatar = false;
        /**
         * Parametro se deve re-dimensionar as imagens upadas TRUE para re-dimensionar
         */
        this.imgResize = false;
        /**
         * Marcar para criar a imagem de fundo - imagem leve - para load rápido
         * TRUE para criar imagem de fundo
         */
        this.criarImagemFundo = false;
        /**
         * Informado as extensoes permitidas para upload
         */
        this.extensoes = [];
        /**
         * Informe o tamanho (em MB) da imagem para o aviso que pode demorar o upload.
         */
        this.maxSizeAlert = 2;
        /**
         * Informe o tamanho maximo (em MB) para o limite da imagem.
         */
        this.maxSizeLimit = 10;
        this.forceUploadBase64 = false;
        /**
         * Emite evento avisando que foi feito upload de imagem retorna {arquivo: 'nome_arquivo'}
         */
        this.onUploaded = new EventEmitter();
        this.onUploadedBase64 = new EventEmitter();
        this.dadosAlert = new DataAlert();
        this.showVideoContainer = false;
        this.showCaptured = false;
        this.cameras = [];
        this.carregando = false;
        this.showMenu = false;
        this.showVideoBlock = false;
        this.isRedeComercial = false;
    }
    ngOnInit() {
        /* inicializa lista de cameras */
        this.getDevices();
    }
    showMenuIMG() {
        this.showMenu = !this.showMenu;
    }
    hideMenuIMG() {
        this.showMenu = false;
    }
    addImagemArquivo() {
        if (!this.carregando) {
            this.showMenu = false;
            this.imageArquivoElementRef.nativeElement.click();
        }
    }
    addImagemWebCam() {
        this.showMenu = false;
        if (this.isCompatibleWebCamNew()) {
            this.menssageAlert('Menssagem', 'Aguardando Permissão do Usuário...', false);
            if (navigator.getUserMedia || navigator.mediaDevices) {
                if (this.cameras.length > 0) {
                    this.initStream();
                }
                else {
                    this.menssageAlert('Erro', 'Não foi encontrado nenhuma webcam!', true);
                }
            }
            else {
                this.menssageAlert('Erro', 'Seu navegador não tem suporte à webcam!\nInstale uma versão mais atual do Mozilla Firefox ou Google Chrome.', true);
            }
        }
        else {
            this.menssageAlert('Erro', 'Erro atualize seu browser para usar o recurso de captura', true);
        }
    }
    initStream() {
        let indexArrayCameras = 0;
        const indexCookie = BrowserUtil.readCookie('webCamSelectedCamera');
        if (this.cameras.length > 1 && indexCookie && Parser.strToInt(indexCookie) >= 0 && Parser.strToInt(indexCookie) <= this.cameras.length) {
            indexArrayCameras = Parser.strToInt(indexCookie);
        }
        else {
            BrowserUtil.createCookie('webCamSelectedCamera', indexArrayCameras + '', 30);
        }
        this.webCamStart(this.cameras.length > 0 ? this.cameras[indexArrayCameras].id : '');
    }
    webCamStart(videoSource) {
        if (navigator && navigator.mediaDevices) {
            this.webCamStop();
            const constraints = {
                audio: false,
                video: { deviceId: videoSource ? { exact: videoSource } : undefined }
            };
            navigator.mediaDevices.getUserMedia(constraints)
                .then(stream => {
                this.getStream(stream);
            });
            this.showVideoBlock = true;
            this.showVideoContainer = true;
        }
    }
    webCamStop() {
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
        }
    }
    getStream(stream) {
        this.stream = stream;
        const videoElement = document.querySelector('video');
        if (videoElement) {
            videoElement.srcObject = stream;
        }
        this.dadosAlert.visible = false;
        /* Refresh button list in case labels have become available */
        return (navigator && navigator.mediaDevices) ? navigator.mediaDevices.enumerateDevices() : undefined;
    }
    menssageAlert(title, message, okButton) {
        this.showVideoBlock = true;
        this.dadosAlert.title = title;
        this.dadosAlert.message = message;
        this.dadosAlert.okButton = okButton;
        this.dadosAlert.visible = true;
    }
    closeAlert() {
        this.dadosAlert.visible = false;
    }
    isCompatibleWebCamNew() {
        const binfo = BrowserUtil.browserInfo();
        return (binfo.browser === BrowserType.CHROME && Parser.strToInt(binfo.version) >= 51)
            || (binfo.browser === BrowserType.FIREFOX && Parser.strToInt(binfo.version) >= 49);
    }
    getDevices() {
        if (navigator && navigator.mediaDevices) {
            navigator.mediaDevices.enumerateDevices()
                .then((deviceInfos) => {
                for (let i = 0; i !== deviceInfos.length; ++i) {
                    const deviceInfo = deviceInfos[i];
                    if (deviceInfo.kind === 'videoinput') {
                        const label = deviceInfo.label || 'camera ' + (i + 1);
                        this.cameras.push(new WebCamInfo('' + deviceInfo.deviceId, '' + label));
                    }
                }
            })
                .catch((error) => console.error(error));
        }
    }
    changeCamera(event) {
        const value = event.srcElement.value;
        BrowserUtil.createCookie('webCamSelectedCamera', value, 30);
        this.webCamStart(value);
    }
    stopAndCloseBlockWindow() {
        this.webCamStop();
        this.closeBlockWindow();
    }
    closeBlockWindow() {
        this.showCaptured = false;
        this.showVideoBlock = false;
        this.showVideoContainer = false;
        this.dadosAlert.visible = false;
    }
    captureImagem() {
        this.carregando = true;
        this.showCaptured = true;
        const canvas = document.getElementById('webCamCaptured');
        const canvasCapturedSave = document.getElementById('webCamCapturedSave');
        /* configurando o tamanho */
        canvas.setAttribute('width', '640');
        canvas.setAttribute('height', '480');
        canvasCapturedSave.setAttribute('width', '1600');
        canvasCapturedSave.setAttribute('height', '1200');
        /* criando contexto para captura */
        const context = canvas.getContext('2d');
        const contextCapturedSave = canvasCapturedSave.getContext('2d');
        /* desenha no canvas */
        context.drawImage(document.querySelector('video'), 0, 0, 640, 480);
        contextCapturedSave.drawImage(document.querySelector('video'), 0, 0, 1600, 1200);
        this.webCamStop();
        /* captura dados do canvas e manda para o backend */
        const imgDataURL = canvasCapturedSave.toDataURL('image/jpeg', 0.7);
        if (this.forceUploadBase64) {
            if (imgDataURL && typeof imgDataURL === 'string' && imgDataURL.length > 0) {
                this.onUploadedBase64.emit(imgDataURL);
                this.carregando = false;
                this.stopAndCloseBlockWindow();
            }
            else {
                this.menssageAlert('Erro', 'Erro ao converter canvas em base64', true);
            }
        }
        else {
            this.postImage(imgDataURL);
        }
    }
    postImage(imgDataURL) {
        const dataReq = { jclass: 'com.macle.web.vo.viewDataUploadBase64', destPath: this.imgPath, prefix: this.imgPrefix, imageBase64: imgDataURL };
        this.ajax.post('upload?action=capturaComponentBase64&isImgAvatar=' + this.imgAvatar + '&destPath=' + encodeURI(this.imgPath) + '&prefix=' + this.imgPrefix, dataReq)
            .then(dataObj => {
            if (dataObj.jclass === 'com.macle.vo.DataException') {
                this.menssageAlert('Erro', dataObj.message, true);
            }
            else if (dataObj.listaArquivo.length > 0) {
                this.onUploaded.emit({ arquivo: dataObj.listaArquivo[0].nomeEmDisco });
                this.stopAndCloseBlockWindow();
            }
            else {
                this.menssageAlert('Aten&ccedil;&atilde;o', 'A lista de arquivo(s) está vazia!', true);
            }
        })
            .catch(error => {
            console.error(error);
            this.menssageAlert('Erro', error.mensagem, true);
        })
            .then(vo => this.carregando = false);
    }
    uploadImagemViaArquivo(event) {
        const file = event.srcElement.files[0];
        event.srcElement.value = '';
        if (file.size > (1024 * 1024 * this.maxSizeLimit)) {
            this.menssageAlert('Atenção', 'O arquivo \'' + file.name + '\' contém ' + Parser.bytesToSize(file.size) + '! Tamanho máximo permitido é de ' + this.maxSizeLimit + ' MB.', true);
            return;
        }
        if (file.size > (1024 * 1024 * this.maxSizeAlert)) {
            this.menssageAlert('Aviso', 'Sua imagem é maior que ' + this.maxSizeAlert + ' MB. Este processo pode ser demorado!', true);
        }
        if (this.forceUploadBase64) {
            this.uploadImagemArquivoViaBase64(file);
        }
        else {
            this.uploadImagemArquivoViaHttp(file);
        }
    }
    uploadImagemArquivoViaBase64(file) {
        const reader = new FileReader();
        reader.onload = () => {
            // console.log('onload:', reader.result);
            if (reader.result && typeof reader.result === 'string') {
                this.onUploadedBase64.emit(reader.result);
            }
            this.showVideoBlock = false;
            this.carregando = false;
            this.closeAlert();
        };
        reader.onerror = () => {
            console.log('onerror:', reader.error);
        };
        reader.onabort = () => {
            console.log('onabort');
        };
        reader.onloadstart = () => {
            // console.log('onloadstart');
        };
        reader.onloadend = () => {
            // console.log('onloadend');
        };
        reader.onprogress = (event) => {
            console.log('onprogress:', Parser.strToInt(((100 * event.loaded) / file.size) + '') + '%');
        };
        reader.readAsDataURL(file);
    }
    uploadImagemArquivoViaHttp(file) {
        let formDataSize = 0;
        let arquivosOK = 0;
        if ((this.extensoes && this.extensoes.length > 0 && this.extensoes.filter(file.type).length > 0) || (!this.extensoes || this.extensoes.length === 0)) {
            formDataSize = formDataSize + file.size + 1000;
            const reader = new FileReader();
            reader.onloadend = () => {
                this.carregando = true;
                const dataReq = { jclass: 'com.macle.web.vo.viewDataUploadBase64', destPath: this.imgPath, prefix: this.imgPrefix, imageBase64: reader.result };
                const urlPost = 'upload?action=uploadComponentImageBase64&destPath=' + encodeURI(this.imgPath)
                    + '&isImgResize=' + this.imgResize
                    + '&isImgAvatar=' + this.imgAvatar
                    + '&criarImagemFundo=' + this.criarImagemFundo
                    + '&maxTamanhoArquivo=' + (10 * 1024 * 1024)
                    + '&maxTamanhoForm=' + formDataSize;
                this.ajax.post(urlPost, dataReq)
                    .then(dataObj => {
                    if (dataObj.jclass === 'com.macle.vo.DataException') {
                        this.menssageAlert('Erro', dataObj.message, true);
                    }
                    else if (dataObj.listaArquivo.length > 0) {
                        this.onUploaded.emit({ arquivo: dataObj.listaArquivo[0].nomeEmDisco });
                    }
                    else {
                        this.menssageAlert('Aten&ccedil;&atilde;o', 'A lista de arquivo(s) está vazia!', true);
                    }
                })
                    .catch(error => this.menssageAlert('Erro', error.mensagem, true))
                    .then(vo => {
                    this.showVideoBlock = false;
                    this.carregando = false;
                    this.closeAlert();
                });
            };
            reader.readAsDataURL(file);
            arquivosOK++;
        }
        else {
            let extPermitidas = '';
            let alertaExtensoes = '';
            if (this.extensoes && this.extensoes.length > 0) {
                for (const ext of this.extensoes) {
                    extPermitidas += ext.replace('image/', '') + ',';
                    alertaExtensoes += '\n.' + ext.replace('image/', '');
                }
            }
            if (arquivosOK === 0) {
                this.menssageAlert('Aten&ccedil;&atilde;o', 'Extensões permitidas:' + alertaExtensoes, true);
                return;
            }
        }
    }
    buscarRedeComercial() {
    }
}
CapturaImagensComponent.ɵfac = function CapturaImagensComponent_Factory(t) { return new (t || CapturaImagensComponent)(ɵɵdirectiveInject(AjaxService)); };
CapturaImagensComponent.ɵcmp = ɵɵdefineComponent({ type: CapturaImagensComponent, selectors: [["maf-captura-imagens"]], viewQuery: function CapturaImagensComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$2, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.imageArquivoElementRef = _t.first);
    } }, inputs: { icone: "icone", label: "label", redeComercialUrl: "redeComercialUrl", redeComercialParam: "redeComercialParam", imgPath: "imgPath", imgPrefix: "imgPrefix", imgAvatar: "imgAvatar", imgResize: "imgResize", criarImagemFundo: "criarImagemFundo", extensoes: "extensoes", maxSizeAlert: "maxSizeAlert", maxSizeLimit: "maxSizeLimit", forceUploadBase64: "forceUploadBase64" }, outputs: { onUploaded: "onUploaded", onUploadedBase64: "onUploadedBase64" }, decls: 12, vars: 6, consts: [["id", "photo-cam"], ["id", "imgCAMDesktop", 3, "click"], [4, "ngIf"], ["class", "fa fa-circle-notch fa-spin fa-fw", "aria-hidden", "true", "title", "Carregando...", 4, "ngIf"], ["id", "menu-up-img", 4, "ngIf"], ["id", "imgCAMMobile", 3, "click"], ["class", "fa fa-camera", "aria-hidden", "true", 4, "ngIf"], ["method", "post", "enctype", "MULTIPART/FORM-DATA", 2, "display", "none"], ["type", "file", "accept", "image/*", 3, "change"], ["imageArquivo", ""], ["id", "webCamBlockWindow", 4, "ngIf"], ["class", "fas fa-pencil", "style", "font-size: 14px;", "aria-hidden", "true", 4, "ngIf"], ["class", "far fa-plus", "style", "font-size: 14px;", "aria-hidden", "true", 4, "ngIf"], ["src", "../img/grey.camera.png", "alt", "Imagem", 4, "ngIf"], ["aria-hidden", "true", 1, "fas", "fa-pencil", 2, "font-size", "14px"], ["aria-hidden", "true", 1, "far", "fa-plus", 2, "font-size", "14px"], ["src", "../img/grey.camera.png", "alt", "Imagem"], ["aria-hidden", "true", "title", "Carregando...", 1, "fa", "fa-circle-notch", "fa-spin", "fa-fw"], ["id", "menu-up-img"], ["id", "item-menu-up-img", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-file-image", 2, "margin", "0 2px"], ["aria-hidden", "true", 1, "fa", "fa-camera"], ["id", "item-menu-up-img", 3, "click", 4, "ngIf"], ["aria-hidden", "true", 1, "fa", "fa-globe", 2, "margin", "0 1px"], ["id", "webCamBlockWindow"], ["id", "webCamBgBlockWindow"], ["id", "webCamContainer"], ["id", "webCamVideoContainer", "class", "webCamBoxEfecct", 4, "ngIf"], ["id", "webCamFloatingCircles", 4, "ngIf"], ["id", "webCamAlert", "class", "webCamBoxEfecct", 4, "ngIf"], ["id", "webCamVideoContainer", 1, "webCamBoxEfecct"], ["id", "webCamStream", "autoplay", ""], ["id", "webCamCapturedContainer"], ["id", "webCamCaptured"], ["id", "webCamCapturedSave", 2, "position", "fixed", "top", "99999px", "left", "99999px"], ["id", "webCamCapture", "title", "Capturar Foto", 3, "click"], ["id", "webCamCloseCapture", "title", "Fechar", 3, "click"], ["id", "webCamSelectCamera", 4, "ngIf"], ["id", "webCamSelectCamera"], [3, "change"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["id", "webCamFloatingCircles"], [1, "fa", "fa-spinner", "fa-pulse", "fa-3x", "webCamFCircle"], ["id", "webCamAlert", 1, "webCamBoxEfecct"], [1, "webCamAlertTitleBar"], [1, "webCamAlertContent"], ["class", "webCamAlertButton", 4, "ngIf"], [1, "webCamAlertButton"], [3, "click"]], template: function CapturaImagensComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵlistener("click", function CapturaImagensComponent_Template_div_click_1_listener() { return ctx.showMenuIMG(); });
        ɵɵtemplate(2, CapturaImagensComponent_div_2_Template, 5, 4, "div", 2);
        ɵɵtemplate(3, CapturaImagensComponent_i_3_Template, 1, 0, "i", 3);
        ɵɵelementEnd();
        ɵɵtemplate(4, CapturaImagensComponent_div_4_Template, 10, 1, "div", 4);
        ɵɵelementStart(5, "div", 5);
        ɵɵlistener("click", function CapturaImagensComponent_Template_div_click_5_listener() { return ctx.addImagemArquivo(); });
        ɵɵtemplate(6, CapturaImagensComponent_i_6_Template, 1, 0, "i", 6);
        ɵɵtemplate(7, CapturaImagensComponent_i_7_Template, 1, 0, "i", 3);
        ɵɵelementEnd();
        ɵɵelementStart(8, "form", 7);
        ɵɵelementStart(9, "input", 8, 9);
        ɵɵlistener("change", function CapturaImagensComponent_Template_input_change_9_listener($event) { return ctx.uploadImagemViaArquivo($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(11, CapturaImagensComponent_div_11_Template, 6, 3, "div", 10);
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !ctx.carregando);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.carregando);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showMenu);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", !ctx.carregando);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.carregando);
        ɵɵadvance(4);
        ɵɵproperty("ngIf", ctx.showVideoBlock);
    } }, directives: [NgIf, ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, NgForOf, NgSelectOption, ɵangular_packages_forms_forms_x, MafButtonComponent], styles: ["#webCamBlockWindow[_ngcontent-%COMP%]{position:fixed;left:0;top:0;width:100%;height:100%;z-index:9900}#webCamBgBlockWindow[_ngcontent-%COMP%]{position:fixed;left:0;top:0;display:block;width:100%;height:100%;background-color:rgba(0,0,0,.4);-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}#webCamContainer[_ngcontent-%COMP%]{position:relative;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}#webCamAlert[_ngcontent-%COMP%]{position:fixed;border-radius:6px;background-color:#fff;top:50%;left:50%;margin:-150px 0 0 -225px;width:450px}@media (max-width:500px){#webCamAlert[_ngcontent-%COMP%]{margin-left:0;left:20px;right:20px;width:auto}}.webCamAlertTitleBar[_ngcontent-%COMP%]{display:inline-block;width:100%;border-bottom:1px solid #c9c9c9;border-radius:10px 10px 0 0;font-size:13px;font-weight:400;color:#333;background:#eaeaea}.webCamAlertTitleBar[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:block;float:left;padding:6px 20px 5px 10px;background:0 0}.webCamAlertContent[_ngcontent-%COMP%]{display:block;padding:18px 20px 20px;text-align:center}.webCamAlertContent[_ngcontent-%COMP%]   .webCamAlertButton[_ngcontent-%COMP%]{padding-top:14px;text-align:right}#webCamVideoContainer[_ngcontent-%COMP%]{position:fixed;display:block;background:#aaa;height:480px;width:640px;top:50%;left:50%;margin:-240px 0 0 -320px}#webCamCapturedContainer[_ngcontent-%COMP%]{top:50%;margin-top:-240px;position:fixed;display:block;height:480px;opacity:0}#webCamCapturedContainer.active[_ngcontent-%COMP%]{opacity:1}#webCamCapturedContainer[_ngcontent-%COMP%]   canvas[_ngcontent-%COMP%]{width:640px;height:480px}#webCamStream[_ngcontent-%COMP%]{z-index:9990;width:640px;height:480px}.webCamBoxEfecct[_ngcontent-%COMP%]{box-shadow:0 0 40px 10px #444}#webCamCapture[_ngcontent-%COMP%], #webCamChooseCamera[_ngcontent-%COMP%], #webCamCloseCapture[_ngcontent-%COMP%]{position:absolute;cursor:pointer;z-index:9999}#webCamCapture[_ngcontent-%COMP%]{width:64px;height:64px;top:400px;left:50%;margin-left:-32px;background:url(data:image/png;base64,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) no-repeat}#webCamCloseCapture[_ngcontent-%COMP%]{width:48px;height:48px;top:10px;right:10px;background:url(data:image/png;base64,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) no-repeat}#webCamChooseCamera[_ngcontent-%COMP%]{width:48px;height:48px;top:10px;left:10px;background:url(data:image/png;base64,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) no-repeat}#webCamFloatingCircles[_ngcontent-%COMP%]{position:fixed;left:50%;top:50%;width:128px;height:128px;margin:-64px 0 0 -64px;transform:scale(.6)}.webCamFCircle[_ngcontent-%COMP%]{position:fixed;font-size:120px;color:#fff;opacity:.5}#webCamSelectCamera[_ngcontent-%COMP%]{position:absolute;top:10px;left:10px;z-index:9999}#menu-up-img[_ngcontent-%COMP%]{color:#777;position:absolute;text-align:left;padding:6px;margin-top:2px;background-color:#fff;border-radius:3px;box-shadow:1px 1px 3px #aaa;cursor:pointer;z-index:10}#item-menu-up-img[_ngcontent-%COMP%]{padding:4px}#item-menu-up-img[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-left:4px}#imgCAMDesktop[_ngcontent-%COMP%]{display:block}#imgCAMMobile[_ngcontent-%COMP%]{display:none}#imgCAMDesktop[_ngcontent-%COMP%], #imgCAMMobile[_ngcontent-%COMP%]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media(max-width:768px){#imgCAMDesktop[_ngcontent-%COMP%]{display:none}#imgCAMMobile[_ngcontent-%COMP%]{display:block}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CapturaImagensComponent, [{
        type: Component,
        args: [{
                selector: 'maf-captura-imagens',
                templateUrl: './captura-imagens.component.html',
                styleUrls: ['./captura-imagens.component.css']
            }]
    }], function () { return [{ type: AjaxService }]; }, { icone: [{
            type: Input
        }], label: [{
            type: Input
        }], redeComercialUrl: [{
            type: Input
        }], redeComercialParam: [{
            type: Input
        }], imgPath: [{
            type: Input
        }], imgPrefix: [{
            type: Input
        }], imgAvatar: [{
            type: Input
        }], imgResize: [{
            type: Input
        }], criarImagemFundo: [{
            type: Input
        }], extensoes: [{
            type: Input
        }], maxSizeAlert: [{
            type: Input
        }], maxSizeLimit: [{
            type: Input
        }], forceUploadBase64: [{
            type: Input
        }], onUploaded: [{
            type: Output
        }], onUploadedBase64: [{
            type: Output
        }], imageArquivoElementRef: [{
            type: ViewChild,
            args: ['imageArquivo']
        }] }); })();
class WebCamInfo {
    constructor(id, label) {
        this.id = id;
        this.label = label;
    }
}
class DataAlert {
}

// tslint:disable: no-output-on-prefix
function EditarImagemComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r39 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 5);
    ɵɵelementStart(1, "i", 6);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_2_Template_i_click_1_listener() { ɵɵrestoreView(_r39); const ctx_r38 = ɵɵnextContext(2); return ctx_r38.fecharEdicao(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function EditarImagemComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r41 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "h1");
    ɵɵtext(2, "O que voc\u00EA quer fazer com esta imagem?");
    ɵɵelementEnd();
    ɵɵelementStart(3, "div", 7);
    ɵɵelementStart(4, "div", 8);
    ɵɵelementStart(5, "div", 9);
    ɵɵelementStart(6, "img", 10);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_4_Template_img_click_6_listener() { ɵɵrestoreView(_r41); const ctx_r40 = ɵɵnextContext(2); return ctx_r40.carregarOriginal(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 11);
    ɵɵelementStart(8, "maf-button", 12);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_4_Template_maf_button_click_8_listener() { ɵɵrestoreView(_r41); const ctx_r42 = ɵɵnextContext(2); return ctx_r42.carregarOriginal(); });
    ɵɵtext(9, "carregar original");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(10, "div", 13);
    ɵɵtext(11, " a imagem ser\u00E1 preenchida com branco at\u00E9 ficar no tamanho correto ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(12, "div", 8);
    ɵɵelementStart(13, "div", 9);
    ɵɵelementStart(14, "img", 14);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_4_Template_img_click_14_listener() { ɵɵrestoreView(_r41); const ctx_r43 = ɵɵnextContext(2); return ctx_r43.continuarEditar(); });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(15, "div", 11);
    ɵɵelementStart(16, "maf-button", 12);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_4_Template_maf_button_click_16_listener() { ɵɵrestoreView(_r41); const ctx_r44 = ɵɵnextContext(2); return ctx_r44.continuarEditar(); });
    ɵɵtext(17, "editar imagem");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(18, "div", 13);
    ɵɵtext(19, " voc\u00EA pode ajustar onde ser\u00E1 o corte para ficar no tamanho correto ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = ɵɵnextContext(2);
    ɵɵadvance(6);
    ɵɵproperty("src", ctx_r36.srcImg, ɵɵsanitizeUrl);
    ɵɵadvance(8);
    ɵɵproperty("src", ctx_r36.srcImg, ɵɵsanitizeUrl);
} }
function EditarImagemComponent_div_0_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 20);
    ɵɵelement(1, "i", 21);
    ɵɵelementStart(2, "p");
    ɵɵtext(3, "carregando imagem");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function EditarImagemComponent_div_0_div_5_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 24);
    ɵɵelementStart(1, "div", 25);
    ɵɵtext(2, "carregando");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function EditarImagemComponent_div_0_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r53 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "image-cropper", 22);
    ɵɵlistener("imageLoaded", function EditarImagemComponent_div_0_div_5_div_2_Template_image_cropper_imageLoaded_1_listener() { ɵɵrestoreView(_r53); const ctx_r52 = ɵɵnextContext(3); return ctx_r52.imageLoaded(); })("imageCropped", function EditarImagemComponent_div_0_div_5_div_2_Template_image_cropper_imageCropped_1_listener($event) { ɵɵrestoreView(_r53); const ctx_r54 = ɵɵnextContext(3); return ctx_r54.imageCropped($event); })("loadImageFailed", function EditarImagemComponent_div_0_div_5_div_2_Template_image_cropper_loadImageFailed_1_listener() { ɵɵrestoreView(_r53); const ctx_r55 = ɵɵnextContext(3); return ctx_r55.loadFailed(); });
    ɵɵelementEnd();
    ɵɵtemplate(2, EditarImagemComponent_div_0_div_5_div_2_div_2_Template, 3, 0, "div", 23);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("imageBase64", ctx_r46.imgBase64)("imageURL", ctx_r46.imgUrl)("maintainAspectRatio", true)("containWithinAspectRatio", ctx_r46.containWithinAspectRatio)("aspectRatio", ctx_r46.aspectRatio)("resizeToWidth", 1600)("resizeToHeight", 1200)("cropperMinWidth", 640)("backgroundColor", "#ffffff")("onlyScaleDown", true)("roundCropper", false)("canvasRotation", ctx_r46.canvasRotation)("transform", ctx_r46.transform)("alignImage", "center");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r46.loadEdicao);
} }
function EditarImagemComponent_div_0_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 26);
    ɵɵelement(1, "img", 27);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("src", ctx_r47.croppedImage, ɵɵsanitizeUrl);
} }
function EditarImagemComponent_div_0_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 28);
    ɵɵelement(1, "i", 29);
    ɵɵtext(2, " Erro ao carregar esta imagem. ");
    ɵɵelementEnd();
} }
function EditarImagemComponent_div_0_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r57 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 30);
    ɵɵelementStart(1, "maf-button", 31);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_5_div_5_Template_maf_button_click_1_listener() { ɵɵrestoreView(_r57); const ctx_r56 = ɵɵnextContext(3); return ctx_r56.rotateLeft(); });
    ɵɵelement(2, "i", 32);
    ɵɵelementEnd();
    ɵɵelementStart(3, "maf-button", 31);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_5_div_5_Template_maf_button_click_3_listener() { ɵɵrestoreView(_r57); const ctx_r58 = ɵɵnextContext(3); return ctx_r58.rotateRight(); });
    ɵɵelement(4, "i", 33);
    ɵɵelementEnd();
    ɵɵelementStart(5, "maf-button", 31);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_5_div_5_Template_maf_button_click_5_listener() { ɵɵrestoreView(_r57); const ctx_r59 = ɵɵnextContext(3); return ctx_r59.flipHorizontal(); });
    ɵɵelement(6, "i", 34);
    ɵɵelementEnd();
    ɵɵelementStart(7, "maf-button", 31);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_5_div_5_Template_maf_button_click_7_listener() { ɵɵrestoreView(_r57); const ctx_r60 = ɵɵnextContext(3); return ctx_r60.flipVertical(); });
    ɵɵelement(8, "i", 35);
    ɵɵelementEnd();
    ɵɵelementStart(9, "maf-button", 31);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_5_div_5_Template_maf_button_click_9_listener() { ɵɵrestoreView(_r57); const ctx_r61 = ɵɵnextContext(3); return ctx_r61.confirmarEdicao(); });
    ɵɵelement(10, "i", 36);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("disabled", ctx_r49.loadEdicao);
    ɵɵadvance(2);
    ɵɵproperty("disabled", ctx_r49.loadEdicao);
    ɵɵadvance(2);
    ɵɵproperty("disabled", ctx_r49.loadEdicao);
    ɵɵadvance(2);
    ɵɵproperty("disabled", ctx_r49.loadEdicao);
    ɵɵadvance(2);
    ɵɵproperty("disabled", ctx_r49.loadEdicao);
} }
function EditarImagemComponent_div_0_div_5_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r63 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 37);
    ɵɵelementStart(1, "maf-button", 12);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_5_div_6_Template_maf_button_click_1_listener() { ɵɵrestoreView(_r63); const ctx_r62 = ɵɵnextContext(3); return ctx_r62.voltarEdicao(); });
    ɵɵelement(2, "i", 38);
    ɵɵelementEnd();
    ɵɵelementStart(3, "maf-button", 12);
    ɵɵlistener("click", function EditarImagemComponent_div_0_div_5_div_6_Template_maf_button_click_3_listener() { ɵɵrestoreView(_r63); const ctx_r64 = ɵɵnextContext(3); return ctx_r64.finalizarEdicao(); });
    ɵɵelement(4, "i", 36);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function EditarImagemComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, EditarImagemComponent_div_0_div_5_div_1_Template, 4, 0, "div", 15);
    ɵɵtemplate(2, EditarImagemComponent_div_0_div_5_div_2_Template, 3, 15, "div", 4);
    ɵɵtemplate(3, EditarImagemComponent_div_0_div_5_div_3_Template, 2, 1, "div", 16);
    ɵɵtemplate(4, EditarImagemComponent_div_0_div_5_div_4_Template, 3, 0, "div", 17);
    ɵɵtemplate(5, EditarImagemComponent_div_0_div_5_div_5_Template, 11, 5, "div", 18);
    ɵɵtemplate(6, EditarImagemComponent_div_0_div_5_div_6_Template, 5, 0, "div", 19);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r37.isLoadingInit);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r37.exibirPreview && !ctx_r37.isError);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r37.exibirPreview && !ctx_r37.isError);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r37.isError);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r37.botaoEdicao);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r37.botaoConfirmacao);
} }
const _c0$3 = function (a0) { return { "blockModal": a0 }; };
const _c1$2 = function (a0) { return { "boxModal": a0 }; };
function EditarImagemComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "div", 1);
    ɵɵtemplate(2, EditarImagemComponent_div_0_div_2_Template, 2, 0, "div", 2);
    ɵɵelementStart(3, "div", 3);
    ɵɵtemplate(4, EditarImagemComponent_div_0_div_4_Template, 20, 2, "div", 4);
    ɵɵtemplate(5, EditarImagemComponent_div_0_div_5_Template, 7, 6, "div", 4);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r34 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(5, _c0$3, ctx_r34.type === "modal"));
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(7, _c1$2, ctx_r34.type === "modal"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r34.type === "modal");
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r34.isOriginal);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r34.isOriginal);
} }
class EditarImagemComponent {
    constructor() {
        this.imageBase64 = '';
        this.imageUrl = '';
        this.croppedImage = '';
        this.canvasRotation = 0;
        this.rotation = 0;
        this.scale = 1;
        this.containWithinAspectRatio = false;
        this.transform = {};
        this.modalEdicao = false;
        this.botaoEdicao = false;
        this.botaoConfirmacao = false;
        this.loadEdicao = false;
        this.exibirPreview = false;
        this.isError = false;
        this.isLoadingInit = true;
        this.isOriginal = false;
        /**
         * Como sera o comportamento (default 'modal')
         * - modal: vai colocar o fundo travado e uma modal com o editor.
         * - component: apenas vai colocar o editor no HTML.
         */
        this.type = 'modal';
        /**
         * A relação largura / altura (1:1), (4:3), (16:9)...
         * O valor é um numero, enão deve colocar "4 / 3" ao invés de "4:3"
         * Valor padrão é 4 / 3
         */
        this.aspectRatio = 4 / 3;
        /**
         * Abre uma tela com uma pergunta se quer carregar a imagem original ou abrir o editor
         */
        this.original = false;
        /**
         * Evento quando confirma a edição
         */
        this.onEditado = new EventEmitter();
        /**
         * Evento quando cancela a edição
         */
        this.onCancelado = new EventEmitter();
    }
    /**
     * Base64 da imagem
     */
    get imgBase64() {
        return this.imageBase64;
    }
    set imgBase64(base64) {
        this.imageBase64 = base64;
        this.modalEdicao = base64.length > 0 && this.imgUrl.length === 0;
        this.initParm();
    }
    /**
     * URL da imagem
     */
    get imgUrl() {
        return this.imageUrl;
    }
    set imgUrl(url) {
        this.imageUrl = url;
        this.modalEdicao = url.length > 0 && this.imgBase64.length === 0;
        this.initParm();
    }
    get srcImg() {
        if (this.imgBase64 != null && this.imgBase64.length > 0) {
            return this.imgBase64;
        }
        if (this.imgUrl != null && this.imgUrl.length > 0) {
            return this.imgUrl;
        }
        return '';
    }
    ngOnInit() {
    }
    initParm() {
        this.isOriginal = this.original;
        this.isError = false;
        this.exibirPreview = false;
        this.botaoEdicao = false;
        this.botaoConfirmacao = false;
        this.canvasRotation = 0;
        this.rotation = 0;
        this.transform = {};
    }
    fecharEdicao() {
        if (!this.loadEdicao) {
            this.limparImagem();
            this.onCancelado.emit('closed');
        }
    }
    carregarOriginal() {
        const img = new Image();
        img.onload = () => {
            let canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.height = img.height;
            canvas.width = img.width;
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);
            this.croppedImage = canvas.toDataURL('image/jpeg', 0.8);
            this.finalizarEdicao();
            canvas = null;
        };
        img.onerror = () => {
            console.error('Erro ao abrir esta imagem');
            this.onCancelado.emit('closed');
        };
        img.src = this.srcImg;
    }
    continuarEditar() {
        this.isOriginal = false;
    }
    confirmarEdicao() {
        if (!this.loadEdicao) {
            this.exibirPreview = true;
            this.botaoEdicao = false;
            this.botaoConfirmacao = true;
        }
    }
    voltarEdicao() {
        this.exibirPreview = false;
        this.botaoEdicao = true;
        this.botaoConfirmacao = false;
    }
    finalizarEdicao() {
        this.modalEdicao = false;
        const copia = this.croppedImage;
        this.limparImagem();
        this.onEditado.emit(copia);
    }
    limparImagem() {
        this.imgBase64 = '';
        this.imgUrl = '';
        this.croppedImage = '';
        this.exibirPreview = false;
        this.botaoEdicao = false;
        this.botaoConfirmacao = false;
    }
    imageLoaded() {
        this.isLoadingInit = false;
        this.botaoEdicao = true;
    }
    imageCropped(event) {
        this.croppedImage = event.base64;
        this.loadEdicao = false;
    }
    loadFailed() {
        this.isError = true;
    }
    flipHorizontal() {
        if (!this.loadEdicao) {
            this.transform = Object.assign(Object.assign({}, this.transform), { flipH: !this.transform.flipH });
        }
    }
    flipVertical() {
        if (!this.loadEdicao) {
            this.transform = Object.assign(Object.assign({}, this.transform), { flipV: !this.transform.flipV });
        }
    }
    rotateLeft() {
        if (!this.loadEdicao) {
            this.loadEdicao = true;
            setTimeout(() => this.rotateLeftLib(), 20);
        }
    }
    rotateRight() {
        if (!this.loadEdicao) {
            this.loadEdicao = true;
            setTimeout(() => this.rotateRightLib(), 20);
        }
    }
    rotateLeftLib() {
        this.canvasRotation--;
        this.flipAfterRotate();
    }
    rotateRightLib() {
        this.canvasRotation++;
        this.flipAfterRotate();
    }
    flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = Object.assign(Object.assign({}, this.transform), { flipH: flippedV, flipV: flippedH });
    }
}
EditarImagemComponent.ɵfac = function EditarImagemComponent_Factory(t) { return new (t || EditarImagemComponent)(); };
EditarImagemComponent.ɵcmp = ɵɵdefineComponent({ type: EditarImagemComponent, selectors: [["maf-editar-imagem"]], inputs: { imgBase64: "imgBase64", imgUrl: "imgUrl", type: "type", aspectRatio: "aspectRatio", original: "original" }, outputs: { onEditado: "onEditado", onCancelado: "onCancelado" }, decls: 1, vars: 1, consts: [["class", "", 3, "ngClass", 4, "ngIf"], [1, "", 3, "ngClass"], ["class", "topo", 4, "ngIf"], [1, "conteudo"], [4, "ngIf"], [1, "topo"], [1, "fal", "fa-times", 3, "click"], [1, "lista-exemplo"], [1, "item-exemplo"], [1, "img-exemplo"], ["alt", "original", 1, "original", 3, "src", "click"], [1, "btn"], [3, "click"], [1, "aviso"], ["alt", "editar", 1, "editar", 3, "src", "click"], ["class", "loading-spin", 4, "ngIf"], ["class", "imagem-final", 4, "ngIf"], ["class", "aviso-erro", 4, "ngIf"], ["class", "edicao", 4, "ngIf"], ["class", "confirmacao", 4, "ngIf"], [1, "loading-spin"], [1, "far", "fa-circle-notch", "fa-spin", "fa-3x", "fa-fw"], ["format", "jpeg", 3, "imageBase64", "imageURL", "maintainAspectRatio", "containWithinAspectRatio", "aspectRatio", "resizeToWidth", "resizeToHeight", "cropperMinWidth", "backgroundColor", "onlyScaleDown", "roundCropper", "canvasRotation", "transform", "alignImage", "imageLoaded", "imageCropped", "loadImageFailed"], ["class", "load-edicao", 4, "ngIf"], [1, "load-edicao"], [1, "load-texto"], [1, "imagem-final"], ["alt", "imagemFinal", 3, "src"], [1, "aviso-erro"], [1, "fas", "fa-exclamation-triangle"], [1, "edicao"], [3, "disabled", "click"], [1, "far", "fa-undo-alt"], [1, "far", "fa-redo-alt"], [1, "far", "fa-arrows-h"], [1, "far", "fa-arrows-v"], [1, "far", "fa-check"], [1, "confirmacao"], [1, "far", "fa-arrow-left"]], template: function EditarImagemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, EditarImagemComponent_div_0_Template, 6, 9, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.modalEdicao);
    } }, directives: [NgIf, NgClass, MafButtonComponent, ImageCropperComponent], styles: [".blockModal[_ngcontent-%COMP%]{display:block;position:fixed;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background:hsla(0,0%,39.2%,.9);z-index:9998}.boxModal[_ngcontent-%COMP%]{position:absolute;width:640px;top:100px;left:50%;margin:0 0 0 -320px;border:1px solid #e7e9ee;border-radius:6px;background:#fff;z-index:9999}@media (max-width:680px){.boxModal[_ngcontent-%COMP%]{width:auto;left:20px;right:20px;margin:0}}.boxModal[_ngcontent-%COMP%]   .topo[_ngcontent-%COMP%]{position:absolute;top:5px;right:4px}.boxModal[_ngcontent-%COMP%]   .topo[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{padding:0 5px;font-size:26px;cursor:pointer}.boxModal[_ngcontent-%COMP%]   .conteudo[_ngcontent-%COMP%]{margin:40px 30px 0}.conteudo[_ngcontent-%COMP%]{position:relative;padding:0 0 5px}.loading-spin[_ngcontent-%COMP%]{padding:20px 0 26px;text-align:center}.loading-spin[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-bottom:10px;color:#999}image-cropper[_ngcontent-%COMP%]{max-height:480px}.load-edicao[_ngcontent-%COMP%]{position:absolute;top:5px;left:5px;right:5px;bottom:10px;background:hsla(0,0%,39.2%,.6)}.load-edicao[_ngcontent-%COMP%]   .load-texto[_ngcontent-%COMP%]{position:absolute;width:100%;top:45%;text-align:center;font-size:20px;color:#333;text-shadow:1px 1px #ccc}.imagem-final[_ngcontent-%COMP%]{padding:5px;text-align:center}.imagem-final[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}.aviso-erro[_ngcontent-%COMP%]{padding:20px 10px 40px;text-align:center;font-size:18px;color:#ff5f22}.aviso-erro[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{padding-right:6px;font-size:20px;color:#ffc107}.boxModal[_ngcontent-%COMP%]   .confirmacao[_ngcontent-%COMP%], .boxModal[_ngcontent-%COMP%]   .edicao[_ngcontent-%COMP%]{padding:0 0 10px}.confirmacao[_ngcontent-%COMP%], .edicao[_ngcontent-%COMP%]{text-align:center}.fa-arrows-v[_ngcontent-%COMP%]{padding-left:3px;padding-right:3px}h1[_ngcontent-%COMP%]{margin:20px 0 30px;text-align:center;font-size:20px;color:#555}.lista-exemplo[_ngcontent-%COMP%]{text-align:center}.item-exemplo[_ngcontent-%COMP%]{position:relative;display:inline-block;width:160px;height:250px;margin:0 20px;text-align:center}.img-exemplo[_ngcontent-%COMP%]{width:162px;height:122px;border:1px solid #999}.img-exemplo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:160px;height:120px;cursor:pointer}img.original[_ngcontent-%COMP%]{-o-object-fit:contain;object-fit:contain}img.editar[_ngcontent-%COMP%]{-o-object-fit:cover;object-fit:cover}.btn[_ngcontent-%COMP%]{margin:10px 0 14px}.aviso[_ngcontent-%COMP%]{position:absolute;width:160px;top:180px;left:1px;right:1px;font-size:11px;color:#aaa}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EditarImagemComponent, [{
        type: Component,
        args: [{
                selector: 'maf-editar-imagem',
                templateUrl: './editar-imagem.component.html',
                styleUrls: ['./editar-imagem.component.css']
            }]
    }], function () { return []; }, { imgBase64: [{
            type: Input
        }], imgUrl: [{
            type: Input
        }], type: [{
            type: Input
        }], aspectRatio: [{
            type: Input
        }], original: [{
            type: Input
        }], onEditado: [{
            type: Output
        }], onCancelado: [{
            type: Output
        }] }); })();

const _c0$4 = ["*"];
class MafSpinComponent {
}
MafSpinComponent.ɵfac = function MafSpinComponent_Factory(t) { return new (t || MafSpinComponent)(); };
MafSpinComponent.ɵcmp = ɵɵdefineComponent({ type: MafSpinComponent, selectors: [["maf-spin"]], ngContentSelectors: _c0$4, decls: 8, vars: 0, consts: [[1, "loading-spin"], [1, "spin-content"], [1, "sk-spinner", "sk-spinner-three-bounce"], [1, "sk-bounce1"], [1, "sk-bounce2"], [1, "sk-bounce3"]], template: function MafSpinComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "p");
        ɵɵprojection(3);
        ɵɵelementEnd();
        ɵɵelementStart(4, "div", 2);
        ɵɵelement(5, "div", 3);
        ɵɵelement(6, "div", 4);
        ɵɵelement(7, "div", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, styles: [".sk-spinner[_ngcontent-%COMP%]{margin:0 auto;width:70px;text-align:center}.sk-spinner-three-bounce[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{width:18px;height:18px;background-color:#1894d7;border-radius:100%;display:inline-block;-webkit-animation:1.4s ease-in-out infinite both sk-threeBounceDelay;animation:1.4s ease-in-out infinite both sk-threeBounceDelay}.sk-spinner-three-bounce[_ngcontent-%COMP%]   .sk-bounce1[_ngcontent-%COMP%]{-webkit-animation-delay:-.32s;animation-delay:-.32s}.sk-spinner-three-bounce[_ngcontent-%COMP%]   .sk-bounce2[_ngcontent-%COMP%]{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes sk-threeBounceDelay{0%,100%,80%{transform:scale(0)}40%{transform:scale(1)}}@keyframes sk-threeBounceDelay{0%,100%,80%{transform:scale(0)}40%{transform:scale(1)}}.loading-spin[_ngcontent-%COMP%]{font-size:16px;color:#1894d7;position:relative;display:flex;align-items:center;justify-content:center;height:85%}.spin-content[_ngcontent-%COMP%]{position:relative}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafSpinComponent, [{
        type: Component,
        args: [{
                selector: 'maf-spin',
                template: `
      <div class="loading-spin">
        <div class="spin-content">
          <p><ng-content></ng-content></p>
          <div class="sk-spinner sk-spinner-three-bounce">
            <div class="sk-bounce1"></div>
            <div class="sk-bounce2"></div>
            <div class="sk-bounce3"></div>
          </div>
        </div>
      </div>
  `,
                styleUrls: ['./maf-spin.component.css']
            }]
    }], null, null); })();

// tslint:disable: no-angle-bracket-type-assertion
class CepMaskDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.el = this.elementRef.nativeElement;
    }
    ngOnInit() {
        this.el.value = Parser.formataCEP(this.el.value);
    }
    onBlur(value) {
        if (Parser.trimToDigits(this.el.value).length > 5) {
            this.el.value = this.formatText(value);
        }
    }
    onKeyUp(event) {
        const value = event.srcElement.value;
        if (value && event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16
            && event.keyCode !== 17 && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37
            && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) {
            if (value.length > 5) {
                const iCaretPos = event.srcElement.selectionStart || 0;
                this.el.value = this.formatText(value);
                if (iCaretPos !== value.length || event.keyCode === 8 || event.keyCode === 46) {
                    event.srcElement.setSelectionRange(iCaretPos, iCaretPos);
                }
            }
        }
    }
    formatText(value) {
        if (value) {
            const newVal = Parser.trimToDigits(value);
            if (newVal.length > 5) {
                return newVal.substring(0, 5) + '-' + newVal.substring(5);
            }
            else {
                return newVal;
            }
        }
        return '';
    }
}
CepMaskDirective.ɵfac = function CepMaskDirective_Factory(t) { return new (t || CepMaskDirective)(ɵɵdirectiveInject(ElementRef)); };
CepMaskDirective.ɵdir = ɵɵdefineDirective({ type: CepMaskDirective, selectors: [["", "mafCepMask", ""]], hostBindings: function CepMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("blur", function CepMaskDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event.target.value); })("keyup", function CepMaskDirective_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); });
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CepMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[mafCepMask]'
            }]
    }], function () { return [{ type: ElementRef }]; }, { onBlur: [{
            type: HostListener,
            args: ['blur', ['$event.target.value']]
        }], onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }] }); })();

// tslint:disable: no-angle-bracket-type-assertion
class CnpjMaskDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.el = this.elementRef.nativeElement;
    }
    ngOnInit() {
        this.el.value = Parser.formataCNPJ(this.el.value);
    }
    onBlur(value) {
        if (value.length === 14) {
            this.el.value = Parser.formataCNPJ(value);
        }
    }
    onKeyUp(event) {
        const value = event.srcElement.value;
        if (value && event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16 && event.keyCode !== 17 && event.keyCode !== 35
            && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) {
            const iCaretPos = event.srcElement.selectionStart || 0;
            const newVal = Parser.trimToDigits(value);
            if (newVal.length > 12) {
                this.el.value = newVal.substring(0, 2)
                    + '.' + newVal.substring(2, 5)
                    + '.' + newVal.substring(5, 8)
                    + '/' + newVal.substring(8, 12)
                    + '-' + newVal.substring(12, 14);
            }
            else if (newVal.length > 8) {
                this.el.value = newVal.substring(0, 2)
                    + '.' + newVal.substring(2, 5)
                    + '.' + newVal.substring(5, 8)
                    + '/' + newVal.substring(8, 12);
            }
            else if (newVal.length > 5) {
                this.el.value = newVal.substring(0, 2)
                    + '.' + newVal.substring(2, 5)
                    + '.' + newVal.substring(5, 8);
            }
            else if (newVal.length > 2) {
                this.el.value = newVal.substring(0, 2)
                    + '.' + newVal.substring(2, 5);
            }
            else {
                this.el.value = newVal;
            }
            if (iCaretPos !== value.length || event.keyCode === 8 || event.keyCode === 46) {
                event.srcElement.setSelectionRange(iCaretPos, iCaretPos);
            }
        }
    }
}
CnpjMaskDirective.ɵfac = function CnpjMaskDirective_Factory(t) { return new (t || CnpjMaskDirective)(ɵɵdirectiveInject(ElementRef)); };
CnpjMaskDirective.ɵdir = ɵɵdefineDirective({ type: CnpjMaskDirective, selectors: [["", "mafCnpjMask", ""]], hostBindings: function CnpjMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("blur", function CnpjMaskDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event.target.value); })("keyup", function CnpjMaskDirective_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); });
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CnpjMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[mafCnpjMask]'
            }]
    }], function () { return [{ type: ElementRef }]; }, { onBlur: [{
            type: HostListener,
            args: ['blur', ['$event.target.value']]
        }], onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }] }); })();

// tslint:disable: deprecation
class CpfMaskDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.el = this.elementRef.nativeElement;
    }
    onBlur(value) {
        this.el.value = Parser.formataCPF(value);
    }
    onInput(event) {
        this.el.value = Parser.formataCPF(event.target.value);
    }
    onKeyUp(event) {
        const value = event.target.value;
        if (value && event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16 && event.keyCode !== 17 && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) {
            const iCaretPos = event.target.selectionStart || 0;
            this.el.value = Parser.formataCPF(value);
            if (iCaretPos !== value.length || event.keyCode === 8 || event.keyCode === 46) {
                event.target.setSelectionRange(iCaretPos, iCaretPos);
            }
        }
    }
}
CpfMaskDirective.ɵfac = function CpfMaskDirective_Factory(t) { return new (t || CpfMaskDirective)(ɵɵdirectiveInject(ElementRef)); };
CpfMaskDirective.ɵdir = ɵɵdefineDirective({ type: CpfMaskDirective, selectors: [["", "mafCpfMask", ""]], hostBindings: function CpfMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("blur", function CpfMaskDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event.target.value); })("input", function CpfMaskDirective_input_HostBindingHandler($event) { return ctx.onInput($event); })("keyup", function CpfMaskDirective_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); });
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CpfMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[mafCpfMask]'
            }]
    }], function () { return [{ type: ElementRef }]; }, { onBlur: [{
            type: HostListener,
            args: ['blur', ['$event.target.value']]
        }], onInput: [{
            type: HostListener,
            args: ['input', ['$event']]
        }], onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }] }); })();

// tslint:disable: deprecation
class CreditCardNumberMaskDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.el = this.elementRef.nativeElement;
    }
    onBlur(value) {
        this.el.value = CreditCard.numberMask(value);
    }
    onInput(event) {
        this.el.value = CreditCard.numberMask(event.target.value);
    }
    onKeyUp(event) {
        const value = event.target.value;
        if (value && event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16 && event.keyCode !== 17 && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) {
            const iCaretPos = event.target.selectionStart || 0;
            this.el.value = CreditCard.numberMask(value);
            if (iCaretPos !== value.length || event.keyCode === 8 || event.keyCode === 46) {
                event.target.setSelectionRange(iCaretPos, iCaretPos);
            }
        }
    }
}
CreditCardNumberMaskDirective.ɵfac = function CreditCardNumberMaskDirective_Factory(t) { return new (t || CreditCardNumberMaskDirective)(ɵɵdirectiveInject(ElementRef)); };
CreditCardNumberMaskDirective.ɵdir = ɵɵdefineDirective({ type: CreditCardNumberMaskDirective, selectors: [["", "mafCreditCardNumberMask", ""]], hostBindings: function CreditCardNumberMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("blur", function CreditCardNumberMaskDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event.target.value); })("input", function CreditCardNumberMaskDirective_input_HostBindingHandler($event) { return ctx.onInput($event); })("keyup", function CreditCardNumberMaskDirective_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); });
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CreditCardNumberMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[mafCreditCardNumberMask]'
            }]
    }], function () { return [{ type: ElementRef }]; }, { onBlur: [{
            type: HostListener,
            args: ['blur', ['$event.target.value']]
        }], onInput: [{
            type: HostListener,
            args: ['input', ['$event']]
        }], onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }] }); })();

// tslint:disable: deprecation
class CreditCardExpirationMaskDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.el = this.elementRef.nativeElement;
    }
    onBlur(value) {
        this.el.value = CreditCard.dateMask(value);
    }
    onInput(event) {
        this.el.value = CreditCard.dateMask(event.target.value);
    }
    onKeyUp(event) {
        const value = event.target.value;
        if (value && event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16 && event.keyCode !== 17 && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) {
            const iCaretPos = event.target.selectionStart || 0;
            this.el.value = CreditCard.dateMask(value);
            if (iCaretPos !== value.length || event.keyCode === 8 || event.keyCode === 46) {
                event.target.setSelectionRange(iCaretPos, iCaretPos);
            }
        }
    }
}
CreditCardExpirationMaskDirective.ɵfac = function CreditCardExpirationMaskDirective_Factory(t) { return new (t || CreditCardExpirationMaskDirective)(ɵɵdirectiveInject(ElementRef)); };
CreditCardExpirationMaskDirective.ɵdir = ɵɵdefineDirective({ type: CreditCardExpirationMaskDirective, selectors: [["", "mafCreditCardExpirationMask", ""]], hostBindings: function CreditCardExpirationMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("blur", function CreditCardExpirationMaskDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event.target.value); })("input", function CreditCardExpirationMaskDirective_input_HostBindingHandler($event) { return ctx.onInput($event); })("keyup", function CreditCardExpirationMaskDirective_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); });
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CreditCardExpirationMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[mafCreditCardExpirationMask]'
            }]
    }], function () { return [{ type: ElementRef }]; }, { onBlur: [{
            type: HostListener,
            args: ['blur', ['$event.target.value']]
        }], onInput: [{
            type: HostListener,
            args: ['input', ['$event']]
        }], onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }] }); })();

// tslint:disable: deprecation
class DataMaskDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.el = this.elementRef.nativeElement;
    }
    onBlur(value) {
        this.el.value = Parser.formataData(value);
    }
    onInput(event) {
        this.el.value = Parser.formataData(event.target.value);
    }
    onKeyUp(event) {
        const value = event.target.value;
        if (value && event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16 && event.keyCode !== 17 && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) {
            const iCaretPos = event.target.selectionStart || 0;
            this.el.value = Parser.formataData(value);
            if (iCaretPos !== value.length || event.keyCode === 8 || event.keyCode === 46) {
                event.target.setSelectionRange(iCaretPos, iCaretPos);
            }
        }
    }
}
DataMaskDirective.ɵfac = function DataMaskDirective_Factory(t) { return new (t || DataMaskDirective)(ɵɵdirectiveInject(ElementRef)); };
DataMaskDirective.ɵdir = ɵɵdefineDirective({ type: DataMaskDirective, selectors: [["", "mafDataMask", ""]], hostBindings: function DataMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("blur", function DataMaskDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event.target.value); })("input", function DataMaskDirective_input_HostBindingHandler($event) { return ctx.onInput($event); })("keyup", function DataMaskDirective_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); });
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DataMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[mafDataMask]'
            }]
    }], function () { return [{ type: ElementRef }]; }, { onBlur: [{
            type: HostListener,
            args: ['blur', ['$event.target.value']]
        }], onInput: [{
            type: HostListener,
            args: ['input', ['$event']]
        }], onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }] }); })();

// tslint:disable: deprecation
class FoneMaskDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.el = this.elementRef.nativeElement;
    }
    onBlur(value) {
        this.el.value = this.formartarMask(value);
    }
    onInput(event) {
        this.el.value = this.formartarMask(event.target.value);
    }
    onKeyUp(event) {
        const value = event.target.value;
        if (value && event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16 && event.keyCode !== 17 && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) {
            const iCaretPos = event.target.selectionStart || 0;
            this.el.value = this.formartarMask(value);
            if (iCaretPos !== value.length || event.keyCode === 8 || event.keyCode === 46) {
                event.target.setSelectionRange(iCaretPos, iCaretPos);
            }
        }
    }
    formartarMask(value) {
        if (value == null || value.length === 0) {
            return '';
        }
        let digitsValue = Parser.trimToDigits(value);
        if (Parser.strToInt(digitsValue.substring(0, 1)) === 0) {
            digitsValue = digitsValue.substring(1);
        }
        let newValue = '';
        if (digitsValue.length > 6) {
            const primeiroNumeroFone = Parser.strToInt(digitsValue.substring(2, 3));
            if (primeiroNumeroFone >= 6 && primeiroNumeroFone <= 9) {
                if (digitsValue.length <= 7) {
                    newValue = '(' + digitsValue.substring(0, 2) + ') ' + digitsValue.substring(2);
                }
                else {
                    newValue = '(' + digitsValue.substring(0, 2) + ') ' + digitsValue.substring(2, 7) + '-' + digitsValue.substring(7, 11);
                }
            }
            else {
                newValue = '(' + digitsValue.substring(0, 2) + ') ' + digitsValue.substring(2, 6) + '-' + digitsValue.substring(6, 10);
            }
        }
        else if (digitsValue.length > 2 && digitsValue.length <= 6) {
            newValue = '(' + digitsValue.substring(0, 2) + ') ' + digitsValue.substring(2);
        }
        else if (digitsValue.length === 1 || digitsValue.length === 2) {
            newValue = '(' + digitsValue;
        }
        return newValue;
    }
}
FoneMaskDirective.ɵfac = function FoneMaskDirective_Factory(t) { return new (t || FoneMaskDirective)(ɵɵdirectiveInject(ElementRef)); };
FoneMaskDirective.ɵdir = ɵɵdefineDirective({ type: FoneMaskDirective, selectors: [["", "mafFoneMask", ""]], hostBindings: function FoneMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("blur", function FoneMaskDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event.target.value); })("input", function FoneMaskDirective_input_HostBindingHandler($event) { return ctx.onInput($event); })("keyup", function FoneMaskDirective_keyup_HostBindingHandler($event) { return ctx.onKeyUp($event); });
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FoneMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[mafFoneMask]'
            }]
    }], function () { return [{ type: ElementRef }]; }, { onBlur: [{
            type: HostListener,
            args: ['blur', ['$event.target.value']]
        }], onInput: [{
            type: HostListener,
            args: ['input', ['$event']]
        }], onKeyUp: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }] }); })();

const _c0$5 = ["*"];
class MafFormComponent {
    constructor(formService) {
        this.formService = formService;
        /* TRUE se todos form-control estão válidos */
        this.valid = true;
    }
    ngOnInit() {
        this.hvalidate = this.formService.validate.subscribe((e) => {
            this.valid = e.valid;
        });
    }
    ngOnDestroy() {
        if (this.hvalidate) {
            this.hvalidate.unsubscribe();
        }
    }
    /**
     * Retorna TRUE se todos componentes estão válidos
     */
    validate() {
        return this.formService.confirmAllValid();
    }
    onKeyEnter(event) {
        this.formService.focusNext();
    }
}
MafFormComponent.ɵfac = function MafFormComponent_Factory(t) { return new (t || MafFormComponent)(ɵɵdirectiveInject(MafFormControlService)); };
MafFormComponent.ɵcmp = ɵɵdefineComponent({ type: MafFormComponent, selectors: [["maf-form"]], features: [ɵɵProvidersFeature([MafFormControlService])], ngContentSelectors: _c0$5, decls: 2, vars: 0, consts: [["onsubmit", "return false;", 3, "keyup.enter"]], template: function MafFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "form", 0);
        ɵɵlistener("keyup.enter", function MafFormComponent_Template_form_keyup_enter_0_listener($event) { return ctx.onKeyEnter($event); });
        ɵɵprojection(1);
        ɵɵelementEnd();
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafFormComponent, [{
        type: Component,
        args: [{
                selector: 'maf-form',
                template: `
    <form (keyup.enter)="onKeyEnter($event)" onsubmit="return false;">
      <ng-content></ng-content>
    </form>
  `,
                providers: [MafFormControlService]
            }]
    }], function () { return [{ type: MafFormControlService }]; }, null); })();

// tslint:disable: no-angle-bracket-type-assertion
function MafInputCepComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r67 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r67.valid == null ? null : ctx_r67.valid.message, ɵɵsanitizeHtml);
} }
const _c0$6 = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c1$3 = function () { return { standalone: true }; };
const _c2 = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
const _c3 = ["*"];
class MafInputCepComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
        this.valueChange.subscribe(() => this.setCep(this.value));
    }
    ngOnInit() {
        this.setCep(this.value);
    }
    setCep(value) {
        if (this.value && Parser.strToInt(value) > 0) {
            this.cep = Parser.formataCEP(value);
        }
    }
    /**
     * controle de caracteres apenas numericos
     */
    onKeyDown(event) {
        const tecla = event.keyCode;
        if (this.isNumberKeys(event)) {
            const element = event.target;
            return Parser.trimToDigits(element.value).length < 8 || element.selectionStart !== element.selectionEnd;
        }
        else {
            return tecla === 0 || tecla === 9 || this.isDeleteKeys(event) || this.isNavigationKeys(event) || this.isCutKeys(event) || this.isPasteKeys(event) || this.isCopyKeys(event);
        }
    }
    onKeyUp(event) {
        if (event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16 && event.keyCode !== 35 && event.keyCode !== 36
            && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) {
            this.status.value = this.status.NONE;
            this._changed = true;
            if (event.target.value.length === 0 || Parser.trimToDigits(event.target.value).length === 8) {
                this.checkValid();
            }
            else {
                this.valid.valid = true;
            }
        }
    }
    checkValid() {
        if (this.cep) {
            if (Parser.trimToDigits(this.cep).length === 8) {
                this.valid = { valid: true, message: '' };
                this.value = Parser.trimToDigits(this.cep);
            }
            else {
                this.valid = { valid: false, message: 'Parece ter algo errado no CEP' };
            }
        }
        else {
            this.valid = { valid: true, message: '' };
            this.value = '';
        }
        super.checkValid();
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onChange(event) {
        super.onChange(event);
    }
}
MafInputCepComponent.ɵfac = function MafInputCepComponent_Factory(t) { return new (t || MafInputCepComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputCepComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputCepComponent, selectors: [["maf-input-cep"]], features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c3, decls: 7, vars: 18, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], ["type", "text", "mafCepMask", "", "pattern", "[0-9]*[.-]*[0-9]*", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "keydown", "keyup", "focus", "change", "blur"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["id", "error", 3, "innerHTML"]], template: function MafInputCepComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("ngModelChange", function MafInputCepComponent_Template_input_ngModelChange_3_listener($event) { return ctx.cep = $event; })("keydown", function MafInputCepComponent_Template_input_keydown_3_listener($event) { return ctx.onKeyDown($event); })("keyup", function MafInputCepComponent_Template_input_keyup_3_listener($event) { return ctx.onKeyUp($event); })("focus", function MafInputCepComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); })("change", function MafInputCepComponent_Template_input_change_3_listener($event) { return ctx.onChange($event); })("blur", function MafInputCepComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, MafInputCepComponent_div_4_Template, 1, 2, "div", 4);
        ɵɵelementStart(5, "span", 5);
        ɵɵprojection(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0$6, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.cep)("ngModelOptions", ɵɵpureFunction0(12, _c1$3))("ngClass", ɵɵpureFunction4(13, _c2, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, DefaultValueAccessor, CepMaskDirective, PatternValidator, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,R0lGODlhEAAQAMQAAP///+7u7t3d3bu7u6qqqpmZmYiIiHd3d2ZmZlVVVURERDMzMyIiIhEREQARAAAAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBwAQACwAAAAAEAAQAAAFdyAkQgGJJOWoQgIjBM8jkKsoPEzgyMGsCjPDw7ADpkQBxRDmSCRetpRA6Rj4kFBkgLC4IlUGhbNQIwXOYYWCXDufzYPDMaoKGBoKb886OjAKdgZAAgQkfCwzAgsDBAUCgl8jAQkHEAVkAoA1AgczlyIDczUDA2UhACH5BAUHABAALAAAAAAPABAAAAVjICSO0IGIATkqIiMKDaGKC8Q49jPMYsE0hQdrlABCGgvT45FKiRKQhWA0mPKGPAgBcTjsspBCAoH4gl+FmXNEUEBVAYHToJAVZK/XWoQQDAgBZioHaX8igigFKYYQVlkCjiMhACH5BAUHABAALAAAAAAQAA8AAAVgICSOUGGQqIiIChMESyo6CdQGdRqUENESI8FAdFgAFwqDISYwPB4CVSMnEhSej+FogNhtHyfRQFmIol5owmEta/fcKITB6y4choMBmk7yGgSAEAJ8JAVDgQFmKUCCZnwhACH5BAUHABAALAAAAAAQABAAAAViICSOYkGe4hFAiSImAwotB+si6Co2QxvjAYHIgBAqDoWCK2Bq6A40iA4yYMggNZKwGFgVCAQZotFwwJIF4QnxaC9IsZNgLtAJDKbraJCGzPVSIgEDXVNXA0JdgH6ChoCKKCEAIfkEBQcAEAAsAAAAABAADgAABUkgJI7QcZComIjPw6bs2kINLB5uW9Bo0gyQx8LkKgVHiccKVdyRlqjFSAApOKOtR810StVeU9RAmLqOxi0qRG3LptikAVQEh4UAACH5BAUHABAALAAAAAAQABAAAAVxICSO0DCQKBQQonGIh5AGB2sYkMHIqYAIN0EDRxoQZIaC6bAoMRSiwMAwCIwCggRkwRMJWKSAomBVCc5lUiGRUBjO6FSBwWggwijBooDCdiFfIlBRAlYBZQ0PWRANaSkED1oQYHgjDA8nM3kPfCmejiEAIfkEBQcAEAAsAAAAABAAEAAABWAgJI6QIJCoOIhFwabsSbiFAotGMEMKgZoB3cBUQIgURpFgmEI0EqjACYXwiYJBGAGBgGIDWsVicbiNEgSsGbKCIMCwA4IBCRgXt8bDACkvYQF6U1OADg8mDlaACQtwJCEAIfkEBQcAEAAsAAABABAADwAABV4gJEKCOAwiMa4Q2qIDwq4wiriBmItCCREHUsIwCgh2q8MiyEKODK7ZbHCoqqSjWGKI1d2kRp+RAWGyHg+DQUEmKliGx4HBKECIMwG61AgssAQPKA19EAxRKz4QCVIhACH5BAUHABAALAAAAAAQABAAAAVjICSOUBCQqHhCgiAOKyqcLVvEZOC2geGiK5NpQBAZCilgAYFMogo/J0lgqEpHgoO2+GIMUL6p4vFojhQNg8rxWLgYBQJCASkwEKLC17hYFJtRIwwBfRAJDk4ObwsidEkrWkkhACH5BAUHABAALAAAAQAQAA8AAAVcICSOUGAGAqmKpjis6vmuqSrUxQyPhDEEtpUOgmgYETCCcrB4OBWwQsGHEhQatVFhB/mNAojFVsQgBhgKpSHRTRxEhGwhoRg0CCXYAkKHHPZCZRAKUERZMAYGMCEAIfkEBQcAEAAsAAABABAADwAABV0gJI4kFJToGAilwKLCST6PUcrB8A70844CXenwILRkIoYyBRk4BQlHo3FIOQmvAEGBMpYSop/IgPBCFpCqIuEsIESHgkgoJxwQAjSzwb1DClwwgQhgAVVMIgVyKCEAIfkECQcAEAAsAAAAABAAEAAABWQgJI5kSQ6NYK7Dw6xr8hCw+ELC85hCIAq3Am0U6JUKjkHJNzIsFAqDqShQHRhY6bKqgvgGCZOSFDhAUiWCYQwJSxGHKqGAE/5EqIHBjOgyRQELCBB7EAQHfySDhGYQdDWGQyUhADs=)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputCepComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-cep',
                template: `
		<div class="field-set">
			<label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
				<input type="text" mafCepMask
					pattern="[0-9]*[\.-]*[0-9]*"
					[(ngModel)]="cep"
					[ngModelOptions]="{standalone: true}"
					[ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
					[placeholder]="placeHolder"
					[title]="title"
					[disabled]="disabled"
					(keydown)="onKeyDown($event)"
					(keyup)="onKeyUp($event)"
					(focus)="onFocus($event)"
					(change)="onChange($event)"
					(blur)="onBlur($event)"
				>
				<div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
				<span class="help-block"><ng-content></ng-content></span>
			</label>
		</div>
	`,
                styleUrls: ['../maf-input.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, null); })();

// tslint:disable: no-angle-bracket-type-assertion
function MafInputCnpjComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r68 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r68.valid == null ? null : ctx_r68.valid.message, ɵɵsanitizeHtml);
} }
const _c0$7 = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c1$4 = function () { return { standalone: true }; };
const _c2$1 = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
const _c3$1 = ["*"];
class MafInputCnpjComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
        this.valueChange.subscribe(() => this.setCnpj(this.value));
    }
    ngOnInit() {
        this.setCnpj(this.value);
    }
    setCnpj(cnpj) {
        this.cnpj = Parser.formataCNPJ(cnpj);
    }
    /**
     * controle de caracteres apenas numericos
     */
    onKeyDown(event) {
        const tecla = event.keyCode;
        if (this.isNumberKeys(event)) {
            const element = event.target;
            return Parser.trimToDigits(element.value).length < 14 || element.selectionStart !== element.selectionEnd;
        }
        else {
            return tecla === 0 || tecla === 9 || this.isDeleteKeys(event) || this.isNavigationKeys(event) || this.isCutKeys(event) || this.isPasteKeys(event) || this.isCopyKeys(event);
        }
    }
    onKeyUp(event) {
        if (event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16 && event.keyCode !== 35 && event.keyCode !== 36
            && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) {
            this.status.value = this.status.NONE;
            this._changed = true;
            if (event.srcElement.value.length === 0 || Parser.trimToDigits(event.srcElement.value).length === 14) {
                this.checkValid();
            }
            else {
                this.valid.valid = true;
            }
        }
    }
    checkValid() {
        if (this.cnpj) {
            if (Cnp.isValidCNPJ(this.cnpj)) {
                this.valid = { valid: true, message: '' };
                this.value = Parser.trimToDigits(this.cnpj);
            }
            else {
                this.valid = { valid: false, message: 'Parece ter algo errado no CNPJ' };
            }
        }
        else {
            this.valid = { valid: true, message: '' };
            this.value = '';
        }
        super.checkValid();
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onChange(event) {
        super.onChange(event);
    }
}
MafInputCnpjComponent.ɵfac = function MafInputCnpjComponent_Factory(t) { return new (t || MafInputCnpjComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputCnpjComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputCnpjComponent, selectors: [["maf-input-cnpj"]], features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c3$1, decls: 7, vars: 18, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], ["type", "text", "mafCnpjMask", "", 1, "form-control", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "keydown", "keyup", "focus", "change", "blur"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["id", "error", 3, "innerHTML"]], template: function MafInputCnpjComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("ngModelChange", function MafInputCnpjComponent_Template_input_ngModelChange_3_listener($event) { return ctx.cnpj = $event; })("keydown", function MafInputCnpjComponent_Template_input_keydown_3_listener($event) { return ctx.onKeyDown($event); })("keyup", function MafInputCnpjComponent_Template_input_keyup_3_listener($event) { return ctx.onKeyUp($event); })("focus", function MafInputCnpjComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); })("change", function MafInputCnpjComponent_Template_input_change_3_listener($event) { return ctx.onChange($event); })("blur", function MafInputCnpjComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, MafInputCnpjComponent_div_4_Template, 1, 2, "div", 4);
        ɵɵelementStart(5, "span", 5);
        ɵɵprojection(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0$7, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.cnpj)("ngModelOptions", ɵɵpureFunction0(12, _c1$4))("ngClass", ɵɵpureFunction4(13, _c2$1, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, DefaultValueAccessor, CnpjMaskDirective, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputCnpjComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-cnpj',
                template: `
		<div class="field-set">
			<label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
				<input type="text" mafCnpjMask
					class="form-control"
					[(ngModel)]="cnpj"
					[ngModelOptions]="{standalone: true}"
					[ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
					[placeholder]="placeHolder"
					[title]="title"
					[disabled]="disabled"
					(keydown)="onKeyDown($event)"
					(keyup)="onKeyUp($event)"
					(focus)="onFocus($event)"
					(change)="onChange($event)"
					(blur)="onBlur($event)"
				>
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
				<span class="help-block"><ng-content></ng-content></span>
			</label>
		</div>
	`,
                styleUrls: ['../maf-input.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, null); })();

// tslint:disable: deprecation
function MafInputCpfComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r69 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r69.valid == null ? null : ctx_r69.valid.message, ɵɵsanitizeHtml);
} }
const _c0$8 = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c1$5 = function () { return { standalone: true }; };
const _c2$2 = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
const _c3$2 = ["*"];
class MafInputCpfComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
        this.valueChange.subscribe(() => this.setCpf(this.value));
    }
    ngOnInit() {
        this.setCpf(this.value);
    }
    setCpf(cpf) {
        this.cpf = Parser.formataCPF(cpf);
    }
    /**
     * controle de caracteres apenas numericos
     */
    onKeyDown(event) {
        const tecla = event.keyCode;
        if (this.isNumberKeys(event)) {
            const element = event.target;
            return Parser.trimToDigits(element.value).length < 11 || element.selectionStart !== element.selectionEnd;
        }
        else {
            return tecla === 0 || tecla === 9 || this.isDeleteKeys(event) || this.isNavigationKeys(event) || this.isCutKeys(event) || this.isPasteKeys(event) || this.isCopyKeys(event);
        }
    }
    onKeyUp(event) {
        if (event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16
            && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38
            && event.keyCode !== 39 && event.keyCode !== 40) {
            this.status.value = this.status.NONE;
            this._changed = true;
            if (event.target.value.length === 0 || Parser.trimToDigits(event.target.value).length === 11) {
                this.checkValid();
            }
            else {
                this.valid.valid = true;
            }
        }
    }
    checkValid() {
        if (this.cpf) {
            let digitsCpf = Parser.trimToDigits(this.cpf);
            if (Parser.trimToDigits(this.cpf).length > 11) {
                digitsCpf = digitsCpf.substring(0, 11);
            }
            if (Cnp.isValidCPF(digitsCpf)) {
                this.valid = { valid: true, message: '' };
                this.value = Parser.trimToDigits(digitsCpf);
            }
            else {
                this.valid = { valid: false, message: 'Parece ter algo errado no CPF' };
            }
        }
        else {
            this.valid = { valid: true, message: '' };
            this.value = '';
        }
        super.checkValid();
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onChange(event) {
        super.onChange(event);
    }
    onInput(event) {
    }
    onPaste(event) {
        console.log('onPaste', event);
        this.checkValid();
    }
}
MafInputCpfComponent.ɵfac = function MafInputCpfComponent_Factory(t) { return new (t || MafInputCpfComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputCpfComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputCpfComponent, selectors: [["maf-input-cpf"]], features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c3$2, decls: 7, vars: 18, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], ["type", "text", "mafCpfMask", "", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "keydown", "keyup", "focus", "change", "blur", "input", "paste"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["id", "error", 3, "innerHTML"]], template: function MafInputCpfComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("ngModelChange", function MafInputCpfComponent_Template_input_ngModelChange_3_listener($event) { return ctx.cpf = $event; })("keydown", function MafInputCpfComponent_Template_input_keydown_3_listener($event) { return ctx.onKeyDown($event); })("keyup", function MafInputCpfComponent_Template_input_keyup_3_listener($event) { return ctx.onKeyUp($event); })("focus", function MafInputCpfComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); })("change", function MafInputCpfComponent_Template_input_change_3_listener($event) { return ctx.onChange($event); })("blur", function MafInputCpfComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); })("input", function MafInputCpfComponent_Template_input_input_3_listener($event) { return ctx.onInput($event); })("paste", function MafInputCpfComponent_Template_input_paste_3_listener($event) { return ctx.onPaste($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, MafInputCpfComponent_div_4_Template, 1, 2, "div", 4);
        ɵɵelementStart(5, "span", 5);
        ɵɵprojection(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0$8, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.cpf)("ngModelOptions", ɵɵpureFunction0(12, _c1$5))("ngClass", ɵɵpureFunction4(13, _c2$2, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, DefaultValueAccessor, CpfMaskDirective, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputCpfComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-cpf',
                template: `
    <div class="field-set">
      <label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
        <input type="text" mafCpfMask
          [(ngModel)]="cpf"
          [ngModelOptions]="{standalone: true}"
          [ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
          [placeholder]="placeHolder"
          [title]="title"
					[disabled]="disabled"
          (keydown)="onKeyDown($event)"
          (keyup)="onKeyUp($event)"
          (focus)="onFocus($event)"
          (change)="onChange($event)"
          (blur)="onBlur($event)"
          (input)="onInput($event)"
          (paste)="onPaste($event)"
        >
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
        <span class="help-block"><ng-content></ng-content></span>
      </label>
    </div>
	`,
                styleUrls: ['../maf-input.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, null); })();

// tslint:disable: deprecation
const _c0$9 = function (a1) { return ["flag", a1]; };
function MafInputCreditCardNumberComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 1);
} if (rf & 2) {
    const ctx_r70 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(1, _c0$9, ctx_r70.creditCardFlag));
} }
function MafInputCreditCardNumberComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 8);
} if (rf & 2) {
    const ctx_r71 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r71.valid == null ? null : ctx_r71.valid.message, ɵɵsanitizeHtml);
} }
const _c1$6 = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c2$3 = function () { return { standalone: true }; };
const _c3$3 = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
const _c4 = ["*"];
class MafInputCreditCardNumberComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
        this.flag = new EventEmitter();
    }
    ngOnInit() {
        this.creditCardNumber = CreditCard.numberMask(this.value);
        this.getCreditCardFlag();
    }
    getCreditCardFlag() {
        this.creditCardFlag = CreditCard.getFlagByNumber(this.creditCardNumber);
        this.flag.emit(this.creditCardFlag);
    }
    /**
     * controle de caracteres apenas numericos
     */
    onKeyDown(event) {
        const tecla = event.keyCode;
        if (this.isNumberKeys(event)) {
            const element = event.target;
            return Parser.trimToDigits(element.value).length <= 16 || element.selectionStart !== element.selectionEnd;
        }
        else {
            return tecla === 0 || tecla === 9 || this.isDeleteKeys(event) || this.isNavigationKeys(event) || this.isCutKeys(event) || this.isPasteKeys(event) || this.isCopyKeys(event);
        }
    }
    onKeyUp(event) {
        if (event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16
            && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38
            && event.keyCode !== 39 && event.keyCode !== 40) {
            this.status.value = this.status.NONE;
            this._changed = true;
            this.valid.valid = true;
            this.getCreditCardFlag();
        }
    }
    checkValid() {
        this.getCreditCardFlag();
        this.valid = { valid: true, message: '' };
        this.value = Parser.trimToDigits(this.creditCardNumber).substring(0, CreditCard.maxLenghtNumberCard(this.creditCardFlag));
        super.checkValid();
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onChange(event) {
        super.onChange(event);
    }
    onPaste(event) {
        this.creditCardNumber = CreditCard.numberMask(event.clipboardData.getData('text'));
        this.checkValid();
    }
}
MafInputCreditCardNumberComponent.ɵfac = function MafInputCreditCardNumberComponent_Factory(t) { return new (t || MafInputCreditCardNumberComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputCreditCardNumberComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputCreditCardNumberComponent, selectors: [["maf-input-credit-card-number"]], outputs: { flag: "flag" }, features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c4, decls: 9, vars: 19, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], [1, "box-flag"], ["type", "text", "mafCreditCardNumberMask", "", "name", "cardNumber", "autocomplete", "cc-number", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "keydown", "keyup", "focus", "change", "blur", "paste"], [3, "ngClass", 4, "ngIf"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["id", "error", 3, "innerHTML"]], template: function MafInputCreditCardNumberComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "input", 4);
        ɵɵlistener("ngModelChange", function MafInputCreditCardNumberComponent_Template_input_ngModelChange_4_listener($event) { return ctx.creditCardNumber = $event; })("keydown", function MafInputCreditCardNumberComponent_Template_input_keydown_4_listener($event) { return ctx.onKeyDown($event); })("keyup", function MafInputCreditCardNumberComponent_Template_input_keyup_4_listener($event) { return ctx.onKeyUp($event); })("focus", function MafInputCreditCardNumberComponent_Template_input_focus_4_listener($event) { return ctx.onFocus($event); })("change", function MafInputCreditCardNumberComponent_Template_input_change_4_listener($event) { return ctx.onChange($event); })("blur", function MafInputCreditCardNumberComponent_Template_input_blur_4_listener($event) { return ctx.onBlur($event); })("paste", function MafInputCreditCardNumberComponent_Template_input_paste_4_listener($event) { return ctx.onPaste($event); });
        ɵɵelementEnd();
        ɵɵtemplate(5, MafInputCreditCardNumberComponent_div_5_Template, 1, 3, "div", 5);
        ɵɵelementEnd();
        ɵɵtemplate(6, MafInputCreditCardNumberComponent_div_6_Template, 1, 2, "div", 6);
        ɵɵelementStart(7, "span", 7);
        ɵɵprojection(8);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(10, _c1$6, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("ngModel", ctx.creditCardNumber)("ngModelOptions", ɵɵpureFunction0(13, _c2$3))("ngClass", ɵɵpureFunction4(14, _c3$3, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.creditCardFlag !== "");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, DefaultValueAccessor, CreditCardNumberMaskDirective, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}", ".form-control[_ngcontent-%COMP%]{padding-right:42px}.box-flag[_ngcontent-%COMP%]{position:relative}.box-flag[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{z-index:2}.flag[_ngcontent-%COMP%]{position:absolute;top:4px;bottom:4px;right:4px;width:36px;height:auto;background-size:contain;background-repeat:no-repeat;background-position:center;z-index:3}.amex[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAfCAMAAACS025rAAAAjVBMVEUkeLz///8WdLoper1/p9GBrtYAb7i71OkadbuzzuYAbrgzfr8KcbkAbLexx+GMr9Xy9/tonM3W5fI7hsOcvd3r8/nM3u5xpNFUkMelwd5dl8vV5PGWuds1hMLv9Pn4+/3i7PXE2OtGi8UAZLRwn8610OdckshwptJnn8+StNhfms2fweDC0+gAYLKQstc8ZNUBAAAAAWJLR0QAiAUdSAAAAXZJREFUOMvtlNFqxSAMhnuYN6OQtmpDQsSm4hEK0vd/vGUbg46dmwPb3X6qDb/9aqOpA5bhKRUcniSG54F/mU6ACQCWAhdFM+NHZGPxAGjXdV4TZ02AsCfpKaU1psS67xukjglzT5pB3QWx95D4UDRTu8ckMocu7mRmh74dbUulbgtekHElZOcJzu7OewxEa3CnebwgYsuECSp8Q2K3p8ZXyiN5QyDnLXQ/2SQT50pU6gEayhVRh7pyrTeebrEzEWnTe2ewz29LlrXVnoHkgnjBcfEi6L1dFoi1ZJHvuwgPYMZhrf7uNnV5l3Mft91/dd7mFEQLfiLaLJ+qWi33pXeixmJOh2aueY+QgLZ1tQLwthdIG477ojqPXWdwut4eIUuFudAGVClCaCFiqFV6pcUWccRHiGXj4jFxXHWFmH3BJpIF+4si1vsDxEosgSrHnV8idpijN0c4RZT3kZ/IZ/2WZl0dLCP3rbyB6f/fH/78iC3D8yf/G+BoMa4nE75KAAAAAElFTkSuQmCC)}.aura[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAhCAMAAACsowi2AAAA2FBMVEXy5SQbLYLCHDXnxim7HDvr3yygmmTHvk7n2zHShDDUii/qzSciMYBhYniNiWyMJWOkn2KvqF6+tVfDulPOxEvaz0Td0kDg1TrCHzTZnC7boy3erSwxLH5ZXHlranZvbnV5d3KBf29yKG+noGKfIlfFvFOtIEvSyEjk2TXGQTPNazHXlS/cpi3iuSvhtyvfsSvkvyru4ijv4yXw3iVBSH05OH1WWHtNUXtGK3pYKndtLXGSjmqXkmmdmGSkIVPWy0Xs1iaFJmedI1nENjTIUjPKXzLPdjHkyi6OpvwQAAABJUlEQVQ4y+3O1W6DAACF4VPBi1MB6m5Y3dv5+7/RSEeWspQBu1z6X58vOcik7v+TekehKIWsJSaNAYK0ejJy8PCdRyYhAkId48mKCBOCjyUKfqT+Tqrbne1MDX3CMgzDTnTDtHIfywiyaYvP/Xz2bvl+V2xvbkl1J55C4wh4etoWrkTsZ5OX77arGaQAgQqRymjMTAzTdnPXXMuZ6sx4VAkjBOM3dupyc9xtztn6+8steWVNfxwb57CjL2JdkDzOGFeySNvFRLhhGSmja/w5JdnLGk8AsyYNtMooCXuBICTyKMhRglqfi62DTzJDYFFCceH7IVXU5ELUrbXS6/VWKmaFMrylT2oA1Lo6oKKI1IGf1qDRaZFkwz/WBDBoSrLE03j05z4Bmigck/p7AxYAAAAASUVORK5CYII=)}.diners[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAgCAMAAABXc8oyAAAAwFBMVEUAAAAAeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb4Aeb7///8Aeb57oc6NrtTR3Ovi6fLf5vH1+Pvo7fXY4e7G1OemvNtpl8o8hcIof8Ds8ffM2Omswd2btdeGqNFgk8g3gsERe7/v8/i3yuKUsdZ0ncxFiMT5+vy+zeOzxt+Kq9KApM92ns1Xj8ZMi8UbfMAKer6F0zfeAAAAGnRSTlMAzMKwVA77472KYRipdEIt8aGWjmwf2dOAO3iLqpQAAAGYSURBVDjLjZTZeoIwEEZHUQH3XcsoihsoCri17n3/t6plMkJSL3puyMccsvwkgRS1SiOToJm5PLwh39fxOPR3O39/Q0FBq4JKpe7Nx5Zg4rvsZmuSVsriemulcPxXrxVI6OihbSmMj6w2kv50d2T9YRuwWWbR8MhTWLps9slr44wqn2J826HnFJmPOJf6Rby/D6gxdFfUWLPYi4NBGniFyCLiiab5YDP3FLtUHkdpEW25yyxATcxwgZJ4dORZlqCIy3gBKIv4FS/vm8UiNN24uFfFQ9w8sNgCjap3VUT+nkPPUBVVkWY0ZzHzf1G7xsWbKkbc5KGbHiWmihsOjTCf8UwoMVmkdB1Mfk2HErMGshjQ9mCvkAfILGj7h2kxomNxZlEDeI49pZ8dJmK0oo/lfdZdiCN1YDEQx2yTdPhLFU8WMeIHMWOv3oGYFm0qlZGXLFlgPOw3XsheO7klDNyp3szjZIqQwsTrOK1NXuvQlVul2sPLyiHLsYevoFt5UMkZiMFmPj8vkNHNEryjlDMbRlZQbral++kHfJBwTuxCZj0AAAAASUVORK5CYII=)}.discover[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAICAMAAACMAFxIAAABLFBMVEUAAAAGBwkFBwYGBwgFBwgFBwYDBggICAwFBwcFBwkFBgkEBwkFBwcFBwgGBwsDCAwGBwkFBwoFBwYFBwcGBwcFBgsFBwkFBwoEBgkFBwcFBwYGBgkECAcEBwkFBwgFBwYFBwkEBwoFCAgaCQwGBwsGCAgFBwcGCAgHBQ4WBREFCAkFCAcOBwn1ax8DCAYBCQgDCAipOCX6mSkHBwgECAcFCAkGBwuTLRClOh/pfRoOBgbvfybSTRz9mx3FRyj+nB2pPyMHBggSBxT+lyQEBRmpOSjRVyQPBAX5liIUBRLsWif+nB6pOBgHBwdAHg77oiS1QCzfeirKWR/vhyP/nCTqbiPlWyv0iyH6kx/dWy73Yyr+mCTtfiTwhSLwYxzsZir0cyjrYiXneCDugBlSNVipAAAAVXRSTlMAB/fn0KWHDT3v4MjFu/bDMiS2in1lYCwoHP77+bKpoJCBaxHNnZqVhVVENhj+++K8qpNxcVJKHxAJ7+zo5+bb2Na/vLy7uLewlpWGgnZeXFhRNjQUyd08GAAAAUVJREFUGNM9zgVywkAABdC/wsaFCAnuTt3d3QVvqd3/DoXC9ABv5gEu5+k6kRZXpTLjPoivsZKMjduzpcetq2MJiJXWLc61QOO6G49EAURYVZ8X0oLIp9xcjdSShucUNg77nU7n+j5VB+GlQDFybkCNMq02pAmxiJRNNRdElq4DgRkhIK2l/tdoNDf3pF6gYRaiSgyIUw9cByZEJ2imCqqQmWnJflIGsLk/+Gi32z/LYjsss1ZUYapm04wwc/9ETvqqQPyOsZUp2R20v9/eu8uhmWNVRJXMaiGkSqIiAbNYxgxVYbfgJWQ6iRXPP8egN3xAOkFtzGIu14tTwrKcrkhqTeNCPSrm5638af15p9vrDU+2sJZwyJhokWxA8w1a+SOe4VRkkIxvG2zRBolZTLPxcrl3cPMKFPU1IJ42jHToxOA5TeAX+PUn6Z6uZ1QAAAAASUVORK5CYII=)}.elo[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAATCAMAAADlEa4QAAAA4VBMVEUAAAAjHyAjHyAjHyAjHyAjHyAjHyAjHyA4p+QjHyAjHyAjHyAjHyA4p+QjHyAjHyAjHyAjHyA4p+QjHyAjHyA4p+QjHyD7xwc4p+T2gxMjHh/7xwfvMSAjHyD7xwcjHyAjHyAjHyD7xwcjHyDvMSA4p+TvMSAjHyDvMSD7xwfvMSD7xwf7xwfvMSAjHyA4p+T7xwfvMSA4p+Q4p+TvMSAjHyDvMSA4p+Q4p+TvMSD7xwcjHyAjHyDvMSAjHyDvMSD7xwfvMSAjHyDvMSD7xwf7xwf7xwcjHyDvMSD7xwc4p+QcxonFAAAAR3RSTlMA65n1PB/fCfejXUQUCdfCb1LGkoWEZR0bCAXj4s3Itox3PzAe0su7ubmurqSjnIyDglRNS0o/PS4pKSgZFhH19cOndXRNFIY3cn0AAAF1SURBVCjPjZLZUsJAEEUvZAOBQAQRkB1kR0EBZXPXHvj/D7I7CSmMZcl5SKp66kxP3xl4NKsvu111ssLpXO48Rl84hcI9gKrvXF0izFleD1VS57EH4GP3pxOhaKhyu9/HHlEsAs2+OP1/lcKeuYDHRJymd5wukZlLHil5jcy6FC7YuE7BZ8jKEEycXCL6QdHROhTOWbnDgRUPMwKQ48VcJs3fpChSOMNbPEKkGYixkkLApzt9UqO0xT+TKOsqG5ZLQClKFMee+Z0rUQK6HM7Ou0qGuItga7Vwl9kWTJYoU2GhO/fH590NCE8Iz7JUqjwGGsRo2XUQcp2o5fV3jFBiA6XUAEhwwBneMGn4iiMzMAYH/fNepopZSMYOEhb0ipYXpWaVTKqUNpZj8omPb3/WE6MHQRoJaSAtyeq2YWluIXhj78qn3IZLjYQbC2jZZINxvELwkjshA5jXow3D75gAo2ejjTUC2r4x3uJUFq/PSnWmS5zAN2HrTbiMTIboAAAAAElFTkSuQmCC)}.hipercard[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAWCAMAAAC13D+jAAAArlBMVEUAAADhw8P////Yra7ZsbH16+zjx8jv4eH////////////btrbq19fo0tL////Kiovx4+P17Oz06+yzExvWqqvFfX6/Y2XCcHG7UlTy5+fMkZL58vLo0tLlzMzu3t7cuLjZsrLw4uO3PT/////69vbq1tfIg4Tjx8fevb3Vp6e6SUv9+/v17Ozfv8DToqPQm5zOlJXDdHa9V1nJiInr2NjAaWq9XF65QkW2LjK0HCKLhce0AAAAE3RSTlMArkXg13CjezsUC+nlmSj1eT09cU/N+AAAAWBJREFUOMuVz1du4zAARdEkdnqZctlFtajL3U7d/8ZG0iTRnyGfHwIEH4h7Nnh6nIupHobFny3TnQ+Te05w3S9uFNOZi35yyQncbT+54gSzIWXOswSU6o6jDruv+rsNhwUQxY3nqGIDv/vJhUKkQO6U6T7SgJR8aqPZye5CKozSBrlbat6+68NCyjLbWxf5JGhUlPhCBoVIq3hdrpLAxZFfL+PVAjZ3/eQcIi9ElZObwCC8L5rarlPiCrrMMnI+IV0jLcyH+hnkJSSpCd5ziMPcSanr7pWD/TIRC2VfTfZBE8JVv7jdorIWwtBFpYXUZQZ4cdgDiBC9IENm4BO4HOoN2wCwIq5EEBchka29Cl5Z2Xq1DeoXKy2fQVgtBeqmn1xDqwDd7ttQSA1oafh/PqN3H6pVfdPb/v2nfmRLjhnrR43hmO96x2Rj/XT6q/4E92dj/TS//g6TBzHV7PFpWPwDMlBW+fGsQgkAAAAASUVORK5CYII=)}.jcb[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAnCAMAAAB6+uurAAABfVBMVEUAAAD///////////////////////////////8AaLTr8urM1OcESY8JQ4nqfIUSOH4ATpUOPYRWsjIXMnnLDzROrjTDFTS7GTOxHDLo6OscLHMIiz4Rjz0alDzaBTbTCjXgAjenHjKdITEAXaYAWKAjmDssnTo1oTg+pjcAYqwAU5sAhj9GqjaTJDGJJzCdgYIAgj8AfUB9KTDn7umzx7nM0NrM18/L0uDM3M6rs8qjttbpzM3izM329/n5+ffP4NB8qYbxzM/x8/fx9fL12dvQ5M7Zzc3urLHIfoPr7vT48PDs4+TY2uLh2NjB18K61bquy7F8iq6Xx5DVT13v7Oz46erQ1ePu3N3V5dTl0tO9vsqLosqBnMnvvL/JtbbHp6lygqjrm6CRuJepi4y9f4PQd36oYWZ0umRZr02sPUjm4eHf697L4chvjL1hhr0dbrhZdqmivqiIjaeiy55ka5KGqZDoh442T4tVW4Z+sYVhmXHZYm1DnlGFREifLzuw2gV2AAAACHRSTlMA3q49C+S0pWlD5bYAAAHJSURBVDjL7dNnU+pAFIBhiuWI93KrvfdeYwANIagUUUCKvffee//tnrODY05mQPju+2V3M/PMcMjGRFkt+ZB9CPIKIKdQmHFRw7JTVBwCasrtVpRRzCeO45rLpWma3+/3ELHgo+H7nz9+dzY3dRQVFeMxstfYUF5W+r+utt5OYKuquqalta29u+SvDYkVn139+qMngd4ePRl/6uKkEGDpHyMzr5zc9hsITvLAydogI9KAkQBUVHLSx4njm2RD3nYmJna/JsOAjSDZDkyCaNJnt4MqfTR9kI4cATWvzCMM2mlvkyQbrQvpCLV4SLM8r24K4sUf5qJNBjLFbrIg07h6MpA1TqKxWJTW6wxknZNUOH7W5NLrfdToW9s3EBmwlXSzvNDmJEVg6YbIBmDquSDgPiSSDH7+Y1u08acIFpLlsNis0FdJG8+ioszq3osEVCJF1PAYiNS5U3FhtiMeAOF8d/rxjxP68Tfi8fiF7o7t0R1LilmGcrrJ3yQbEuIkyMk+gNlIloGTWU6iAIUGcjbGySowkgAAKyfLKHQkOQqMxPBoMSFRZZHTOYcAiwQCbkxRfOIoORwuSlugm2fOQ5JTBShyIfkWqwl7B/qny+3Kyc7uAAAAAElFTkSuQmCC)}.master[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAfCAMAAACS025rAAAAflBMVEUAAAD3nhvrABvrABv3nhvrABv3nhv3nhv3nhvrABv3nhvrABv3nhvrABv3nhvrABv3nhvrABvrABvrABv5kRbwLxb3nhvrABv3nhv3nhvrABv3nhvrABv3nhvrABv/XwD9eQz5TQz+bgb8VQbtGRn5khfwLhf6ihPzOhP+ZgMFpWJzAAAAHXRSTlMAy8u2XFzZuHp69fUwMCkpHx/b1vX1wsKwZmZDQznVapoAAADNSURBVDjLvdTZEoIwDAXQAMomyOauSd3R//9BURmwpNPRPHjeO0na5kIvjbySiCovKqCVhysfEf0gTIAbu9Rb7qCxXWDPGYEuc0nnFXmAOmeqlZjQ0HyGQ/FHoQ0xN6VqZNZdDWKuqnFBpq2T8a7O6umOTPyexyXmoF72yDi2tiytmYvYyqRkmKSDXAKR6YI7NTIheMa+LJ0FUBJzUp0jMj7Qr0fwP0cEswhuTPAugtcX/DHBTxbsi2ArBbsvSBhBjgnSUpjJffJX3yT/A6n+lcJ72A1kAAAAAElFTkSuQmCC)}.visa[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAPCAMAAACRBWzwAAAAjVBMVEUAAAAAV6AAV6AAV6AAV6AAV6AAV6AAV6AAV6AAV6AAV6AAV6AAV6AAV6AAV6AAV6D6phoAV6AAV6AAV6AAV6AAV6AAV6AAV6AAV6AAV6D6phoAV6D6phoAV6AAV6D6phr6phoAV6D6php1a5KpgH76phrnnEr6phoAV6D6phrUk183XJ1OYJrHjWvsn0BkYwgUAAAAKHRSTlMAzJlbCUeuPRPr4B65wmbWzKOFeyj18o9xMgvGwqmCgFxS1q+ro3pIhQWnBwAAAUlJREFUKM9FkdmagjAMhdPSYhGFQcBtXGcNzvL+j+dJSr/+F+1JjE1OoOvpRbgeSVgZY7yeNaJwWY/M7Vk0uQ2yHQnH22kCN9GemSsXGCBqRo4cCOxU0szH/zR9iiiR3NECpyEqOKFNKpULihQ/j+kNtz4fqMFpiaSmqyn4DYE9K73oWPo3wUwvRUQW157qOFJiybxGokyxYX58Ix07v+Ly5BgsC1J0yqKFU5rZMP9+qfk1oi3uWpuB9k5Antk6qz8oavhdzRekE23F8JkVOxfY2IoUtVoFGQQ6NUMhpo9VpfoadKFKTKnreTeWIl6GXGlt1TSNDErZnTA66A6iyS6lpeWMy2vm1NXo3u6rYiDnZYmXMHLG5zULg8j4VM+JZRBtLJD5+zxA+k6DVKm7SFu7SvsCp85mDgZoegFhYbwz8t+ygERmLiyhnpLkNTf9QmBYAAAAAElFTkSuQmCC)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputCreditCardNumberComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-credit-card-number',
                template: `
    <div class="field-set">
      <label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
        <div class="box-flag">
          <input type="text" mafCreditCardNumberMask
            name="cardNumber" autocomplete="cc-number"
            [(ngModel)]="creditCardNumber"
            [ngModelOptions]="{standalone: true}"
            [ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
            [placeholder]="placeHolder"
            [title]="title"
            [disabled]="disabled"
            (keydown)="onKeyDown($event)"
            (keyup)="onKeyUp($event)"
            (focus)="onFocus($event)"
            (change)="onChange($event)"
            (blur)="onBlur($event)"
            (paste)="onPaste($event)"
          >
          <div *ngIf="creditCardFlag !== ''" [ngClass]="['flag', creditCardFlag]"></div>
        </div>
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
        <span class="help-block"><ng-content></ng-content></span>
      </label>
    </div>
  `,
                styleUrls: ['../../maf-input.css', './maf-input-credit-card-number.component.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, { flag: [{
            type: Output
        }] }); })();

// tslint:disable: deprecation
function MafInputCreditCardNameComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r72 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r72.valid == null ? null : ctx_r72.valid.message, ɵɵsanitizeHtml);
} }
const _c0$a = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c1$7 = function () { return { standalone: true }; };
const _c2$4 = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
const _c3$4 = ["*"];
class MafInputCreditCardNameComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
    }
    ngOnInit() {
        this.creditCardName = this.value;
    }
    /**
     * controle de caracteres apenas numericos
     */
    onKeyDown(event) {
        return event.target.value.length <= 600;
    }
    onKeyUp(event) {
        this.status.value = this.status.NONE;
        this._changed = true;
        this.valid.valid = true;
    }
    checkValid() {
        this.valid = { valid: true, message: '' };
        this.value = this.creditCardName;
        super.checkValid();
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onChange(event) {
        super.onChange(event);
    }
    onPaste(event) {
        this.creditCardName = event.clipboardData.getData('text');
        this.checkValid();
    }
}
MafInputCreditCardNameComponent.ɵfac = function MafInputCreditCardNameComponent_Factory(t) { return new (t || MafInputCreditCardNameComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputCreditCardNameComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputCreditCardNameComponent, selectors: [["maf-input-credit-card-name"]], features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c3$4, decls: 7, vars: 18, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], ["type", "text", "name", "ccnNme", "autocomplete", "cc-name", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "keydown", "keyup", "focus", "change", "blur", "paste"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["id", "error", 3, "innerHTML"]], template: function MafInputCreditCardNameComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("ngModelChange", function MafInputCreditCardNameComponent_Template_input_ngModelChange_3_listener($event) { return ctx.creditCardName = $event; })("keydown", function MafInputCreditCardNameComponent_Template_input_keydown_3_listener($event) { return ctx.onKeyDown($event); })("keyup", function MafInputCreditCardNameComponent_Template_input_keyup_3_listener($event) { return ctx.onKeyUp($event); })("focus", function MafInputCreditCardNameComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); })("change", function MafInputCreditCardNameComponent_Template_input_change_3_listener($event) { return ctx.onChange($event); })("blur", function MafInputCreditCardNameComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); })("paste", function MafInputCreditCardNameComponent_Template_input_paste_3_listener($event) { return ctx.onPaste($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, MafInputCreditCardNameComponent_div_4_Template, 1, 2, "div", 4);
        ɵɵelementStart(5, "span", 5);
        ɵɵprojection(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0$a, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.creditCardName)("ngModelOptions", ɵɵpureFunction0(12, _c1$7))("ngClass", ɵɵpureFunction4(13, _c2$4, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, DefaultValueAccessor, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputCreditCardNameComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-credit-card-name',
                template: `
    <div class="field-set">
      <label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
        <input type="text"
          name="ccnNme" autocomplete="cc-name"
          [(ngModel)]="creditCardName"
          [ngModelOptions]="{standalone: true}"
          [ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
          [placeholder]="placeHolder"
          [title]="title"
          [disabled]="disabled"
          (keydown)="onKeyDown($event)"
          (keyup)="onKeyUp($event)"
          (focus)="onFocus($event)"
          (change)="onChange($event)"
          (blur)="onBlur($event)"
          (paste)="onPaste($event)"
        >
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
        <span class="help-block"><ng-content></ng-content></span>
      </label>
    </div>
  `,
                styleUrls: ['../../maf-input.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, null); })();

// tslint:disable: deprecation
function MafInputCreditCardExpirationComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r73 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r73.valid == null ? null : ctx_r73.valid.message, ɵɵsanitizeHtml);
} }
const _c0$b = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c1$8 = function () { return { standalone: true }; };
const _c2$5 = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
const _c3$5 = ["*"];
class MafInputCreditCardExpirationComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
    }
    ngOnInit() {
        this.creditCardExpiration = CreditCard.dateMask(this.value);
    }
    /**
     * controle de caracteres apenas numericos
     */
    onKeyDown(event) {
        const tecla = event.keyCode;
        if (this.isNumberKeys(event)) {
            const element = event.target;
            return Parser.trimToDigits(element.value).length <= 4 || element.selectionStart !== element.selectionEnd;
        }
        else {
            return tecla === 0 || tecla === 9 || this.isDeleteKeys(event) || this.isNavigationKeys(event) || this.isCutKeys(event) || this.isPasteKeys(event) || this.isCopyKeys(event);
        }
    }
    onKeyUp(event) {
        if (event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16
            && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38
            && event.keyCode !== 39 && event.keyCode !== 40) {
            this.status.value = this.status.NONE;
            this._changed = true;
            this.valid.valid = true;
            this.checkValid();
        }
    }
    checkValid() {
        if (this.creditCardExpiration) {
            const digitsDate = Parser.trimToDigits(this.creditCardExpiration);
            if (digitsDate.length === 1 && Parser.strToInt(digitsDate) > 1) {
                this.valid = { valid: false, message: 'Mês inválido' };
                this.value = '';
                return;
            }
            if (digitsDate.length === 2 && (Parser.strToInt(digitsDate) < 1 || Parser.strToInt(digitsDate) > 12)) {
                this.valid = { valid: false, message: 'Mês inválido' };
                this.value = '';
                return;
            }
            if (digitsDate.length >= 4) {
                if (CreditCard.isDateValidate(Parser.strToInt(digitsDate.substring(0, 2)), Parser.strToInt(digitsDate.substring(2, 4)))) {
                    this.valid = { valid: true, message: '' };
                    this.value = digitsDate.substring(0, 2) + '/' + digitsDate.substring(2, 4);
                }
                else {
                    this.valid = { valid: false, message: 'Data inválida' };
                    this.value = '';
                    return;
                }
            }
        }
        else {
            this.valid = { valid: true, message: '' };
            this.value = '';
        }
        super.checkValid();
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onChange(event) {
        super.onChange(event);
    }
    onPaste(event) {
        this.creditCardExpiration = CreditCard.dateMask(event.clipboardData.getData('text'));
        this.checkValid();
    }
}
MafInputCreditCardExpirationComponent.ɵfac = function MafInputCreditCardExpirationComponent_Factory(t) { return new (t || MafInputCreditCardExpirationComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputCreditCardExpirationComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputCreditCardExpirationComponent, selectors: [["maf-input-credit-card-expiration"]], features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c3$5, decls: 7, vars: 18, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], ["type", "text", "mafCreditCardExpirationMask", "", "name", "ccExp", "autocomplete", "cc-exp", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "keydown", "keyup", "focus", "change", "blur", "paste"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["id", "error", 3, "innerHTML"]], template: function MafInputCreditCardExpirationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("ngModelChange", function MafInputCreditCardExpirationComponent_Template_input_ngModelChange_3_listener($event) { return ctx.creditCardExpiration = $event; })("keydown", function MafInputCreditCardExpirationComponent_Template_input_keydown_3_listener($event) { return ctx.onKeyDown($event); })("keyup", function MafInputCreditCardExpirationComponent_Template_input_keyup_3_listener($event) { return ctx.onKeyUp($event); })("focus", function MafInputCreditCardExpirationComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); })("change", function MafInputCreditCardExpirationComponent_Template_input_change_3_listener($event) { return ctx.onChange($event); })("blur", function MafInputCreditCardExpirationComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); })("paste", function MafInputCreditCardExpirationComponent_Template_input_paste_3_listener($event) { return ctx.onPaste($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, MafInputCreditCardExpirationComponent_div_4_Template, 1, 2, "div", 4);
        ɵɵelementStart(5, "span", 5);
        ɵɵprojection(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0$b, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.creditCardExpiration)("ngModelOptions", ɵɵpureFunction0(12, _c1$8))("ngClass", ɵɵpureFunction4(13, _c2$5, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, DefaultValueAccessor, CreditCardExpirationMaskDirective, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputCreditCardExpirationComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-credit-card-expiration',
                template: `
    <div class="field-set">
      <label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
        <input type="text" mafCreditCardExpirationMask
          name="ccExp" autocomplete="cc-exp"
          [(ngModel)]="creditCardExpiration"
          [ngModelOptions]="{standalone: true}"
          [ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
          [placeholder]="placeHolder"
          [title]="title"
          [disabled]="disabled"
          (keydown)="onKeyDown($event)"
          (keyup)="onKeyUp($event)"
          (focus)="onFocus($event)"
          (change)="onChange($event)"
          (blur)="onBlur($event)"
          (paste)="onPaste($event)"
        >
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
        <span class="help-block"><ng-content></ng-content></span>
      </label>
    </div>
  `,
                styleUrls: ['../../maf-input.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, null); })();

// tslint:disable: deprecation
function MafInputCreditCardCvvComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r74 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r74.valid == null ? null : ctx_r74.valid.message, ɵɵsanitizeHtml);
} }
const _c0$c = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c1$9 = function () { return { standalone: true }; };
const _c2$6 = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
const _c3$6 = ["*"];
class MafInputCreditCardCvvComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
        this.ccFlag = '';
    }
    get flag() { return this.ccFlag; }
    set flag(flag) {
        this.ccFlag = flag ? flag : '';
        this.creditCardCvv = this.creditCardCvv ? this.creditCardCvv.substring(0, this.maxLengthCvv) : '';
        this.value = this.value ? this.value.substring(0, this.maxLengthCvv) : '';
    }
    get maxLengthCvv() { return CreditCard.lenghtCvv(this.flag); }
    ngOnInit() {
        this.creditCardCvv = Parser.trimToDigits(this.value);
    }
    /**
     * controle de caracteres apenas numericos
     */
    onKeyDown(event) {
        const tecla = event.keyCode;
        if (this.isNumberKeys(event)) {
            const element = event.target;
            return Parser.trimToDigits(element.value).length < this.maxLengthCvv || element.selectionStart !== element.selectionEnd;
        }
        else {
            return tecla === 0 || tecla === 9 || this.isDeleteKeys(event) || this.isNavigationKeys(event) || this.isCutKeys(event) || this.isPasteKeys(event) || this.isCopyKeys(event);
        }
    }
    onKeyUp(event) {
        if (event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16
            && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38
            && event.keyCode !== 39 && event.keyCode !== 40) {
            this.status.value = this.status.NONE;
            this._changed = true;
            this.valid.valid = true;
        }
    }
    checkValid() {
        this.valid = { valid: true, message: '' };
        this.value = this.creditCardCvv;
        super.checkValid();
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onChange(event) {
        super.onChange(event);
    }
    onPaste(event) {
        this.creditCardCvv = Parser.trimToDigits(event.clipboardData.getData('text'));
        this.checkValid();
    }
}
MafInputCreditCardCvvComponent.ɵfac = function MafInputCreditCardCvvComponent_Factory(t) { return new (t || MafInputCreditCardCvvComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputCreditCardCvvComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputCreditCardCvvComponent, selectors: [["maf-input-credit-card-cvv"]], inputs: { flag: "flag" }, features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c3$6, decls: 7, vars: 18, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], ["type", "text", "name", "cvv", "autocomplete", "cc-csc", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "keydown", "keyup", "focus", "change", "blur", "paste"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["id", "error", 3, "innerHTML"]], template: function MafInputCreditCardCvvComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("ngModelChange", function MafInputCreditCardCvvComponent_Template_input_ngModelChange_3_listener($event) { return ctx.creditCardCvv = $event; })("keydown", function MafInputCreditCardCvvComponent_Template_input_keydown_3_listener($event) { return ctx.onKeyDown($event); })("keyup", function MafInputCreditCardCvvComponent_Template_input_keyup_3_listener($event) { return ctx.onKeyUp($event); })("focus", function MafInputCreditCardCvvComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); })("change", function MafInputCreditCardCvvComponent_Template_input_change_3_listener($event) { return ctx.onChange($event); })("blur", function MafInputCreditCardCvvComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); })("paste", function MafInputCreditCardCvvComponent_Template_input_paste_3_listener($event) { return ctx.onPaste($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, MafInputCreditCardCvvComponent_div_4_Template, 1, 2, "div", 4);
        ɵɵelementStart(5, "span", 5);
        ɵɵprojection(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0$c, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.creditCardCvv)("ngModelOptions", ɵɵpureFunction0(12, _c1$9))("ngClass", ɵɵpureFunction4(13, _c2$6, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, DefaultValueAccessor, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputCreditCardCvvComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-credit-card-cvv',
                template: `
    <div class="field-set">
      <label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
        <input type="text"
          name="cvv" autocomplete="cc-csc"
          [(ngModel)]="creditCardCvv"
          [ngModelOptions]="{standalone: true}"
          [ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
          [placeholder]="placeHolder"
          [title]="title"
          [disabled]="disabled"
          (keydown)="onKeyDown($event)"
          (keyup)="onKeyUp($event)"
          (focus)="onFocus($event)"
          (change)="onChange($event)"
          (blur)="onBlur($event)"
          (paste)="onPaste($event)"
        >
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
        <span class="help-block"><ng-content></ng-content></span>
      </label>
    </div>
  `,
                styleUrls: ['../../maf-input.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, { flag: [{
            type: Input
        }] }); })();

// tslint:disable: deprecation
function MafInputDataComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r75 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r75.valid == null ? null : ctx_r75.valid.message, ɵɵsanitizeHtml);
} }
const _c0$d = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c1$a = function () { return { standalone: true }; };
const _c2$7 = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
const _c3$7 = ["*"];
class MafInputDataComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
        this.nascimento = false;
        this.maximoNascimento = 0;
        this.valueChange.subscribe(() => this.setData(this.value));
    }
    ngOnInit() {
        this.setData(this.value);
    }
    setData(data) {
        this.data = Parser.formataData(data);
    }
    validDiasMes(value) {
        const digitsData = Parser.trimToDigits(value);
        if (digitsData.length >= 1 && Parser.strToInt(digitsData.substring(0, 1)) > 3) { /* não passar de 30 dias */
            return false;
        }
        if (digitsData.length >= 2 && Parser.strToInt(digitsData.substring(0, 1)) === 3 && Parser.strToInt(digitsData.substring(1, 2)) > 1) { /* não passar de 31 dias */
            return false;
        }
        if (digitsData.length >= 3 && Parser.strToInt(digitsData.substring(2, 3)) > 1) { /* não passar de 10 meses */
            return false;
        }
        if (digitsData.length >= 4 && Parser.strToInt(digitsData.substring(2, 3)) === 1 && Parser.strToInt(digitsData.substring(3, 4)) > 2) { /* não passar de 12 meses */
            return false;
        }
        return true;
    }
    /**
     * controle de caracteres apenas numericos
     */
    onKeyDown(event) {
        const tecla = event.keyCode;
        if (this.isNumberKeys(event)) {
            const element = event.target;
            return (Parser.trimToDigits(element.value).length < 8 && this.validDiasMes(element.value)) || element.selectionStart !== element.selectionEnd;
        }
        else {
            return tecla === 0 || tecla === 9 || this.isDeleteKeys(event) || this.isNavigationKeys(event) || this.isCutKeys(event) || this.isPasteKeys(event) || this.isCopyKeys(event);
        }
    }
    onKeyUp(event) {
        if (event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16
            && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38
            && event.keyCode !== 39 && event.keyCode !== 40) {
            this.status.value = this.status.NONE;
            this._changed = true;
            if (event.target.value.length === 0 || Parser.trimToDigits(event.target.value).length === 8) {
                this.checkValid();
            }
            else {
                this.valid.valid = true;
            }
        }
    }
    isValidNascimento() {
        if (this.nascimento) {
            return DateUtil.isDataNascimentoValida(DateUtil.strToDate(this.data), this.maximoNascimento);
        }
        else {
            return true;
        }
    }
    checkValid() {
        if (this.data) {
            let digitsData = Parser.trimToDigits(this.data);
            if (Parser.trimToDigits(this.data).length > 8) {
                digitsData = digitsData.substring(0, 8);
            }
            if (DateUtil.isValid(digitsData) && this.isValidNascimento()) {
                this.valid = { valid: true, message: '' };
                this.value = Parser.formataData(digitsData);
            }
            else {
                this.valid = { valid: false, message: 'Parece ter algo errado com a data' };
            }
        }
        else {
            this.valid = { valid: true, message: '' };
            this.value = '';
        }
        super.checkValid();
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onChange(event) {
        super.onChange(event);
    }
    onInput(event) {
    }
    onPaste(event) {
        this.checkValid();
    }
}
MafInputDataComponent.ɵfac = function MafInputDataComponent_Factory(t) { return new (t || MafInputDataComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputDataComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputDataComponent, selectors: [["maf-input-data"]], inputs: { nascimento: "nascimento", maximoNascimento: "maximoNascimento" }, features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c3$7, decls: 7, vars: 18, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], ["type", "text", "mafDataMask", "", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "keydown", "keyup", "focus", "change", "blur", "input", "paste"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["id", "error", 3, "innerHTML"]], template: function MafInputDataComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("ngModelChange", function MafInputDataComponent_Template_input_ngModelChange_3_listener($event) { return ctx.data = $event; })("keydown", function MafInputDataComponent_Template_input_keydown_3_listener($event) { return ctx.onKeyDown($event); })("keyup", function MafInputDataComponent_Template_input_keyup_3_listener($event) { return ctx.onKeyUp($event); })("focus", function MafInputDataComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); })("change", function MafInputDataComponent_Template_input_change_3_listener($event) { return ctx.onChange($event); })("blur", function MafInputDataComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); })("input", function MafInputDataComponent_Template_input_input_3_listener($event) { return ctx.onInput($event); })("paste", function MafInputDataComponent_Template_input_paste_3_listener($event) { return ctx.onPaste($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, MafInputDataComponent_div_4_Template, 1, 2, "div", 4);
        ɵɵelementStart(5, "span", 5);
        ɵɵprojection(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0$d, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.data)("ngModelOptions", ɵɵpureFunction0(12, _c1$a))("ngClass", ɵɵpureFunction4(13, _c2$7, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, DefaultValueAccessor, DataMaskDirective, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputDataComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-data',
                template: `
    <div class="field-set">
      <label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
        <input type="text" mafDataMask
          [(ngModel)]="data"
          [ngModelOptions]="{standalone: true}"
          [ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
          [placeholder]="placeHolder"
          [title]="title"
					[disabled]="disabled"
          (keydown)="onKeyDown($event)"
          (keyup)="onKeyUp($event)"
          (focus)="onFocus($event)"
          (change)="onChange($event)"
          (blur)="onBlur($event)"
          (input)="onInput($event)"
          (paste)="onPaste($event)"
        >
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
        <span class="help-block"><ng-content></ng-content></span>
      </label>
    </div>
	`,
                styleUrls: ['../maf-input.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, { nascimento: [{
            type: Input
        }], maximoNascimento: [{
            type: Input
        }] }); })();

// tslint:disable: deprecation
function MafInputEmailComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r76 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r76.valid == null ? null : ctx_r76.valid.message, ɵɵsanitizeHtml);
} }
const _c0$e = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c1$b = function () { return { standalone: true }; };
const _c2$8 = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
const _c3$8 = ["*"];
class MafInputEmailComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
    }
    checkValid() {
        if (this.value) {
            this.value = this.value.trim().toLowerCase();
            if (StringUtil.isValidEmail(this.value)) {
                this.valid = { valid: true, message: '' };
            }
            else {
                this.valid = { valid: false, message: 'Parece ter algo errado com o e-mail' };
            }
        }
        else {
            this.valid = { valid: true, message: '' };
            this.value = '';
        }
        super.checkValid();
    }
    onKeyDown(event) {
        const tecla = event.keyCode;
        /* spaceKey:32 */
        if (tecla === 32) {
            return false;
        }
        return true;
    }
    onKeyUp(event) {
        const tecla = event.keyCode;
        if (tecla !== 9 && tecla !== 10 && tecla !== 13 && tecla !== 16 && tecla !== 35 && tecla !== 36 && tecla !== 37 && tecla !== 38 && tecla !== 39 && tecla !== 40) {
            this.status.value = this.status.NONE;
            this._changed = true;
            this.valid.valid = true;
        }
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onChange(event) {
        super.onChange(event);
    }
    onInput(event) {
    }
    onPaste(event) {
        this.checkValid();
    }
}
MafInputEmailComponent.ɵfac = function MafInputEmailComponent_Factory(t) { return new (t || MafInputEmailComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputEmailComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputEmailComponent, selectors: [["maf-input-email"]], features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c3$8, decls: 7, vars: 18, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], ["type", "text", "autocorrect", "off", "autocapitalize", "off", "spellcheck", "false", 2, "text-transform", "lowercase", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "keydown", "keyup", "focus", "change", "blur", "input", "paste"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["id", "error", 3, "innerHTML"]], template: function MafInputEmailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("ngModelChange", function MafInputEmailComponent_Template_input_ngModelChange_3_listener($event) { return ctx.value = $event; })("keydown", function MafInputEmailComponent_Template_input_keydown_3_listener($event) { return ctx.onKeyDown($event); })("keyup", function MafInputEmailComponent_Template_input_keyup_3_listener($event) { return ctx.onKeyUp($event); })("focus", function MafInputEmailComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); })("change", function MafInputEmailComponent_Template_input_change_3_listener($event) { return ctx.onChange($event); })("blur", function MafInputEmailComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); })("input", function MafInputEmailComponent_Template_input_input_3_listener($event) { return ctx.onInput($event); })("paste", function MafInputEmailComponent_Template_input_paste_3_listener($event) { return ctx.onPaste($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, MafInputEmailComponent_div_4_Template, 1, 2, "div", 4);
        ɵɵelementStart(5, "span", 5);
        ɵɵprojection(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0$e, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.value)("ngModelOptions", ɵɵpureFunction0(12, _c1$b))("ngClass", ɵɵpureFunction4(13, _c2$8, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, DefaultValueAccessor, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputEmailComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-email',
                template: `
    <div class="field-set">
      <label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
        <input type="text"
          [(ngModel)]="value"
          [ngModelOptions]="{standalone: true}"
          [ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
          [placeholder]="placeHolder"
          [title]="title"
					[disabled]="disabled"
          (keydown)="onKeyDown($event)"
          (keyup)="onKeyUp($event)"
          (focus)="onFocus($event)"
          (change)="onChange($event)"
          (blur)="onBlur($event)"
          (input)="onInput($event)"
          (paste)="onPaste($event)"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          style="text-transform: lowercase;"
        >
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
        <span class="help-block"><ng-content></ng-content></span>
      </label>
    </div>
	`,
                styleUrls: ['../maf-input.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, null); })();

// tslint:disable: no-angle-bracket-type-assertion
function MafInputFoneComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r77 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r77.valid == null ? null : ctx_r77.valid.message, ɵɵsanitizeHtml);
} }
const _c0$f = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c1$c = function () { return { standalone: true }; };
const _c2$9 = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
const _c3$9 = ["*"];
class MafInputFoneComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
        this.valueChange.subscribe(() => this.setFone(this.value));
    }
    ngOnInit() {
        this.setFone(this.value);
    }
    formataFone(value) {
        let digitsValue = Parser.trimToDigits(value);
        if (Parser.strToInt(digitsValue.substring(0, 1)) === 0) {
            digitsValue = digitsValue.substring(1);
        }
        return Parser.formataFone(digitsValue);
    }
    setFone(fone) {
        this.fone = this.formataFone(fone);
    }
    onKeyDown(event) {
        const tecla = event.keyCode;
        if (this.isNumberKeys(event)) {
            const element = event.target;
            return Parser.trimToDigits(element.value).length < 18 || element.selectionStart !== element.selectionEnd;
        }
        else {
            return tecla === 0 || tecla === 9 || this.isDeleteKeys(event) || this.isNavigationKeys(event) || this.isCutKeys(event) || this.isPasteKeys(event) || this.isCopyKeys(event);
        }
    }
    onKeyUp(event) {
        if (event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16 && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) {
            this.status.value = EStatusControl.NONE;
            this._changed = true;
            if (event.target.value.length === 0 || Parser.trimToDigits(event.target.value).length > 9) {
                this.checkValid();
            }
            else {
                this.valid.valid = true;
            }
        }
    }
    checkValid() {
        if (this.fone) {
            let digitsFone = Parser.trimToDigits(this.fone);
            if (digitsFone.length > 8) {
                digitsFone = digitsFone.substring(0, 11);
            }
            if (Parser.strToInt(digitsFone.substring(0, 1)) !== 0 && (digitsFone.length === 10 || digitsFone.length === 11)) {
                this.valid = { valid: true, message: '' };
                this.value = this.formataFone(digitsFone);
            }
            else {
                this.valid = { valid: false, message: 'Parece ter algo errado com o telefone' };
            }
        }
        else {
            this.valid = { valid: true, message: '' };
            this.value = '';
        }
        super.checkValid();
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onChange(event) {
        super.onChange(event);
    }
    onInput(event) {
    }
    onPaste(event) {
        this.checkValid();
    }
}
MafInputFoneComponent.ɵfac = function MafInputFoneComponent_Factory(t) { return new (t || MafInputFoneComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputFoneComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputFoneComponent, selectors: [["maf-input-fone"]], features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c3$9, decls: 7, vars: 18, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], ["type", "text", "mafFoneMask", "", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "keydown", "keyup", "focus", "change", "blur", "input", "paste"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["id", "error", 3, "innerHTML"]], template: function MafInputFoneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("ngModelChange", function MafInputFoneComponent_Template_input_ngModelChange_3_listener($event) { return ctx.fone = $event; })("keydown", function MafInputFoneComponent_Template_input_keydown_3_listener($event) { return ctx.onKeyDown($event); })("keyup", function MafInputFoneComponent_Template_input_keyup_3_listener($event) { return ctx.onKeyUp($event); })("focus", function MafInputFoneComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); })("change", function MafInputFoneComponent_Template_input_change_3_listener($event) { return ctx.onChange($event); })("blur", function MafInputFoneComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); })("input", function MafInputFoneComponent_Template_input_input_3_listener($event) { return ctx.onInput($event); })("paste", function MafInputFoneComponent_Template_input_paste_3_listener($event) { return ctx.onPaste($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, MafInputFoneComponent_div_4_Template, 1, 2, "div", 4);
        ɵɵelementStart(5, "span", 5);
        ɵɵprojection(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0$f, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.fone)("ngModelOptions", ɵɵpureFunction0(12, _c1$c))("ngClass", ɵɵpureFunction4(13, _c2$9, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, DefaultValueAccessor, FoneMaskDirective, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputFoneComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-fone',
                template: `
    <div class="field-set">
      <label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
        <input type="text" mafFoneMask
          [(ngModel)]="fone"
          [ngModelOptions]="{standalone: true}"
          [ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
          [placeholder]="placeHolder"
          [title]="title"
          [disabled]="disabled"
          (keydown)="onKeyDown($event)"
          (keyup)="onKeyUp($event)"
          (focus)="onFocus($event)"
          (change)="onChange($event)"
          (blur)="onBlur($event)"
          (input)="onInput($event)"
          (paste)="onPaste($event)"
        >
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
        <span class="help-block"><ng-content></ng-content></span>
      </label>
    </div>
  `,
                styleUrls: ['../maf-input.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, null); })();

// tslint:disable: no-angle-bracket-type-assertion
const _c0$g = ["setFocus"];
function MafInputIntComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r83 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 10);
    ɵɵlistener("click", function MafInputIntComponent_button_6_Template_button_click_0_listener() { ɵɵrestoreView(_r83); const ctx_r82 = ɵɵnextContext(); return ctx_r82.onMinusValue(); });
    ɵɵelement(1, "i", 11);
    ɵɵelementEnd();
} }
function MafInputIntComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r85 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 12);
    ɵɵlistener("click", function MafInputIntComponent_button_7_Template_button_click_0_listener() { ɵɵrestoreView(_r85); const ctx_r84 = ɵɵnextContext(); return ctx_r84.onPlusValue(); });
    ɵɵelement(1, "i", 13);
    ɵɵelementEnd();
} }
function MafInputIntComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 14);
} if (rf & 2) {
    const ctx_r81 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r81.valid == null ? null : ctx_r81.valid.message, ɵɵsanitizeHtml);
} }
const _c1$d = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c2$a = function () { return { standalone: true }; };
const _c3$a = function (a1, a2, a3, a4, a5) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4, "buttonsEnable": a5 }; };
const _c4$1 = ["*"];
class MafInputIntComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
        /* Marque TRUE para aceitar somente numeros positivos */
        this.positivos = false;
        /* Marque TRUE para mostra botões de (+) e (-) */
        this.botoes = false;
        /* valor minimo para este campo */
        this.minValue = -2147483648;
        /* valor maximo para este campo */
        this.maxValue = 2147483647;
        /* texto para minimo para este campo */
        this.minValueText = 'Informe um valor maior que ';
        /* texto para maximo para este campo */
        this.maxValueText = 'Informe um valor menor que ';
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onKeyDown(event) {
        const tecla = event.keyCode;
        if (this.isNumberKeys(event)) {
            const element = event.target;
            return Parser.trimToDigits(element.value).length < 11 || element.selectionStart !== element.selectionEnd;
        }
        else {
            return tecla === 0 || tecla === 9 || (!this.positivos && tecla === 189) || this.isDeleteKeys(event) || this.isNavigationKeys(event) || this.isCutKeys(event) || this.isPasteKeys(event) || this.isCopyKeys(event);
        }
    }
    onKeyUp(event) {
        if (event.keyCode === 38 || event.keyCode === 107) { /* seta para cima */
            /*                38_upArrow              107_numpadAdd  */
            this.somaValor();
        }
        else if (event.keyCode === 40 || event.keyCode === 109) { /* seta para baixo */
            /*                       40_downArrow            109_numpadSubtract  */
            this.subtraiValor();
        }
        else if (event.keyCode !== 9 && event.keyCode !== 10 && event.keyCode !== 13 && event.keyCode !== 16 && event.keyCode !== 35 && event.keyCode !== 36 && event.keyCode !== 37 && event.keyCode !== 39) {
            /*                       9_tab                  10_enter                13_enter                16_shift                35_end                  36_home                 37_leftArrow            39_rightArrow  */
            this.status.value = EStatusControl.NONE;
            this.valid.message = '';
            this.valid.valid = true;
        }
        super.onKeyUp(event);
    }
    onChange(event) {
        this.filterValue();
        super.onChange(event);
    }
    filterValue() {
        if (this.value == null) {
            this.value = '';
        }
        if (typeof this.value === 'number') {
            this.value = this.value + '';
        }
        if (typeof this.value === 'string') {
            if (!this.positivos && this.value && this.value.indexOf('-') === 0) {
                this.value = '-' + Parser.trimToDigits(this.value);
            }
            else {
                this.value = Parser.trimToDigits(this.value);
            }
        }
    }
    checkValid() {
        this.filterValue();
        this.status.value = EStatusControl.NONE;
        this.valid.message = '';
        this.valid.valid = true;
        if (Parser.strToInt(this.value) < this.minValue) {
            this.valid.message = this.minValueText + '' + this.minValue;
            this.valid.valid = false;
        }
        if (Parser.strToInt(this.value) > this.maxValue) {
            this.valid.message = this.maxValueText + '' + this.maxValue;
            this.valid.valid = false;
        }
        /* maxlenght, minlenght, required */
        super.checkValid();
    }
    somaValor() {
        this.value = '' + (Math.min(this.maxValue, Math.max(this.minValue, (Parser.strToInt(this.value) || 0) + 1)));
        this.checkValid();
    }
    subtraiValor() {
        this.value = '' + (Math.min(this.maxValue, Math.max(this.minValue, (Parser.strToInt(this.value) || 0) - 1)));
        this.checkValid();
    }
    onPlusValue() {
        this.somaValor();
        if (this.focusElement) {
            this.focusElement.nativeElement.focus();
        }
    }
    onMinusValue() {
        this.subtraiValor();
        if (this.focusElement) {
            this.focusElement.nativeElement.focus();
        }
    }
}
MafInputIntComponent.ɵfac = function MafInputIntComponent_Factory(t) { return new (t || MafInputIntComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputIntComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputIntComponent, selectors: [["maf-input-int"]], viewQuery: function MafInputIntComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$g, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.focusElement = _t.first);
    } }, inputs: { positivos: "positivos", botoes: "botoes", minValue: "minValue", maxValue: "maxValue", minValueText: "minValueText", maxValueText: "maxValueText" }, features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c4$1, decls: 11, vars: 21, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], [1, "maf-input-int-buttons"], ["type", "number", "step", "1", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "focus", "keydown", "keyup", "change", "blur"], ["setFocus", ""], ["type", "button", "class", "int-button minus", "tabindex", "-1", 3, "click", 4, "ngIf"], ["type", "button", "class", "int-button plus", "tabindex", "-1", 3, "click", 4, "ngIf"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["type", "button", "tabindex", "-1", 1, "int-button", "minus", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-minus"], ["type", "button", "tabindex", "-1", 1, "int-button", "plus", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-plus"], ["id", "error", 3, "innerHTML"]], template: function MafInputIntComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "input", 4, 5);
        ɵɵlistener("ngModelChange", function MafInputIntComponent_Template_input_ngModelChange_4_listener($event) { return ctx.value = $event; })("focus", function MafInputIntComponent_Template_input_focus_4_listener($event) { return ctx.onFocus($event); })("keydown", function MafInputIntComponent_Template_input_keydown_4_listener($event) { return ctx.onKeyDown($event); })("keyup", function MafInputIntComponent_Template_input_keyup_4_listener($event) { return ctx.onKeyUp($event); })("change", function MafInputIntComponent_Template_input_change_4_listener($event) { return ctx.onChange($event); })("blur", function MafInputIntComponent_Template_input_blur_4_listener($event) { return ctx.onBlur($event); });
        ɵɵelementEnd();
        ɵɵtemplate(6, MafInputIntComponent_button_6_Template, 2, 0, "button", 6);
        ɵɵtemplate(7, MafInputIntComponent_button_7_Template, 2, 0, "button", 7);
        ɵɵelementEnd();
        ɵɵtemplate(8, MafInputIntComponent_div_8_Template, 1, 2, "div", 8);
        ɵɵelementStart(9, "span", 9);
        ɵɵprojection(10);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(11, _c1$d, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(2);
        ɵɵproperty("ngModel", ctx.value)("ngModelOptions", ɵɵpureFunction0(14, _c2$a))("ngClass", ɵɵpureFunction5(15, _c3$a, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR, ctx.botoes))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.botoes);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.botoes);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, NumberValueAccessor, DefaultValueAccessor, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}", ".maf-input-int-buttons[_ngcontent-%COMP%]{position:relative}.maf-input-int-buttons[_ngcontent-%COMP%]   input.buttonsEnable[_ngcontent-%COMP%]{padding:6px 44px;border-width:1px 0;z-index:2}.maf-input-int-buttons[_ngcontent-%COMP%]   button.int-button[_ngcontent-%COMP%]{position:absolute;top:0;bottom:0;width:34px;border:1px solid #e5e6e7;background-color:#fff;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;z-index:3;outline:0}.maf-input-int-buttons[_ngcontent-%COMP%]   input.buttonsEnable[_ngcontent-%COMP%]:focus ~ button.int-button[_ngcontent-%COMP%]{border-color:#1ab394!important}.maf-input-int-buttons[_ngcontent-%COMP%]   input.error.buttonsEnable[_ngcontent-%COMP%] ~ button.int-button[_ngcontent-%COMP%]{border-color:#cc5965!important}.maf-input-int-buttons[_ngcontent-%COMP%]   button.plus[_ngcontent-%COMP%]{right:0;border-radius:0 4px 4px 0}.maf-input-int-buttons[_ngcontent-%COMP%]   button.minus[_ngcontent-%COMP%]{left:0;border-radius:4px 0 0 4px}.maf-input-int-buttons[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .maf-input-int-buttons[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.maf-input-int-buttons[_ngcontent-%COMP%]   input[type=number][_ngcontent-%COMP%]{-moz-appearance:textfield}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputIntComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-int',
                template: `
    <div class="field-set">
      <label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
      <span [innerHTML]="label"></span>
				<div class="maf-input-int-buttons">
					<input type="number"
						[(ngModel)]="value"
						[ngModelOptions]="{standalone: true}"
						[ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR, 'buttonsEnable': botoes}"
						[placeholder]="placeHolder"
						[title]="title"
						[disabled]="disabled"
						step="1"
						(focus)="onFocus($event)"
						(keydown)="onKeyDown($event)"
						(keyup)="onKeyUp($event)"
						(change)="onChange($event)"
						(blur)="onBlur($event)"
						#setFocus
					>
					<button *ngIf="botoes" (click)="onMinusValue()" type="button" class="int-button minus" tabindex="-1"><i class="fa fa-minus" aria-hidden="true"></i></button>
					<button *ngIf="botoes" (click)="onPlusValue()" type="button" class="int-button plus" tabindex="-1"><i class="fa fa-plus" aria-hidden="true"></i></button>
				</div>
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
        <span class="help-block"><ng-content></ng-content></span>
      </label>
    </div>
  `,
                styleUrls: ['../maf-input.css', './maf-input-int.component.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, { positivos: [{
            type: Input
        }], botoes: [{
            type: Input
        }], minValue: [{
            type: Input
        }], maxValue: [{
            type: Input
        }], minValueText: [{
            type: Input
        }], maxValueText: [{
            type: Input
        }], focusElement: [{
            type: ViewChild,
            args: ['setFocus']
        }] }); })();

// tslint:disable: deprecation
function MafInputSelectComponent_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "option", 6);
} if (rf & 2) {
    const dataOption_r88 = ctx.$implicit;
    ɵɵproperty("value", dataOption_r88.value)("disabled", dataOption_r88.disabled)("selected", dataOption_r88.selected)("innerHTML", dataOption_r88.text, ɵɵsanitizeHtml);
} }
function MafInputSelectComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 7);
} if (rf & 2) {
    const ctx_r87 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r87.valid == null ? null : ctx_r87.valid.message, ɵɵsanitizeHtml);
} }
const _c0$h = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c1$e = function () { return { standalone: true }; };
const _c2$b = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
class MafInputSelectComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
        this.options = [
            { value: '', text: '-- selecione um teste --' },
            { value: '1', text: 'teste 1' },
            { value: '2', text: 'teste 2', selected: true },
            { value: '3', text: 'teste 3', disabled: true },
        ];
    }
    ngOnInit() {
        if ((!this.value || this.value.length === 0) && this.options && this.options.length > 0) {
            const selected = this.options.find(o => o.selected);
            if (selected) {
                this.value = selected.value;
            }
        }
    }
    checkValid() {
        this.valid.valid = true;
        super.checkValid();
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onChange(event) {
        super.onChange(event);
    }
    onInput(event) {
    }
    onPaste(event) {
        this.checkValid();
    }
}
MafInputSelectComponent.ɵfac = function MafInputSelectComponent_Factory(t) { return new (t || MafInputSelectComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputSelectComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputSelectComponent, selectors: [["maf-input-select"]], inputs: { options: "options" }, features: [ɵɵInheritDefinitionFeature], decls: 6, vars: 18, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], [3, "ngModel", "ngModelOptions", "ngClass", "title", "disabled", "ngModelChange", "keyup", "focus", "change", "blur"], [3, "value", "disabled", "selected", "innerHTML", 4, "ngFor", "ngForOf"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [3, "value", "disabled", "selected", "innerHTML"], ["id", "error", 3, "innerHTML"]], template: function MafInputSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "select", 3);
        ɵɵlistener("ngModelChange", function MafInputSelectComponent_Template_select_ngModelChange_3_listener($event) { return ctx.value = $event; })("keyup", function MafInputSelectComponent_Template_select_keyup_3_listener($event) { return ctx.onKeyUp($event); })("focus", function MafInputSelectComponent_Template_select_focus_3_listener($event) { return ctx.onFocus($event); })("change", function MafInputSelectComponent_Template_select_change_3_listener($event) { return ctx.onChange($event); })("blur", function MafInputSelectComponent_Template_select_blur_3_listener($event) { return ctx.onBlur($event); });
        ɵɵtemplate(4, MafInputSelectComponent_option_4_Template, 1, 4, "option", 4);
        ɵɵelementEnd();
        ɵɵtemplate(5, MafInputSelectComponent_div_5_Template, 1, 2, "div", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0$h, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.value)("ngModelOptions", ɵɵpureFunction0(12, _c1$e))("ngClass", ɵɵpureFunction4(13, _c2$b, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.options);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, SelectControlValueAccessor, NgControlStatus, NgModel, NgForOf, NgIf, NgSelectOption, ɵangular_packages_forms_forms_x], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputSelectComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-select',
                template: `
    <div class="field-set">
      <label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
        <select
          [(ngModel)]="value"
          [ngModelOptions]="{standalone: true}"
          [ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
          [title]="title"
					[disabled]="disabled"
          (keyup)="onKeyUp($event)"
          (focus)="onFocus($event)"
          (change)="onChange($event)"
          (blur)="onBlur($event)"
        >
          <option *ngFor="let dataOption of options" [value]="dataOption.value" [disabled]="dataOption.disabled" [selected]="dataOption.selected" [innerHTML]="dataOption.text"></option>
        </select>
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
      </label>
    </div>
	`,
                styleUrls: ['../maf-input.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, { options: [{
            type: Input
        }] }); })();

// tslint:disable: no-angle-bracket-type-assertion
function MafInputTextComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r89 = ɵɵnextContext();
    ɵɵproperty("@InOut", "in")("innerHTML", ctx_r89.valid == null ? null : ctx_r89.valid.message, ɵɵsanitizeHtml);
} }
const _c0$i = function (a0, a1) { return { "focus": a0, "error": a1 }; };
const _c1$f = function () { return { standalone: true }; };
const _c2$c = function (a1, a2, a3, a4) { return { "form-control": true, "error": a1, "loading": a2, "success": a3, "sterror": a4 }; };
const _c3$b = ["*"];
class MafInputTextComponent extends MafFormControlComponent {
    constructor(elRef, formService) {
        super(elRef, formService);
    }
    onFocus(event) {
        super.onFocus(event);
    }
    onBlur(event) {
        super.onBlur(event);
    }
    onKeyUp(event) {
        super.onKeyUp(event);
    }
    onChange(event) {
        super.onChange(event);
    }
    checkValid() {
        this.valid.valid = true; /* true forever */
        /* maxlenght, minlenght, required */
        super.checkValid();
    }
}
MafInputTextComponent.ɵfac = function MafInputTextComponent_Factory(t) { return new (t || MafInputTextComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(MafFormControlService, 8)); };
MafInputTextComponent.ɵcmp = ɵɵdefineComponent({ type: MafInputTextComponent, selectors: [["maf-input-text"]], features: [ɵɵInheritDefinitionFeature], ngContentSelectors: _c3$b, decls: 7, vars: 18, consts: [[1, "field-set"], [3, "ngClass"], [3, "innerHTML"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelOptions", "ngClass", "placeholder", "title", "disabled", "ngModelChange", "focus", "keyup", "change", "blur"], ["id", "error", 3, "innerHTML", 4, "ngIf"], [1, "help-block"], ["id", "error", 3, "innerHTML"]], template: function MafInputTextComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵelement(2, "span", 2);
        ɵɵelementStart(3, "input", 3);
        ɵɵlistener("ngModelChange", function MafInputTextComponent_Template_input_ngModelChange_3_listener($event) { return ctx.value = $event; })("focus", function MafInputTextComponent_Template_input_focus_3_listener($event) { return ctx.onFocus($event); })("keyup", function MafInputTextComponent_Template_input_keyup_3_listener($event) { return ctx.onKeyUp($event); })("change", function MafInputTextComponent_Template_input_change_3_listener($event) { return ctx.onChange($event); })("blur", function MafInputTextComponent_Template_input_blur_3_listener($event) { return ctx.onBlur($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, MafInputTextComponent_div_4_Template, 1, 2, "div", 4);
        ɵɵelementStart(5, "span", 5);
        ɵɵprojection(6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ɵɵpureFunction2(9, _c0$i, ctx.focused, !ctx.valid.valid));
        ɵɵadvance(1);
        ɵɵproperty("innerHTML", ctx.label, ɵɵsanitizeHtml);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.value)("ngModelOptions", ɵɵpureFunction0(12, _c1$f))("ngClass", ɵɵpureFunction4(13, _c2$c, !ctx.valid.valid, ctx.status.value === ctx.status.LOADING, ctx.status.value === ctx.status.SUCCESS, ctx.status.value === ctx.status.ERROR))("placeholder", ctx.placeHolder)("title", ctx.title)("disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.valid.valid);
    } }, directives: [NgClass, DefaultValueAccessor, NgControlStatus, NgModel, NgIf], styles: [".field-set[_ngcontent-%COMP%]{margin-bottom:8px}.form-control[_ngcontent-%COMP%]{display:block;background-color:#fff;background-image:none;border:1px solid #aaa;color:#444;padding:6px 10px;transition:border-color .2s ease-in-out,box-shadow .2s ease-in-out;width:100%;font-size:14px;font-weight:400;border-radius:4px;box-shadow:inset 1px 1px 1px rgba(0,0,0,.045);z-index:2;position:relative}select.form-control[_ngcontent-%COMP%]{padding:6px 22px 6px 12px;-webkit-appearance:none;-moz-appearance:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH1goTDBgnLqRhFAAAAB10RVh0Q29tbWVudABDcmVhdGVkIHdpdGggVGhlIEdJTVDvZCVuAAAAsUlEQVQoz6VSQQ7CIBAcGs9WbdNDH2Hizf+fvJn4BWNpgaW0PmA9mNYaoZgAmQMLM5mZIFR7R8raSPlIE7hdL2kCx9M5SUAwc5qD59j/DLf5IUocB/t2MDjyPsh3BQBE7WXMDB9cbwBAxCrIwIwQnNVrIsJZDdGTCsrvi2p5XMYRnwgIb0sdPKSZbKkLdzCBTOsTAZkWzIzVDiaQll/RSMv5ThjV/P1pyqqGUQ3Kqp5nL4V5luVWc29WAAAAAElFTkSuQmCC);background-attachment:scroll;background-repeat:no-repeat;background-position:top 50% right 8px}.form-control[_ngcontent-%COMP%]:focus, .single-line[_ngcontent-%COMP%]:focus{border-color:#1ab394!important;outline:0}.has-success[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#1ab394}.has-warning[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#f8ac59}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%], .has-error[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]{border-color:#ed5565}.form-control.ng-invalid.ng-dirty[_ngcontent-%COMP%]:focus{border-color:#ed5565!important;outline:0}.form-control.error[_ngcontent-%COMP%]{border:1px solid #cc5965}.form-control.error[_ngcontent-%COMP%]:focus{border:1px solid #cc5965!important;outline:0}.has-success[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#1ab394}.has-warning[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#f8ac59}.has-error[_ngcontent-%COMP%]   .control-label[_ngcontent-%COMP%]{color:#ed5565}div#error[_ngcontent-%COMP%]{border:1px solid #cc5965;border-radius:4px;padding:5px 1px 1px 4px;margin-top:-5px;background-color:rgba(255,65,85,.65);text-shadow:0 -1px 0 rgba(0,0,0,.2);text-align:left;color:#fff;font-weight:400;z-index:1;position:relative}label[_ngcontent-%COMP%]{color:#333;transition:color .2s ease-in-out;width:100%;font-weight:400}label.focus[_ngcontent-%COMP%]{color:#555;font-weight:700}label.error[_ngcontent-%COMP%]{color:#cc5965}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;width:100%}.help-block[_ngcontent-%COMP%]{color:#aaa;margin:3px 0;font-weight:400}.form-control.loading[_ngcontent-%COMP%], .form-control.sterror[_ngcontent-%COMP%], .form-control.success[_ngcontent-%COMP%]{padding:6px 26px 6px 10px;background-color:#fff;background-size:16px 16px;background-position:right 5px center;background-repeat:no-repeat}.form-control.loading[_ngcontent-%COMP%]{background-image:url(data:image/gif;base64,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)}.form-control.success[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYxIDY0LjE0MDk0OSwgMjAxMC8xMi8wNy0xMDo1NzowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNS4xIE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpFMzkwQzA4MzRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpFMzkwQzA4NDRBOEMxMUUxODcwNDlFODk1M0ZEQzYyOSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUzOTBDMDgxNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUzOTBDMDgyNEE4QzExRTE4NzA0OUU4OTUzRkRDNjI5Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+akjsCAAAAS9JREFUeNpiDJrmz4AG1IE4DYjtgdgAKnYBiA8C8SwgvomsmAlNcxEQn4fSxkDMDMXGaHIYBrAB8XYg7gViTgbcgBOqZjtUD9yALiD2YCAegNS2wwzQBeIcBtJBPhBrgQxIhvoTH/gOxKDQ7kASA+lJZiLC6SDNPkC8CYj7gPg1sldABigiCTwFYitotIHAFyB2A+J9QCwKxHuhNAxIo0djGRAfh2o6gkTDNOuiqWdmARKPgFgFKjANiO8A8SkgtoWK4dIMAo9ALtiBJMAPxLuA2IwIzSCwmwmaPP9iMcSbgGaQnrkgAy4D8XQ0SZAhW/BoBoEpIL2wQCxG8wohsAMa4PCk/AuIPaEGfSeQJoqhan+Bo0HTWwNZASgK10AlQRlHAik7L4Nm8y3IGgACDABmkz3ImFbZoAAAAABJRU5ErkJggg==)}.form-control.sterror[_ngcontent-%COMP%]{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAABcRgAAXEYBFJRDQQAAAAd0SU1FB9kIDBA0L4+efuAAAAMLSURBVCjPBcHLbhtVAAbg/9xmxhln4tg1aUSURKGAwqZqJcSG0LDksuqGB0AIseBp2PECVXeIBSABK5BKpUhQRU1JKxo3ddxaTsaeGc+cOXe+jwDAxXgMW5UkNLWA1sPg7HvOh/e99+9671JjzFw28lhKeVS28llp7dwQah0I+IvRGeQ8p74qM9I0t6g1d+HdZz6Kt7HWY0JEQLEI4eqy8cXiSaT0T8TaHxXIieVC8qYoiS3mGcriY962X1FnPwrBp6R/DSuDITpZhsJaUueXaXg9uc1btUWd29E8/l4mK0dcNXVkFotbvJh/CdUewpiOdxaUMiTGgBACnV8iP3oA+exfarXeMCL+3G7tter6mxPeVNW1MM8/QT478LLpuLKALnLQYhfxW28jHQzg5pewZ6fwL57CO084Yf1OnHyad7OHvF1W7+BqdojxaNXOXkO9PIOdzxDd/gB6eYgQAoSRyNDCxoB1gHKOiHK2ed5u3+VqWe1gOtnVTx4RezECreboJAICFsQ7hBDAnUIvCiBdCuMIpAmIzJLT4G/ypl726HSSkOenELpGVwDdDgURAEOAVgrQElkUIFIO4wIaE0A4gXVulTdK+8gYmahmNRFAGlN0EwrHPKxuUVUlUJfImEcnobAO4MxDrvZQK6W59OEC3WyW9npDoQoSC4qEA3V5idmjhzDnIwzPnyIKGrGg4AzwlCLvDcNioY6pNOZxla0f6629JaI4BEIAQhBRgpVOB2vDDWT9AXgUgVAGMIYyG+JI8bLx4T5ttB4vePTLdHP3tHhjW9UkCrWlaGkENthAunMDLOujDQxLz/BKrOFPNpQnTfi5Nu43dnDwoZVaL5YOrBHJZiAsI8ZwpS2pjEc9ncCf/g1zNcM5z/AH6S//kuz3V637LlB+wrVSXmkzVtbdz0m8GKfXv1in6c0hMd3k+X8MozM6Mhozt+5ftuRi6sMPpTX3HKX/DPt9TQDg22++hjGGtrJJddvuWSnv6Hp5x2p1wzkb+YApEeKBp/RX4/HYhnAVJx27v7+P/wFgXuAlz/8/ZgAAAABJRU5ErkJggg==)}"], data: { animation: MafInputConst.maf_input_anim_config } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafInputTextComponent, [{
        type: Component,
        args: [{
                selector: 'maf-input-text',
                template: `
    <div class="field-set">
      <label [ngClass]="{'focus': focused, 'error': ! valid.valid}">
        <span [innerHTML]="label"></span>
        <input type="text" class="form-control"
          [(ngModel)]="value"
          [ngModelOptions]="{standalone: true}"
          [ngClass]="{'form-control': true, 'error': ! valid.valid, 'loading': status.value === status.LOADING, 'success': status.value === status.SUCCESS, 'sterror': status.value === status.ERROR}"
          [placeholder]="placeHolder"
          [title]="title"
					[disabled]="disabled"
          (focus)="onFocus($event)"
          (keyup)="onKeyUp($event)"
          (change)="onChange($event)"
          (blur)="onBlur($event)"
        >
        <div *ngIf="! valid.valid" [@InOut]="'in'" id="error" [innerHTML]="valid?.message"></div>
        <span class="help-block"><ng-content></ng-content></span>
      </label>
    </div>
  `,
                styleUrls: ['../maf-input.css'],
                animations: MafInputConst.maf_input_anim_config
            }]
    }], function () { return [{ type: ElementRef }, { type: MafFormControlService, decorators: [{
                type: Optional
            }] }]; }, null); })();

class InputModule {
}
InputModule.ɵmod = ɵɵdefineNgModule({ type: InputModule });
InputModule.ɵinj = ɵɵdefineInjector({ factory: function InputModule_Factory(t) { return new (t || InputModule)(); }, imports: [[
            CommonModule,
            FormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(InputModule, { declarations: [CepMaskDirective,
        CnpjMaskDirective,
        CpfMaskDirective,
        CreditCardNumberMaskDirective,
        CreditCardExpirationMaskDirective,
        DataMaskDirective,
        FoneMaskDirective,
        MafFormComponent,
        MafButtonComponent,
        MafInputCepComponent,
        MafInputCnpjComponent,
        MafInputCpfComponent,
        MafInputCreditCardNumberComponent,
        MafInputCreditCardNameComponent,
        MafInputCreditCardExpirationComponent,
        MafInputCreditCardCvvComponent,
        MafInputDataComponent,
        MafInputEmailComponent,
        MafInputFoneComponent,
        MafInputIntComponent,
        MafInputSelectComponent,
        MafInputTextComponent], imports: [CommonModule,
        FormsModule], exports: [MafFormComponent,
        MafButtonComponent,
        MafInputCepComponent,
        MafInputCnpjComponent,
        MafInputCpfComponent,
        MafInputCreditCardNumberComponent,
        MafInputCreditCardNameComponent,
        MafInputCreditCardExpirationComponent,
        MafInputCreditCardCvvComponent,
        MafInputDataComponent,
        MafInputEmailComponent,
        MafInputFoneComponent,
        MafInputIntComponent,
        MafInputSelectComponent,
        MafInputTextComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(InputModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    CepMaskDirective,
                    CnpjMaskDirective,
                    CpfMaskDirective,
                    CreditCardNumberMaskDirective,
                    CreditCardExpirationMaskDirective,
                    DataMaskDirective,
                    FoneMaskDirective,
                    MafFormComponent,
                    MafButtonComponent,
                    MafInputCepComponent,
                    MafInputCnpjComponent,
                    MafInputCpfComponent,
                    MafInputCreditCardNumberComponent,
                    MafInputCreditCardNameComponent,
                    MafInputCreditCardExpirationComponent,
                    MafInputCreditCardCvvComponent,
                    MafInputDataComponent,
                    MafInputEmailComponent,
                    MafInputFoneComponent,
                    MafInputIntComponent,
                    MafInputSelectComponent,
                    MafInputTextComponent
                ],
                exports: [
                    MafFormComponent,
                    MafButtonComponent,
                    MafInputCepComponent,
                    MafInputCnpjComponent,
                    MafInputCpfComponent,
                    MafInputCreditCardNumberComponent,
                    MafInputCreditCardNameComponent,
                    MafInputCreditCardExpirationComponent,
                    MafInputCreditCardCvvComponent,
                    MafInputDataComponent,
                    MafInputEmailComponent,
                    MafInputFoneComponent,
                    MafInputIntComponent,
                    MafInputSelectComponent,
                    MafInputTextComponent
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();

class MafElementsModule {
}
MafElementsModule.ɵmod = ɵɵdefineNgModule({ type: MafElementsModule });
MafElementsModule.ɵinj = ɵɵdefineInjector({ factory: function MafElementsModule_Factory(t) { return new (t || MafElementsModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            InputModule,
            ImageCropperModule
        ],
        InputModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(MafElementsModule, { declarations: [AlertComponent,
        CapturaImagensComponent,
        EditarImagemComponent,
        MafSpinComponent], imports: [CommonModule,
        FormsModule,
        InputModule,
        ImageCropperModule], exports: [AlertComponent,
        CapturaImagensComponent,
        EditarImagemComponent,
        MafSpinComponent,
        InputModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(MafElementsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    InputModule,
                    ImageCropperModule
                ],
                declarations: [
                    AlertComponent,
                    CapturaImagensComponent,
                    EditarImagemComponent,
                    MafSpinComponent
                ],
                exports: [
                    AlertComponent,
                    CapturaImagensComponent,
                    EditarImagemComponent,
                    MafSpinComponent,
                    InputModule
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();

/*************
 *  ELEMENTS
 */

/*
 * Public API Surface of maf-web
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AjaxService, AlertComponent, ArrayList, BaseService, BrowserInfo, BrowserType, BrowserUtil, CapturaImagensComponent, Cnp, CreditCard, DataBaseManager, DataRelativaPipe, DateToStrPipe, DateUtil, DigitoVerificadorUtil, EStatusControl, EditarImagemComponent, FormatNumberEtiqPipe, InputModule, ListEmpresas, MacleMobileUtil, MafButtonComponent, MafCommonsModule, MafElementsModule, MafFormComponent, MafFormControlComponent, MafInputCepComponent, MafInputCnpjComponent, MafInputConst, MafInputCpfComponent, MafInputCreditCardCvvComponent, MafInputCreditCardExpirationComponent, MafInputCreditCardNameComponent, MafInputCreditCardNumberComponent, MafInputDataComponent, MafInputEmailComponent, MafInputFoneComponent, MafInputIntComponent, MafInputSelectComponent, MafInputTextComponent, MafSpinComponent, Parser, StrToDatePipe, StringUtil, TableInfo, TableManager, VersaoMMT };
//# sourceMappingURL=maf-web.js.map
